import * as n from "react";
import { Component as cr, useState as A, useRef as L, useEffect as Z, useLayoutEffect as qe, isValidElement as on, cloneElement as oa, forwardRef as Vr, useContext as Dn, createContext as An, useMemo as we, useCallback as oe, Fragment as Qr, Children as Yn, createRef as Jr } from "react";
import { a as Zr, t as ir, b as es, f as ts } from "./format-BpCURHRA.js";
import { createPortal as ns } from "react-dom";
const as = "_page_1l6cf_5", rs = "_inner_1l6cf_25", ss = "_pageScroll_1l6cf_38", os = "_innerScroll_1l6cf_39", _n = {
  page: as,
  inner: rs,
  pageScroll: ss,
  innerScroll: os
};
function ls({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  scroll: a = "grid",
  className: r = "",
  style: s,
  children: o
}) {
  const l = a === "page";
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [_n.page, l && _n.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...s }
    },
    /* @__PURE__ */ n.createElement("div", { className: [_n.inner, l && _n.innerScroll].filter(Boolean).join(" "), style: { minWidth: t } }, o)
  );
}
const cs = "_body_1wgsn_4", is = {
  body: cs
};
function Jg({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [is.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const us = "_orbitPortalRoot_177qv_2", ms = {
  orbitPortalRoot: us
};
class Ht extends cr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || ms.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return ns(this.props.children, this.getPortalRoot());
  }
}
const ds = "_anchor_7h2m7_2", fs = "_tip_7h2m7_5", ya = {
  anchor: ds,
  tip: fs
};
let _s = 0;
function Bt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: s,
  describe: o = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = A(!1), [u, f] = A({ top: 0, left: 0 }), y = L(null), _ = L(null), p = L(null), d = L("");
  d.current || (d.current = `axe-tip-${++_s}`);
  const b = () => {
    p.current && (clearTimeout(p.current), p.current = null);
  }, w = (E) => {
    b(), E <= 0 ? m(!0) : p.current = setTimeout(() => m(!0), E);
  }, N = () => {
    b(), m(!1);
  };
  Z(() => b, []), qe(() => {
    if (!i) return;
    const E = () => {
      const h = y.current, g = _.current;
      if (!h || !g) return;
      const x = h.getBoundingClientRect(), C = g.offsetHeight, M = g.offsetWidth;
      let T = a === "top" ? x.top - C - 6 : x.bottom + 6;
      a === "bottom" && T + C > window.innerHeight - 4 && x.top - C - 6 > 4 && (T = x.top - C - 6), a === "top" && T < 4 && x.bottom + 6 + C < window.innerHeight - 4 && (T = x.bottom + 6);
      const I = Math.max(4, Math.min(x.left + x.width / 2 - M / 2, window.innerWidth - M - 4));
      f((q) => q.top === T && q.left === I ? q : { top: T, left: I });
    };
    return E(), window.addEventListener("resize", E), window.addEventListener("scroll", E, !0), () => {
      window.removeEventListener("resize", E), window.removeEventListener("scroll", E, !0);
    };
  }, [i, a, e]), Z(() => {
    if (!i) return;
    const E = (h) => {
      h.key !== "Escape" || h.isComposing || (h.preventDefault(), h.stopPropagation(), N());
    };
    return document.addEventListener("keydown", E, !0), () => document.removeEventListener("keydown", E, !0);
  }, [i]);
  const k = e != null && e !== !1 && e !== "";
  if (!k && !c) return t;
  const $ = k && on(t) ? oa(t, i && o ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: y,
      className: [ya.anchor, l].filter(Boolean).join(" "),
      tabIndex: s ? 0 : void 0,
      onMouseEnter: () => {
        k && w(r);
      },
      onMouseLeave: N,
      onFocus: () => {
        k && w(0);
      },
      onBlur: N
    },
    $,
    k && i && /* @__PURE__ */ n.createElement(Ht, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: _,
        id: d.current,
        role: "tooltip",
        className: ya.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: N
      },
      e
    ))
  );
}
const ps = "_bar_gkpv7_1", ys = "_menu_gkpv7_17", bs = "_title_gkpv7_27", Es = "_info_gkpv7_29", hs = "_badge_gkpv7_37", gs = "_badge_muted_gkpv7_38", vs = "_badge_ok_gkpv7_39", ks = "_badge_warn_gkpv7_40", ws = "_meta_gkpv7_42", Ns = "_actions_gkpv7_26", $s = "_notice_gkpv7_59", xs = "_notice_info_gkpv7_65", Ds = "_notice_ok_gkpv7_66", As = "_notice_err_gkpv7_67", Ge = {
  bar: ps,
  menu: ys,
  title: bs,
  info: Es,
  badge: hs,
  badge_muted: gs,
  badge_ok: vs,
  badge_warn: ks,
  meta: ws,
  actions: Ns,
  notice: $s,
  notice_info: xs,
  notice_ok: Ds,
  notice_err: As
};
function Cs({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: s,
  notice: o,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(Bt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), s && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, s), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, o && o.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = o.tone) != null ? c : "info"}`]].join(" "), role: o.tone === "err" ? "alert" : "status" }, o.text), l));
}
const Ss = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Ms = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Ts({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Ms[e]);
}
function ln({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Ss[e]
  );
}
const qs = "_btn_a0orf_1", Bs = "_sm_a0orf_18", Ls = "_primary_a0orf_21", js = "_dark_a0orf_23", Rs = "_danger_a0orf_25", Is = "_soon_a0orf_29", Os = "_soonTag_a0orf_30", Ps = "_blocked_a0orf_39", Xs = "_kbd_a0orf_51", zs = "_iconBtn_a0orf_54", Fs = "_link_a0orf_70", ct = {
  btn: qs,
  sm: Bs,
  primary: Ls,
  dark: js,
  danger: Rs,
  soon: Is,
  soonTag: Os,
  blocked: Ps,
  kbd: Xs,
  iconBtn: zs,
  link: Fs
}, ut = Vr(function(t, a) {
  const {
    variant: r = "default",
    size: s = "md",
    icon: o,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: m,
    className: u = "",
    type: f = "button",
    onClick: y,
    title: _,
    disabled: p,
    ...d
  } = t, b = c || i || "", w = b !== "", N = "blockedReason" in t, k = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: f,
      className: [ct.btn, ct[r], s === "sm" ? ct.sm : "", c ? ct.soon : w ? ct.blocked : "", u].filter(Boolean).join(" "),
      "aria-disabled": w ? !0 : void 0,
      disabled: w ? void 0 : p,
      title: w ? void 0 : _,
      onClick: w ? ($) => $.preventDefault() : y,
      ...d
    },
    o && /* @__PURE__ */ n.createElement(ln, { name: o, size: s === "sm" ? 12 : 14 }),
    m,
    l && /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: ct.soonTag }, "준비 중")
  );
  return w || N ? /* @__PURE__ */ n.createElement(Bt, { content: b, keepWrapper: N }, k) : k;
});
function Vn({ label: e, children: t, className: a = "", type: r = "button", ...s }) {
  return /* @__PURE__ */ n.createElement(Bt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [ct.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...s
    },
    t
  ));
}
function la({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [ct.link, t].filter(Boolean).join(" "), ...r }, e);
}
const Ws = "_wrap_10shm_1", Hs = "_btn_10shm_2", Ks = "_on_10shm_6", Us = "_caret_10shm_8", Gs = "_pop_10shm_9", Ys = "_sec_10shm_14", Vs = "_item_10shm_17", Qs = "_danger_10shm_24", pt = {
  wrap: Ws,
  btn: Hs,
  on: Ks,
  caret: Us,
  pop: Gs,
  sec: Ys,
  item: Vs,
  danger: Qs
}, Js = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), Zg = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function Zs({ label: e, entries: t, disabled: a, title: r }) {
  const [s, o] = A(!1), l = L(null), c = L(null), i = L(null), m = () => {
    var f, y;
    return Array.from((y = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? y : []);
  };
  Z(() => {
    var f;
    s && ((f = m()[0]) == null || f.focus());
  }, [s]), Z(() => {
    if (!s) return;
    const f = (_) => {
      l.current && !l.current.contains(_.target) && o(!1);
    }, y = (_) => {
      var p;
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), o(!1), (p = c.current) == null || p.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", y, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", y, !0);
    };
  }, [s]);
  const u = (f) => {
    const y = m();
    if (y.length === 0) return;
    const _ = y.indexOf(document.activeElement);
    let p = -1;
    if (f.key === "ArrowDown") p = (_ + 1) % y.length;
    else if (f.key === "ArrowUp") p = (_ <= 0 ? y.length : _) - 1;
    else if (f.key === "Home") p = 0;
    else if (f.key === "End") p = y.length - 1;
    else if (f.key === "Tab") {
      o(!1);
      return;
    } else return;
    f.preventDefault(), y[p].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: pt.wrap, ref: l }, /* @__PURE__ */ n.createElement(Bt, { content: s ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [pt.btn, s ? pt.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": s,
      onClick: () => o((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !s && (f.preventDefault(), o(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: pt.caret, "aria-hidden": "true" }, "▾")
  )), s && /* @__PURE__ */ n.createElement("div", { ref: i, className: pt.pop, role: "menu", onKeyDown: u }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: pt.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [pt.item, f.danger ? pt.danger : ""].join(" "),
      onClick: () => {
        var y;
        o(!1), (y = c.current) == null || y.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
function ev(e, t, a = !0) {
  const r = L(t);
  r.current = t, Z(() => {
    if (!a) return;
    const s = (o) => {
      if (o.key !== "Enter" || !(o.ctrlKey || o.metaKey) || o.isComposing || o.repeat || o.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (o.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [e, a]);
}
function eo() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const to = "_bar_1g564_2", no = "_sticky_1g564_12", ao = "_start_1g564_19", ro = "_end_1g564_20", so = "_status_1g564_22", oo = "_dirty_1g564_23", lo = "_kbd_1g564_25", kt = {
  bar: to,
  sticky: no,
  start: ao,
  end: ro,
  status: so,
  dirty: oo,
  kbd: lo
};
function tv({ start: e, children: t, status: a, dirty: r, inline: s, shortcutHint: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", kt.bar, s ? "" : kt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: kt.start }, e), /* @__PURE__ */ n.createElement("span", { className: kt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [kt.status, r ? kt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, o && /* @__PURE__ */ n.createElement("kbd", { className: kt.kbd }, eo())));
}
const co = "_root_j67qt_2", io = "_closed_j67qt_3", uo = "_tab_j67qt_6", mo = "_collapse_j67qt_7", fo = "_body_j67qt_16", _o = "_card_j67qt_32", po = "_head_j67qt_37", yo = "_cardOpen_j67qt_44", bo = "_headBtn_j67qt_47", Eo = "_icon_j67qt_56", ho = "_badge_j67qt_57", go = "_trailing_j67qt_58", vo = "_chev_j67qt_59", ko = "_panelWrap_j67qt_63", wo = "_panelOpen_j67qt_67", No = "_panelBody_j67qt_68", $o = "_panelInner_j67qt_69", xo = "_panelSettled_j67qt_70", ve = {
  root: co,
  closed: io,
  tab: uo,
  collapse: mo,
  body: fo,
  card: _o,
  head: po,
  cardOpen: yo,
  headBtn: bo,
  icon: Eo,
  badge: ho,
  trailing: go,
  chev: vo,
  panelWrap: ko,
  panelOpen: wo,
  panelBody: No,
  panelInner: $o,
  panelSettled: xo
}, Do = 1280, Ao = 8, ur = "axe-side-bar:";
function Co(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(ur + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function So(e, t) {
  if (e)
    try {
      window.localStorage.setItem(ur + e, t ? "1" : "0");
    } catch {
    }
}
function nv({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = Do,
  storageKey: s,
  className: o = "",
  children: l
}) {
  var y;
  const c = L(Co(s)), [i, m] = A((y = c.current) != null ? y : t), u = L(c.current !== null);
  if (Z(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const _ = window.matchMedia(`(max-width: ${r - 1}px)`), p = () => {
      u.current || m(!_.matches && t);
    };
    return p(), _.addEventListener ? _.addEventListener("change", p) : _.addListener(p), () => {
      _.removeEventListener ? _.removeEventListener("change", p) : _.removeListener(p);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    u.current = !0, So(s, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ve.root, i ? "" : ve.closed, o].filter(Boolean).join(" "),
      style: { width: i ? a : Ao }
    },
    /* @__PURE__ */ n.createElement("div", { className: ve.tab }, /* @__PURE__ */ n.createElement(Bt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ve.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Ts, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ve.body }, l)
  );
}
const mr = An(null);
function av({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, s] = A(t);
  return a ? /* @__PURE__ */ n.createElement(mr.Provider, { value: { openId: r, setOpenId: s } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const dr = "axe-side-panel:";
function Mo(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(dr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function To(e, t) {
  if (e)
    try {
      window.localStorage.setItem(dr + e, t ? "1" : "0");
    } catch {
    }
}
function rv({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: s,
  trailing: o,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var E;
  const u = Dn(mr), f = !!u && c != null, y = L(Mo(l)), [_, p] = A((E = y.current) != null ? E : a), d = f ? u.openId === c : _, [b, w] = A(d), [N, k] = A(d);
  if (!t) return null;
  d && !b && w(!0);
  const $ = () => {
    const h = !d;
    To(l, h), w(!0), k(!1), f ? u.setOpenId(h ? c : null) : p(h);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ve.card, d ? ve.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ve.head, onClick: $ }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ve.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ve.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), s && /* @__PURE__ */ n.createElement("span", { className: ve.badge }, s), o && /* @__PURE__ */ n.createElement("span", { className: ve.trailing, onClick: (h) => h.stopPropagation() }, o), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ve.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ve.panelWrap, d ? ve.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (h) => {
        h.target === h.currentTarget && h.propertyName === "grid-template-rows" && k(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ve.panelBody, d && N ? ve.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ve.panelInner }, m))
  ));
}
const qo = "_guide_qnh7l_1", Bo = "_title_qnh7l_5", Lo = "_desc_qnh7l_6", jo = "_act_qnh7l_7", Ro = "_why_qnh7l_13", Io = "_steps_qnh7l_14", Oo = "_no_qnh7l_20", Po = "_cur_qnh7l_24", Xo = "_link_qnh7l_26", nt = {
  guide: qo,
  title: Bo,
  desc: Lo,
  act: jo,
  why: Ro,
  steps: Io,
  no: Oo,
  cur: Po,
  link: Xo
};
function sv({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: nt.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: nt.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: nt.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: nt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: nt.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: nt.steps }, r.map((s, o) => /* @__PURE__ */ n.createElement("li", { key: s.label, className: s.current ? nt.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: nt.no }, o + 1), s.onClick && !s.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: nt.link, onClick: s.onClick }, s.label) : /* @__PURE__ */ n.createElement("span", null, s.label), s.hint && /* @__PURE__ */ n.createElement("small", null, s.hint)))));
}
const zo = "_list_1w2rs_1", Fo = "_row_1w2rs_2", Wo = "_label_1w2rs_6", Ho = "_value_1w2rs_7", Ko = "_emphasis_1w2rs_8", Uo = "_changed_1w2rs_10", Lt = {
  list: zo,
  row: Fo,
  label: Wo,
  value: Ho,
  emphasis: Ko,
  changed: Uo
};
function ov({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [Lt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [Lt.row, a.emphasis ? Lt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: Lt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [Lt.value, a.changed ? Lt.changed : ""].join(" ") }, a.value))));
}
const Go = "_underline_xl221_2", Yo = "_active_xl221_24", Vo = "_segmented_xl221_33", Rn = {
  underline: Go,
  active: Yo,
  segmented: Vo
};
function fr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: s = "",
  "aria-label": o
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Rn.segmented : Rn.underline, s].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": o
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Rn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Qo = "_bar_1e999_1", Jo = "_actions_1e999_17", Zo = "_field_1e999_24", el = "_fieldLabel_1e999_25", tl = "_readout_1e999_33", nl = "_search_1e999_44", al = "_detail_1e999_58", rl = "_pill_1e999_70", sl = "_hint_1e999_81", it = {
  bar: Qo,
  actions: Jo,
  field: Zo,
  fieldLabel: el,
  readout: tl,
  search: nl,
  detail: al,
  pill: rl,
  hint: sl
}, ol = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function ll(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !ol.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function lv({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: s,
  detailSearch: o = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  trailing: i,
  enterSearch: m = !0
}) {
  const u = (f) => {
    !m || !t || r || !ll(f) || (f.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: it.bar, onKeyDown: u }, e, /* @__PURE__ */ n.createElement("span", { className: it.actions }, i, o && /* @__PURE__ */ n.createElement("button", { type: "button", className: it.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(Bt, { content: s, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: it.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function cl({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: it.field }, /* @__PURE__ */ n.createElement("span", { className: it.fieldLabel }, e), t);
}
function cv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: it.readout }, e);
}
function iv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: it.pill, role: "status" }, e);
}
function uv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: it.hint }, e);
}
function il(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function mv({ rows: e, value: t, onChange: a, disabled: r, label: s = "기수" }) {
  return /* @__PURE__ */ n.createElement(cl, { label: s }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": s,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (o) => a(Number(o.target.value))
    },
    e.map((o) => /* @__PURE__ */ n.createElement("option", { key: o.gisu, value: o.gisu }, il(o)))
  ));
}
class _r {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const s of r) {
            const o = s.borderBoxSize[0];
            this._callback({ width: o.inlineSize, height: o.blockSize }, s);
          }
        } catch (s) {
          console.error(s);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function pr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function yr(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function br(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function ul(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function Er(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function ml(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => Er(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let s = [], o = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(s), s = [], o = [], a.push(c);
      return;
    }
    for (; o.length && o[o.length - 1].level >= l.level; ) o.pop();
    const i = { i: c, kids: [] };
    (o.length ? o[o.length - 1].node.kids : s).push(i), o.push({ level: l.level, node: i });
  }), r(s), a;
}
function dl(e, t) {
  const a = new Set(t), r = e.filter((o) => a.has(o)), s = new Set(r);
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    if (s.has(l)) continue;
    const c = o + 1 < t.length ? r.indexOf(t[o + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), s.add(l);
  }
  return r;
}
function fl(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), s = [], o = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = s.length;
    for (; m < u; ) {
      const f = m + u >> 1;
      r[s[f]] < c ? m = f + 1 : u = f;
    }
    m > 0 && (o[i] = s[m - 1]), s[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = s.length ? s[s.length - 1] : -1; c >= 0; c = o[c]) l.add(e[c]);
  return l;
}
const _l = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', pl = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function yl(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((o, l) => {
      o <= 1 ? a.delete(l) : a.set(l, o - 1);
    });
    let s = 0;
    for (const o of Array.from(r.cells)) {
      for (; a.has(s); ) s += 1;
      const l = o.colSpan || 1;
      if (t.set(o, s), o.rowSpan > 1) for (let c = s; c < s + l; c += 1) a.set(c, o.rowSpan);
      s += l;
    }
  }
  return t;
}
function bl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = yl(Array.from(t.rows)), r = [];
  return a.forEach((s, o) => {
    var c, i;
    if (o.tagName !== "TH" || (o.colSpan || 1) !== 1 || o.dataset.sortable === "false" || o.hasAttribute("aria-sort") && o.dataset.axeSort === void 0 || o.querySelector(_l)) return;
    const l = ((c = o.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: o, col: s, key: (i = o.dataset.sortKey) != null ? i : String(s), label: l });
  }), r;
}
function ba(e, t) {
  var r;
  let a = 0;
  for (const s of Array.from(e.cells)) {
    const o = s.colSpan || 1;
    if (t < a + o) {
      const l = s.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = s.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return ul(c ? c.value : (r = s.textContent) != null ? r : "");
    }
    a += o;
  }
  return null;
}
function El(e) {
  if (e.matches(pl) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function hl() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function gl(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((s) => Array.from(s.cells).some((o) => o.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const hr = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function vl(e, t, a) {
  if (hr(t, a)) return;
  const r = fl(t, a);
  let s = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    r.has(l) || e.insertBefore(l, s), s = l;
  }
}
function kl(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? ba(c.rows[0], a) : null }));
    return l.sort((c, i) => Er(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const s = e, o = s.map((l) => {
    const c = El(l);
    return { level: c, value: c === null ? null : ba(l, a) };
  });
  return ml(o, r).map((l) => s[l]);
}
function wl(e, t, a) {
  const r = gl(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const s = r.items, o = t ? `${t.col}:${t.dir}` : "";
  if (o === a.sig && hr(s, a.shown)) return;
  a.base = a.sig ? dl(a.base, s) : s;
  let l = t ? kl(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && o === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  vl(r.parent, l, s), a.shown = l, a.sig = o;
}
const Nl = "input, select, textarea, button";
function $l(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const s = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), o = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    s !== "" && !r.querySelector(Nl) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: s, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || o) && (r.getAttribute("title") !== s && r.setAttribute("title", s), r.dataset.axeTitle !== s && (r.dataset.axeTitle = s))) : o && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const gr = An(null), xl = "_card_1j6er_2", Dl = "_grow_1j6er_24", Al = "_head_1j6er_26", Cl = "_title_1j6er_35", Sl = "_trailing_1j6er_36", Ml = "_scroll_1j6er_6", Tl = "_foot_1j6er_54", ql = "_strip_1j6er_56", Bl = "_pager_1j6er_58", Ll = "_spacer_1j6er_60", jl = "_table_1j6er_62", Rl = "_fixed_1j6er_63", Il = "_fz_1j6er_81", Ol = "_fzEdge_1j6er_93", Pl = "_frozen_1j6er_100", Xl = "_sr_1j6er_162", zl = "_statusCell_1j6er_43", Fl = "_status_1j6er_43", Wl = "_st_error_1j6er_244", Hl = "_stIcon_1j6er_245", Kl = "_spin_1j6er_251", Ul = "_axeSpin_1j6er_1", Gl = "_busy_1j6er_261", Yl = "_statusRow_1j6er_263", Vl = "_busyBar_1j6er_264", Ql = "_axeBusy_1j6er_1", ue = {
  card: xl,
  grow: Dl,
  head: Al,
  title: Cl,
  trailing: Sl,
  scroll: Ml,
  foot: Tl,
  strip: ql,
  pager: Bl,
  spacer: Ll,
  table: jl,
  fixed: Rl,
  fz: Il,
  fzEdge: Ol,
  frozen: Pl,
  sr: Xl,
  statusCell: zl,
  status: Fl,
  st_error: Wl,
  stIcon: Hl,
  spin: Kl,
  axeSpin: Ul,
  busy: Gl,
  statusRow: Yl,
  busyBar: Vl,
  axeBusy: Ql
}, Jl = 120;
function Zl(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Jl : void 0;
}
function Ea({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const zt = /* @__PURE__ */ new Set();
function ca() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function ec(e) {
  if (!ca() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var s;
    return (s = r.textContent) == null ? void 0 : s.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  zt.has(a) || (zt.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function tc(e) {
  if (!ca()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, o;
    r.scrollWidth > r.clientWidth + 1 && t.push((o = (s = r.textContent) == null ? void 0 : s.trim()) != null ? o : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  zt.has(a) || (zt.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function nc(e) {
  if (!ca() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (zt.has(t)) return;
  zt.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function ha(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const s of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let o = 0;
    for (const l of Array.from(s.cells)) {
      for (; r.has(o); ) o += 1;
      const c = l.colSpan || 1, i = t > 0 && o + c <= t;
      if (l.classList.toggle(ue.fz, i), l.classList.toggle(ue.fzEdge, i && o + c === t), l.style.left = i ? `${a[o]}px` : "", l.rowSpan > 1) for (let m = o; m < o + c; m += 1) r.set(m, l.rowSpan);
      o += c;
    }
  }
}
function ac({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: s,
  grow: o,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: f = !0,
  sort: y,
  onSort: _,
  manualSort: p,
  className: d = "",
  children: b
}) {
  const w = l || e !== void 0 && e.length > 0, N = w ? Zl(e) : void 0, { stick: k, offsets: $ } = we(() => {
    const R = Math.max(Math.trunc(c), 0), F = [];
    if (R === 0 || !e) return { stick: 0, offsets: F };
    let Y = 0, z = 0;
    for (let H = 0; H < R; H += 1) {
      const ce = e[H];
      if (typeof ce != "number") break;
      F.push(Y), Y += ce, z += 1;
    }
    return { stick: z, offsets: F };
  }, [e, c]), E = [ue.table, w ? ue.fixed : "", k > 0 ? ue.frozen : ""].filter(Boolean).join(" "), h = L(null), g = L(null), x = L(null), C = L(null), M = L(0), T = L(0), I = we(() => ({
    scrollRef: h,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (T.current += 1, () => {
      T.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [q, X] = A(null), G = y !== void 0 ? y : q, [K, j] = A(""), ne = L(hl()), ae = () => {
    const R = h.current, F = x.current, Y = C.current;
    if (!R || !F || !Y) return;
    const z = R.scrollWidth;
    Y.style.width = z + "px", F.style.display = z > R.clientWidth + 1 ? "" : "none";
    const H = R.offsetWidth - R.clientWidth;
    F.style.paddingRight = H + "px", g.current && (g.current.style.paddingRight = H + "px"), tc(R), nc($l(R.querySelector("table")));
  };
  Z(() => {
    const R = h.current;
    if (!R) return;
    const F = new _r(R, ae);
    return ec(R.querySelector("table")), () => F.detach();
  }, []), qe(() => {
    var R, F, Y, z, H;
    (k > 0 || M.current > 0) && (ha((F = (R = h.current) == null ? void 0 : R.querySelector("table")) != null ? F : null, k, $), ha((z = (Y = g.current) == null ? void 0 : Y.querySelector("table")) != null ? z : null, k, $)), M.current = k, (H = h.current) == null || H.querySelectorAll("thead th:not([scope])").forEach((ce) => ce.setAttribute("scope", "col")), v(), ae();
  });
  function v() {
    var z;
    const R = (z = h.current) == null ? void 0 : z.querySelector("table");
    if (!R) return;
    const F = f ? bl(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((H) => {
      F.some((ce) => ce.th === H) || (H.removeAttribute("data-axe-sort"), H.removeAttribute("aria-sort"), H.removeAttribute("tabindex"));
    }), F.forEach(({ th: H, key: ce }) => {
      H.dataset.axeSort !== ce && (H.dataset.axeSort = ce);
      const Pe = yr(G, ce);
      H.getAttribute("aria-sort") !== Pe && H.setAttribute("aria-sort", Pe), H.hasAttribute("tabindex") || H.setAttribute("tabindex", "0");
    });
    const Y = G && F.find((H) => H.key === G.key);
    wl(R, G && Y && !p && T.current === 0 ? { col: Y.col, dir: G.dir } : null, ne.current);
  }
  const O = (R) => {
    var H;
    const F = R.dataset.axeSort;
    if (F === void 0) return;
    const Y = pr(G, F), z = ((H = R.textContent) != null ? H : "").replace(/\s+/g, " ").trim();
    j(br(Y, () => z)), y === void 0 && X(Y), _ == null || _(Y);
  }, V = (R) => {
    var z, H;
    const F = R, Y = (z = F.closest) == null ? void 0 : z.call(F, "thead th[data-axe-sort]");
    return !Y || !((H = h.current) != null && H.contains(Y)) || F !== Y && F.closest('input, select, textarea, button, a[href], [role="button"]') ? null : Y;
  }, Q = (R) => {
    const F = V(R.target);
    F && O(F);
  }, se = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const F = V(R.target);
    !F || R.target !== F || (R.preventDefault(), O(F));
  }, B = (R) => {
    const F = R.target.scrollLeft;
    h.current && (h.current.scrollLeft = F), g.current && (g.current.scrollLeft = F);
  }, J = (R) => {
    const F = R.target.scrollLeft;
    g.current && (g.current.scrollLeft = F), x.current && (x.current.scrollLeft = F);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ue.card, o ? ue.grow : "", i ? ue.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ue.busyBar, "aria-hidden": "true" }), (r !== void 0 || s !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ue.head }, /* @__PURE__ */ n.createElement("span", { className: ue.title }, r), s && /* @__PURE__ */ n.createElement("span", { className: ue.trailing }, s)), /* @__PURE__ */ n.createElement("div", { className: ue.scroll, ref: h, onScroll: J }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: E,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: N ? { minWidth: N } : void 0,
      onClick: f ? Q : void 0,
      onKeyDown: f ? se : void 0
    },
    /* @__PURE__ */ n.createElement(Ea, { cols: e }),
    /* @__PURE__ */ n.createElement(gr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ue.foot, ref: g }, /* @__PURE__ */ n.createElement("table", { className: E, style: N ? { minWidth: N } : void 0 }, /* @__PURE__ */ n.createElement(Ea, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ue.strip, ref: x, onScroll: B }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ue.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ue.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ue.sr, role: "status", "aria-live": "polite" }, K));
}
const rc = 600;
function ga(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: s } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const o = e.viewport > 0 ? e.viewport : rc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - s) / a))), i = Math.ceil(o / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function sc(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function oc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const va = /* @__PURE__ */ new Set();
function ka({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function dv({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: s = 6,
  colSpan: o,
  headerRows: l = 1,
  className: c
}) {
  var E;
  const i = Dn(gr), m = L(null), [u, f] = A(() => ga({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: s
  })), y = e.length, [_, p] = A(null), d = _ && _.of === t ? _.px : t;
  qe(() => i ? i.registerVirtual() : void 0, [i]), qe(() => {
    var g;
    const h = (g = m.current) == null ? void 0 : g.closest("table");
    if (h)
      return h.setAttribute("aria-rowcount", String(y + l)), () => h.removeAttribute("aria-rowcount");
  }, [y, l]), Z(() => {
    const h = i == null ? void 0 : i.scrollRef.current, g = m.current;
    if (!h || !g) return;
    const x = () => {
      const M = g.getBoundingClientRect().top - h.getBoundingClientRect().top + h.scrollTop, T = ga({ count: y, rowHeight: d, scrollTop: h.scrollTop, viewport: h.clientHeight, bodyTop: M, overscan: s });
      f((I) => oc(I, T) ? I : T);
    };
    x(), h.addEventListener("scroll", x, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(x) : null;
    return C ? C.observe(h) : window.addEventListener("resize", x), () => {
      h.removeEventListener("scroll", x), C ? C.disconnect() : window.removeEventListener("resize", x);
    };
  }, [i, y, d, s]), qe(() => {
    var x, C, M;
    const h = (x = m.current) == null ? void 0 : x.querySelector("tr:not([data-virtual-spacer])"), g = (C = h == null ? void 0 : h.getBoundingClientRect().height) != null ? C : 0;
    !(g > 0) || Math.abs(g - d) <= 0.25 || (p({ of: t, px: g }), typeof process != "undefined" && ((M = process.env) == null ? void 0 : M.NODE_ENV) !== "production" && Math.abs(g - t) > 2 && !va.has(t) && (va.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(g)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, y]);
  const b = Math.min(u.end, y), w = Math.min(u.start, b), N = sc(y, d, { start: w, end: b }), k = (E = o != null ? o : i == null ? void 0 : i.colCount) != null ? E : 1, $ = [];
  for (let h = w; h < b; h += 1) {
    const g = a(e[h], h), x = r ? r(e[h], h) : h;
    $.push(on(g) ? oa(g, { key: x, "aria-rowindex": h + 1 + l }) : g);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(ka, { height: N.top, colSpan: k }), $, /* @__PURE__ */ n.createElement(ka, { height: N.bottom, colSpan: k }));
}
const lc = 7.09, cc = 3.88, ic = 4.46, uc = 16, mc = 2;
function dc(e, t = {}) {
  var o;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), s = a * lc + r * cc + (t.negative ? ic : 0) + uc + mc;
  return Math.max(Math.ceil(s), (o = t.min) != null ? o : 0);
}
function fv(e, t = {}) {
  var s, o;
  let a = 0, r = (s = t.negative) != null ? s : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((o = t.min) != null ? o : 96, 96) : dc(a, { ...t, negative: r });
}
function _v(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), s = a("000,000,000,000"), o = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (s - r) / 3, minus: o - s };
}
const wt = 12, fc = 1.06, _c = 16, pc = 4;
function yc(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? wt : e === " " ? wt * 0.3 : /[0-9]/.test(e) ? wt * 0.56 : /[A-Z]/.test(e) ? wt * 0.68 : /[a-z]/.test(e) ? wt * 0.56 : /[.,:;'|!]/.test(e) ? wt * 0.3 : wt * 0.6;
}
function bc(e, t = !1) {
  let a = 0;
  for (const r of e) a += yc(r);
  return t ? a * fc : a;
}
function pv(e, t = {}) {
  var o, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = bc(i, t.bold);
    m > a && (a = m);
  }
  const r = (o = t.min) != null ? o : 64;
  if (a === 0) return r;
  const s = Math.ceil(a + _c + ((l = t.extra) != null ? l : 0) + pc);
  return Math.min(Math.max(s, r), (c = t.max) != null ? c : 1 / 0);
}
function Ec({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: s = "조회 결과가 없습니다",
  idle: o = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && m) f = "loading";
  else if (r == null) {
    if (o === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const y = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ue.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ue.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? u : f === "loading" ? l : f === "idle" ? o : s)), _ = /* @__PURE__ */ n.createElement("div", { className: [ue.status, ue[`st_${f}`]].join(" "), role: "status" }, y);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, _) : /* @__PURE__ */ n.createElement("tr", { className: [ue.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ue.statusCell }, _));
}
function hc(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const gc = "_cell_n9rrj_1", vc = "_toggle_n9rrj_2", kc = "_spacer_n9rrj_8", wc = "_label_n9rrj_9", Nc = "_dim_n9rrj_10", Vt = {
  cell: gc,
  toggle: vc,
  spacer: kc,
  label: wc,
  dim: Nc
};
function yv(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [s, o] = A(() => /* @__PURE__ */ new Set()), [l, c] = A(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = we(() => {
    const _ = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const w = a(b), N = w == null || !d.has(String(w)) ? null : String(w);
      _.set(String(t(b)), N), N && p.add(N);
    }
    return { parents: _, kids: p };
  }, [e, t, a]), u = oe((_) => r ? !s.has(_) : l.has(_), [r, s, l]), f = we(() => e.filter((_) => {
    var b, w;
    let p = (b = i.get(String(t(_)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; p && !d.has(p); ) {
      if (!u(p)) return !1;
      d.add(p), p = (w = i.get(p)) != null ? w : null;
    }
    return !0;
  }), [e, i, t, u]), y = oe((_, p) => {
    const d = (b, w) => {
      const N = new Set(b);
      return w ? N.add(_) : N.delete(_), N;
    };
    r ? o((b) => d(b, !p)) : c((b) => d(b, p));
  }, [r]);
  return {
    visible: f,
    hasChildren: (_) => m.has(String(t(_))),
    isOpen: (_) => u(String(t(_))),
    toggle: (_) => {
      const p = String(t(_));
      y(p, !u(p));
    },
    expandAll: () => {
      o(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      o(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const _ = s, p = l;
      return o(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        o(_), c(p);
      };
    },
    reveal: (_) => {
      var b, w;
      let p = (b = i.get(String(_))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; p && !d.has(p); )
        y(p, !0), d.add(p), p = (w = i.get(p)) != null ? w : null;
    }
  };
}
function bv({ depth: e, hasChildren: t, open: a, onToggle: r, dim: s, toggleOutOfTabOrder: o, title: l, csvPath: c, children: i }) {
  const m = (f) => {
    f.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Vt.cell, s ? Vt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Vt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: o ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Vt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Vt.label, title: u }, i)
  );
}
function $c(e, t, a, r = !1) {
  const s = e[t.r];
  if (!s || t.i < 0 || t.i >= s.length) return null;
  const o = s[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < s.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: s.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: xc(e[m], o) };
      return null;
    }
    default:
      return null;
  }
}
function xc(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function Ev(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, s = L(null), [o, l] = A(null);
  Z(() => {
    e.current !== o && l(e.current);
  }), Z(() => {
    if (!o) return;
    const i = () => Array.from(o.querySelectorAll(a)), m = () => {
      const p = i();
      if (!p.length) {
        s.current = null;
        return;
      }
      (!s.current || !p.includes(s.current)) && (s.current = r && p.find((d) => d.matches(r)) || p[0]), p.forEach((d) => {
        const b = d === s.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, u = () => {
      const p = i(), d = [], b = [], w = /* @__PURE__ */ new Map(), N = [];
      return p.forEach((k) => {
        var M;
        const $ = k.tagName === "TR", E = $ ? null : k.closest("td, th"), h = E && o.contains(E) ? E.parentElement : null, g = $ ? k : (M = h != null ? h : k.parentElement) != null ? M : o;
        let x = d.indexOf(g);
        x < 0 && (x = d.length, d.push(g), b.push([]), N.push([]));
        let C;
        if ($)
          C = 0;
        else if (E && h) {
          C = 0;
          for (const T of Array.from(h.cells)) {
            if (T === E) break;
            C += Math.max(1, T.colSpan || 1);
          }
        } else
          C = b[x].length;
        w.set(k, { r: x, i: b[x].length }), b[x].push(C), N[x].push(k);
      }), { rows: b, where: w, byPos: N };
    }, f = (p) => {
      var h;
      const d = p.target;
      if (!d || !d.matches(a) || !o.contains(d) || p.altKey || p.metaKey || d.tagName === "TR" && (p.key === "ArrowLeft" || p.key === "ArrowRight")) return;
      const { rows: b, where: w, byPos: N } = u(), k = w.get(d);
      if (!k) return;
      const $ = $c(b, k, p.key, p.ctrlKey);
      if ($ === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(p.key) && p.preventDefault();
        return;
      }
      p.preventDefault();
      const E = (h = N[$.r]) == null ? void 0 : h[$.i];
      E && (s.current = E, m(), E.focus());
    }, y = (p) => {
      const d = p.target;
      !d || !d.matches(a) || d === s.current || (s.current = d, m());
    };
    m(), o.addEventListener("keydown", f), o.addEventListener("focusin", y);
    const _ = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return _ == null || _.observe(o, { childList: !0, subtree: !0 }), () => {
      o.removeEventListener("keydown", f), o.removeEventListener("focusin", y), _ == null || _.disconnect();
    };
  }, [o, a, r]);
}
const Dc = "_btn_r1trx_1", Ac = "_mark_r1trx_7", Cc = "_sr_r1trx_9", Qn = {
  btn: Dc,
  mark: Ac,
  sr: Cc
};
function hv({ sortKey: e, sort: t, onSort: a, children: r, className: s = "", colSpan: o, style: l, title: c }) {
  const i = yr(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: o, style: l, title: c, className: s }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Qn.btn, onClick: () => a(pr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Qn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function gv({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: Qn.sr, role: "status", "aria-live": "polite" }, br(e, t));
}
const Sc = "_card_14vt3_1", Mc = "_accent_14vt3_8", Tc = "_grow_14vt3_9", qc = "_head_14vt3_11", Bc = "_body_14vt3_20", Lc = "_title_14vt3_28", jc = "_trailing_14vt3_29", Rc = "_summary_14vt3_32", Ic = "_sumHead_14vt3_33", Oc = "_sumTotal_14vt3_42", Pc = "_tone_warn_14vt3_43", Xc = "_tone_ok_14vt3_44", zc = "_sumList_14vt3_46", Fc = "_sumEm_14vt3_55", Wc = "_sumFoot_14vt3_57", Hc = "_sumNote_14vt3_66", $e = {
  card: Sc,
  accent: Mc,
  grow: Tc,
  head: qc,
  body: Bc,
  title: Lc,
  trailing: jc,
  summary: Rc,
  sumHead: Ic,
  sumTotal: Oc,
  tone_warn: Pc,
  tone_ok: Xc,
  sumList: zc,
  sumEm: Fc,
  sumFoot: Wc,
  sumNote: Hc
};
function vr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: s,
  className: o = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [$e.card, a ? $e.accent : "", r ? $e.grow : "", o].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: $e.trailing }, t)),
    s ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", $e.body].join(" ") }, l)
  );
}
function vv({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: s,
  note: o,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [$e.card, $e.accent, $e.summary, $e[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: $e.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: $e.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: $e.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? $e.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: $e.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, s)), o && /* @__PURE__ */ n.createElement("div", { className: $e.sumNote }, o));
}
let Kc = 0;
function Kt(e = "axe") {
  const t = L(null);
  return t.current || (t.current = `${e}-${++Kc}`), t.current;
}
const Uc = "_sr_1y2mv_2", Gc = "_skip_1y2mv_8", Yc = "_crit_1y2mv_16", Vc = "_c_danger_1y2mv_21", Qc = "_c_warn_1y2mv_22", Jc = "_critI_1y2mv_23", Zc = "_critBody_1y2mv_24", ei = "_critX_1y2mv_25", ti = "_ch_1y2mv_32", ni = "_chBtn_1y2mv_33", ai = "_chBox_1y2mv_43", Je = {
  sr: Uc,
  skip: Gc,
  crit: Yc,
  c_danger: Vc,
  c_warn: Qc,
  critI: Jc,
  critBody: Zc,
  critX: ei,
  ch: ti,
  chBtn: ni,
  chBox: ai
};
function kr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Je.sr, id: a }, t);
}
function kv({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, s) => {
    const o = document.getElementById(s);
    o && (r.preventDefault(), o.hasAttribute("tabindex") || o.setAttribute("tabindex", "-1"), o.focus(), o.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Je.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (s) => a(s, r.targetId) }, r.label)));
}
function wv({ title: e, children: t, tone: a = "danger", onClose: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Je.crit, Je[`c_${a}`], s].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Je.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Je.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Je.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function Nv({ label: e, children: t, className: a = "" }) {
  const [r, s] = A(!1), o = Kt("axe-ch"), l = L(null), c = L(null);
  return Z(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && s(!1);
    }, m = (u) => {
      var f;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), s(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Je.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Je.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": o,
      onClick: () => s((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: o, role: "region", "aria-label": e, className: Je.chBox }, t));
}
function Jn(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const s = (t != null ? t : "").trim();
  return !s || a === "code" ? r : a === "name" ? s : `${r}. ${s}`;
}
function ri(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = Jn(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function si(e, t, a, r) {
  const s = (e != null ? e : "").trim();
  if (!s) return null;
  if (t && t.name && t.code === s) return t.name;
  if (a && a.code === s && a.name) return a.name;
  const o = r == null ? void 0 : r.find((l) => l.code === s);
  return o && o.name ? o.name : null;
}
const oi = "_root_g2b1p_1", li = "_rootNone_g2b1p_5", ci = "_field_g2b1p_12", ii = "_codeInput_g2b1p_13", ui = "_nameHint_g2b1p_16", mi = "_pickBtn_g2b1p_25", di = "_suggest_g2b1p_42", fi = "_suggestList_g2b1p_48", _i = "_suggestRow_g2b1p_49", pi = "_suggestOn_g2b1p_50", yi = "_suggestEmpty_g2b1p_55", bi = "_suggestMore_g2b1p_55", Ei = "_popup_g2b1p_59", hi = "_popupHead_g2b1p_73", gi = "_searchRow_g2b1p_83", vi = "_list_g2b1p_87", ki = "_current_g2b1p_96", wi = "_empty_g2b1p_100", Ni = "_summaryBtn_g2b1p_108", $i = "_ov_g2b1p_129", xi = "_modal_g2b1p_140", Di = "_modalWide_g2b1p_140", Ai = "_head_g2b1p_152", Ci = "_sub_g2b1p_160", Si = "_x_g2b1p_162", Mi = "_body_g2b1p_179", Ti = "_chips_g2b1p_187", qi = "_chip_g2b1p_187", Bi = "_chipOn_g2b1p_201", Li = "_search_g2b1p_83", ji = "_tbl_g2b1p_220", Ri = "_row_g2b1p_250", Ii = "_rowCursor_g2b1p_252", Oi = "_rowPicked_g2b1p_253", Pi = "_rowCurrent_g2b1p_254", Xi = "_curTag_g2b1p_255", zi = "_busy_g2b1p_256", Fi = "_count_g2b1p_257", Wi = "_chk_g2b1p_259", Hi = "_tdLeft_g2b1p_260", Ki = "_tdCenter_g2b1p_261", Ui = "_emptyCell_g2b1p_263", Gi = "_stop_g2b1p_265", Yi = "_more_g2b1p_276", Vi = "_pager_g2b1p_288", Qi = "_note_g2b1p_301", Ji = "_foot_g2b1p_304", Zi = "_ghost_g2b1p_313", eu = "_primary_g2b1p_325", U = {
  root: oi,
  rootNone: li,
  field: ci,
  codeInput: ii,
  nameHint: ui,
  pickBtn: mi,
  suggest: di,
  suggestList: fi,
  suggestRow: _i,
  suggestOn: pi,
  suggestEmpty: yi,
  suggestMore: bi,
  popup: Ei,
  popupHead: hi,
  searchRow: gi,
  list: vi,
  current: ki,
  empty: wi,
  summaryBtn: Ni,
  ov: $i,
  modal: xi,
  modalWide: Di,
  head: Ai,
  sub: Ci,
  x: Si,
  body: Mi,
  chips: Ti,
  chip: qi,
  chipOn: Bi,
  search: Li,
  tbl: ji,
  row: Ri,
  rowCursor: Ii,
  rowPicked: Oi,
  rowCurrent: Pi,
  curTag: Xi,
  busy: zi,
  count: Fi,
  chk: Wi,
  tdLeft: Hi,
  tdCenter: Ki,
  emptyCell: Ui,
  stop: Gi,
  more: Yi,
  pager: Vi,
  note: Qi,
  foot: Ji,
  ghost: Zi,
  primary: eu
};
function tu({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: s,
  pos: o,
  onPick: l,
  onClose: c
}) {
  const [i, m] = A(""), u = we(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (y) => {
        var _;
        return y.code.toLowerCase().includes(f) || y.name.toLowerCase().includes(f) || ((_ = y.sub) != null ? _ : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return Z(() => {
    const f = (_) => {
      const p = _.target;
      r.current && !r.current.contains(p) && s.current && !s.current.contains(p) && c();
    }, y = (_) => {
      _.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", y), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", y);
    };
  }, [r, s, c]), /* @__PURE__ */ n.createElement(Ht, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: U.popup,
      style: { left: o.left, top: o.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: U.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: U.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => m(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && u.length && l(u[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: U.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? U.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: U.empty }, "검색 결과가 없습니다"))
  ));
}
const wr = 250, pn = 7;
function wa(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function nu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const s = r.trim().toLowerCase();
      return s ? Promise.resolve({
        rows: a.filter(
          (o) => {
            var l;
            return o.cd.toLowerCase().includes(s) || o.nm.toLowerCase().includes(s) || String((l = o.sub) != null ? l : "").toLowerCase().includes(s);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function au({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: s,
  current: o,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const m = we(() => nu(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [f, y] = A(""), [_, p] = A((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = A(0), [w, N] = A([]), [k, $] = A(!1), [E, h] = A(!1), [g, x] = A(null), [C, M] = A(0), [T, I] = A(/* @__PURE__ */ new Map()), q = L(u);
  q.current = u, Z(() => {
    var J;
    y(""), p((J = q.current.defaultFilter) != null ? J : null), b(0), M(0), x(null), I(new Map((s != null ? s : []).map((R) => [R.cd, R])));
    const B = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(B);
  }, [u.key]), Z(() => {
    let B = !0;
    h(!0);
    const J = () => {
      q.current.fetch({ q: f.trim(), ty: _, page: d }).then((F) => {
        var z, H;
        if (!B) return;
        N((z = F.rows) != null ? z : []), $(!!F.hasMore), x(null);
        const Y = o ? ((H = F.rows) != null ? H : []).findIndex((ce) => ce.cd === o) : -1;
        M(Y > 0 ? Y : 0);
      }).catch((F) => {
        B && (N([]), $(!1), x("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        B && h(!1);
      });
    }, R = window.setTimeout(J, f.trim() ? wr : 0);
    return () => {
      B = !1, window.clearTimeout(R);
    };
  }, [u.key, f, _, d]);
  const X = L(null);
  Z(() => {
    const B = X.current && X.current.children[C];
    B && "scrollIntoView" in B && B.scrollIntoView({ block: "nearest" });
  }, [C, w]);
  const G = we(() => {
    var J, R;
    const B = [
      { key: "cd", label: "코드", width: (J = u.codeWidth) != null ? J : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (F) => /* @__PURE__ */ n.createElement(n.Fragment, null, F.nm, F.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: U.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && B.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (F) => u.typeLabel ? u.typeLabel(F) : ""
    }), B.concat((R = u.extraColumns) != null ? R : []);
  }, [u]), K = oe((B) => {
    I((J) => {
      const R = new Map(J);
      return R.has(B.cd) ? R.delete(B.cd) : R.set(B.cd, B), R;
    });
  }, []), j = oe((B) => c([B]), [c]), ne = oe(() => c(Array.from(T.values())), [T, c]), ae = w.length > 0 && w.every((B) => T.has(B.cd)), v = () => {
    I((B) => {
      const J = new Map(B);
      return ae ? w.forEach((R) => J.delete(R.cd)) : w.forEach((R) => J.set(R.cd, R)), J;
    });
  }, O = L(null);
  Z(() => {
    const B = document.activeElement;
    return () => {
      window.setTimeout(() => {
        B && B.isConnected && typeof B.focus == "function" && (!document.activeElement || document.activeElement === document.body) && B.focus();
      }, 0);
    };
  }, []);
  const V = L(i);
  V.current = i, Z(() => {
    const B = (J) => {
      J.key !== "Escape" || J.isComposing || (J.stopPropagation(), J.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", B, !0), () => document.removeEventListener("keydown", B, !0);
  }, []);
  const Q = (B) => {
    var F;
    if (B.nativeEvent.isComposing || B.keyCode === 229) return;
    if (B.key === "Tab" && O.current) {
      const Y = Array.from(O.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (Y.length) {
        const z = Y[0], H = Y[Y.length - 1], ce = document.activeElement;
        B.shiftKey && ce === z ? (B.preventDefault(), H.focus()) : !B.shiftKey && ce === H && (B.preventDefault(), z.focus());
      }
      return;
    }
    if (B.key === "Escape") {
      B.stopPropagation(), i();
      return;
    }
    const J = B.target, R = J === l.current;
    if (!(!R && J !== O.current)) {
      if (B.key === "ArrowDown" || B.key === "ArrowUp") {
        B.preventDefault(), M((Y) => Math.max(0, Math.min(w.length - 1, Y + (B.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (B.key === " " && r && w[C] && !(R && ((F = l.current) != null && F.value))) {
        B.preventDefault(), K(w[C]);
        return;
      }
      if (B.key === "Enter") {
        if (B.preventDefault(), E) return;
        r ? ne() : w[C] && j(w[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Ht, null, /* @__PURE__ */ n.createElement("div", { className: U.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${U.modal} ${U.modalWide}` : U.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: O,
      onClick: (B) => B.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: U.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: U.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: U.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: U.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: _ === null ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          p(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((B) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: B.value,
        type: "button",
        className: _ === B.value ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          p(B.value), b(0);
        }
      },
      B.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: U.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (B) => {
          y(B.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: U.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: U.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: ae,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), G.map((B) => /* @__PURE__ */ n.createElement("th", { key: B.key, style: B.width ? { width: B.width } : void 0 }, B.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: X, className: E && w.length > 0 ? U.busy : void 0, "aria-busy": E }, w.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: U.emptyCell, colSpan: G.length + (r ? 1 : 0) }, E ? "검색 중…" : g || u.emptyText || "검색 결과가 없습니다")) : w.map((B, J) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: B.cd,
        className: [
          U.row,
          J === C ? U.rowCursor : "",
          T.has(B.cd) ? U.rowPicked : "",
          !r && o && B.cd === o ? U.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": J === C,
        onClick: () => {
          M(J), r ? K(B) : j(B);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: U.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: T.has(B.cd),
          onChange: () => K(B),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${B.cd} 선택`
        }
      )),
      G.map((R) => {
        var F, Y;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? U.tdLeft : U.tdCenter,
            title: R.render ? void 0 : String((F = B[R.key]) != null ? F : "")
          },
          R.render ? R.render(B) : String((Y = B[R.key]) != null ? Y : ""),
          R.key === "cd" && !r && o && B.cd === o && /* @__PURE__ */ n.createElement("em", { className: U.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: U.count, role: "status", "aria-live": "polite" }, E ? "검색 중…" : g ? "" : `${w.length}건`, !r && !E && !g && w.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (k || d > 0) && /* @__PURE__ */ n.createElement("div", { className: U.more }, /* @__PURE__ */ n.createElement("span", null, k ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: U.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((B) => Math.max(0, B - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), k && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((B) => B + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: U.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, T.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: U.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.primary, onClick: ne }, "확인"))
  )));
}
let ru = 0;
function su({ source: e, items: t, anchorRef: a }) {
  const [r, s] = A(null), [o, l] = A(-1), [c, i] = A(null), m = L(null), u = L(0), f = L(`axe-cp-${++ru}`), y = L(e);
  y.current = e;
  const _ = L(t);
  _.current = t;
  const p = oe(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, s(null), l(-1);
  }, []);
  Z(() => p, [p]);
  const d = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const w = u.current;
    if (!b.trim()) {
      s(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var $;
      let N = [], k = !1;
      try {
        const E = y.current;
        if (E) {
          const h = await E.fetch({ q: b, ty: null, page: 0 });
          N = h.rows, k = !!h.hasMore || N.length > pn;
        } else {
          const h = b.trim().toLowerCase();
          N = (($ = _.current) != null ? $ : []).filter((g) => {
            var x;
            return g.code.toLowerCase().includes(h) || g.name.toLowerCase().includes(h) || ((x = g.sub) != null ? x : "").toLowerCase().includes(h);
          }).map((g) => ({ cd: g.code, nm: g.name, sub: g.sub })), k = N.length > pn;
        }
      } catch {
        return;
      }
      w === u.current && (s({ rows: N.slice(0, pn), more: k, q: b }), l(-1));
    }, wr);
  };
  return Z(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const w = a.current;
      if (!w) return;
      const N = w.getBoundingClientRect(), k = Math.min(r.rows.length, pn) * 28 + 34, $ = N.bottom + k > window.innerHeight - 8 && N.top - k - 2 > 8 ? N.top - k - 2 : N.bottom + 2, E = Math.max(N.width, 260);
      i({ left: Math.max(8, Math.min(N.left, window.innerWidth - E - 8)), top: $, width: E });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: o, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: p };
}
function $v({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: s,
  source: o,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: f = "전체",
  open: y,
  onOpenChange: _,
  placeholder: p,
  title: d = "코드 선택",
  variant: b,
  disabled: w,
  className: N = "",
  maxLength: k,
  numeric: $ = !1,
  ariaLabel: E,
  autoFocus: h,
  onEnter: g,
  onEscape: x,
  onBlur: C,
  invalid: M,
  selectOnFocus: T = !1
}) {
  const I = o ? "source" : "static", q = E != null ? E : (o == null ? void 0 : o.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", X = b != null ? b : I === "source" ? "modal" : "anchor", G = u != null ? u : l ? "summary" : "input", [K, j] = A(!1), ne = y != null ? y : K, ae = oe(
    (W) => {
      y === void 0 && j(W), _ && _(W);
    },
    [y, _]
  ), v = L(null), O = L(!1), V = L(null), Q = L(null), [se, B] = A(null), J = () => {
    if (!w) {
      if (X === "anchor") {
        const W = v.current;
        if (!W) return;
        const D = W.getBoundingClientRect(), P = 320, te = D.bottom + P > window.innerHeight ? Math.max(8, D.top - P - 4) : D.bottom + 4;
        B({ left: Math.min(D.left, window.innerWidth - 320), top: te });
      }
      ae(!0);
    }
  }, R = oe(() => ae(!1), [ae]), [F, Y] = A(!1), [z, H] = A(null), ce = L(null);
  (!ce.current || ce.current.name !== t) && (ce.current = { name: t, code: e });
  const Pe = si(e, ce.current, z, s), je = Jn(e, Pe, a), Re = Jn(e, Pe), ft = F && Pe && a !== "code" ? Pe : "", Ut = (W) => {
    !l && W[0] && H({ code: W[0].cd, name: W[0].nm }), i ? i(W) : W[0] && r && r(W[0].cd, { code: W[0].cd, name: W[0].nm });
  }, { sugg: Ee, active: Ie, setActive: Gt, suggPos: Fe, suggId: _t, runSuggest: Ln, cancelSuggest: Ue } = su({ source: o, items: s, anchorRef: v }), fn = (W) => {
    Ue(), Ut([W]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: v, className: [G === "none" ? U.rootNone : U.root, N].filter(Boolean).join(" ") }, G === "input" && /* @__PURE__ */ n.createElement("span", { className: U.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: U.codeInput,
      style: { paddingRight: ft ? "calc(24px + 45%)" : 24 },
      value: F ? e : je,
      placeholder: p,
      disabled: w,
      maxLength: k,
      inputMode: $ ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: h,
      "aria-label": q,
      "aria-invalid": M ? !0 : void 0,
      onChange: (W) => {
        const D = W.target.value.trim(), P = $ ? D.replace(/[^0-9]/g, "") : D, te = k ? P.slice(0, k) : P;
        r && r(te), !w && (o || s) && Ln(te);
      },
      onKeyDown: (W) => {
        if (W.key === "F2") {
          W.preventDefault(), Ue(), J();
          return;
        }
        if (!Ee) {
          W.key === "Enter" && g && !W.nativeEvent.isComposing ? (W.preventDefault(), g()) : W.key === "Escape" && x && (W.preventDefault(), x());
          return;
        }
        const D = Ee.rows.length;
        W.key === "ArrowDown" && D ? (W.preventDefault(), Gt((P) => (P + 1) % D)) : W.key === "ArrowUp" && D ? (W.preventDefault(), Gt((P) => (P <= 0 ? D : P) - 1)) : W.key === "Enter" && Ie >= 0 && Ee.rows[Ie] ? (W.preventDefault(), fn(Ee.rows[Ie])) : W.key === "Enter" && g && !W.nativeEvent.isComposing ? (W.preventDefault(), Ue(), g()) : W.key === "Escape" && (W.preventDefault(), W.stopPropagation(), W.nativeEvent.stopImmediatePropagation(), Ue());
      },
      onFocus: (W) => {
        if (Y(!0), !T) return;
        const D = W.currentTarget;
        window.requestAnimationFrame(() => D.select());
      },
      onMouseDown: (W) => {
        T && document.activeElement !== W.currentTarget && (O.current = !0);
      },
      onMouseUp: (W) => {
        O.current && (W.preventDefault(), O.current = !1);
      },
      onBlur: () => {
        Y(!1), Ue(), C && C();
      },
      title: typeof M == "string" && M ? M : Re && Re !== e ? `${Re} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!Ee,
      "aria-controls": Ee ? _t.current : void 0,
      "aria-activedescendant": Ee && Ie >= 0 ? `${_t.current}-${Ie}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${_t.current}-inv` : void 0
    }
  ), ft && /* @__PURE__ */ n.createElement("span", { className: U.nameHint, "aria-hidden": "true" }, ft), typeof M == "string" && M && /* @__PURE__ */ n.createElement(kr, { id: `${_t.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: U.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: w,
      onClick: J,
      onMouseDown: (W) => W.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(ln, { name: "search", size: 13 })
  )), G === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.summaryBtn, disabled: w, onClick: J }, /* @__PURE__ */ n.createElement("span", null, ri(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(ln, { name: "search", size: 13 }))), Ee && Fe && G === "input" && !ne && /* @__PURE__ */ n.createElement(Ht, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: U.suggest,
      style: { left: Fe.left, top: Fe.top, width: Fe.width },
      onMouseDown: (W) => W.preventDefault()
    },
    Ee.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: U.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: _t.current, role: "listbox", className: U.suggestList }, Ee.rows.map((W, D) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: W.cd,
        id: `${_t.current}-${D}`,
        role: "option",
        "aria-selected": D === Ie,
        className: [U.suggestRow, D === Ie ? U.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Gt(D),
        onClick: () => fn(W)
      },
      /* @__PURE__ */ n.createElement("code", null, wa(W.cd, Ee.q)),
      /* @__PURE__ */ n.createElement("span", null, wa(W.nm, Ee.q)),
      W.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    Ee.more && /* @__PURE__ */ n.createElement("div", { className: U.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), ne && I === "static" && X === "anchor" && se && /* @__PURE__ */ n.createElement(
    tu,
    {
      items: s != null ? s : [],
      value: e,
      title: d,
      popupRef: V,
      anchorRef: v,
      pos: se,
      onPick: (W) => {
        H({ code: W.code, name: W.name }), r && r(W.code, W), R();
      },
      onClose: R
    }
  ), ne && (I === "source" || X === "modal") && /* @__PURE__ */ n.createElement(
    au,
    {
      source: o,
      items: s,
      title: d,
      multiple: l,
      selected: c,
      current: m,
      searchRef: Q,
      onConfirm: (W) => {
        Ut(W), R();
      },
      onClose: R
    }
  ));
}
const ia = 864e5;
function ou(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Be(e, t) {
  return t === 2 ? ou(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function gt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ia);
}
function lu(e) {
  const t = new Date(e * ia);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Cn(e, t) {
  return lu(gt(e) + t);
}
function ua(e) {
  return new Date(gt(e) * ia).getUTCDay();
}
const Na = "1900-01-01", $a = "2099-12-31", In = ["일", "월", "화", "수", "목", "금", "토"], vn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${vn(t)}-${vn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], s = +t[3];
  return r < 1 || r > 12 || s < 1 || s > Be(a, r) ? null : { y: a, m: r, d: s };
}
function cu(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function Qt(e, t) {
  return t === "month" ? cu(e) : de(e);
}
function Te(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${vn(e.m)}` : tt(e.y, e.m, e.d);
}
function Le(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function cn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function vt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = (a % 12 + 12) % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Be(r, s)) };
}
function iu(e, t, a) {
  return e >= t && e <= a;
}
function jt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function On(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), s = e.slice(6, 8);
  let o = a;
  return e.length > 4 && (o += "-" + r), t === "date" && e.length > 6 && (o += "-" + s), o;
}
function xa(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function hn(e, t, a) {
  let r, s, o = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), s = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), s = +e.slice(4, 6), o = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4), o = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, s = +e.slice(0, 2), o = +e.slice(2, 4);
  else return null;
  return s < 1 || s > 12 || o < 1 || o > Be(r, s) ? null : { y: r, m: s, d: o };
}
function uu(e, t, a) {
  const r = e.trim(), s = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (s) {
    const o = { y: +s[1], m: +s[2], d: t === "month" ? 1 : +s[3] };
    return o.m >= 1 && o.m <= 12 && o.d >= 1 && o.d <= Be(o.y, o.m) ? o : null;
  }
  return hn(r.replace(/\D/g, ""), t, a);
}
function mu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = cn(a, -Le(a));
  return Array.from({ length: 42 }, (s, o) => cn(r, o));
}
function du(e, t) {
  const a = e.y, r = [], s = (m, u) => `${String(m).padStart(4, "0")}-${vn(u)}`, o = (m, u, f) => tt(m, u, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: s(a, e.m), to: s(a, e.m) });
    const m = vt(e, -1);
    r.push({ label: "지난달", from: s(m.y, m.m), to: s(m.y, m.m) }), r.push({ label: "올해", from: s(a, 1), to: s(a, 12) }), r.push({ label: "올해 누계", from: s(a, 1), to: s(a, e.m) }), r.push({ label: "전년도", from: s(a - 1, 1), to: s(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: s(a, u * 3 - 2), to: s(a, u * 3) });
    return r.push({ label: "상반기", from: s(a, 1), to: s(a, 6) }), r.push({ label: "하반기", from: s(a, 7), to: s(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = cn(e, -Le(e));
  r.push({ label: "이번 주", from: Te(c, "date"), to: Te(cn(c, 6), "date") }), r.push({ label: "이번 달", from: o(a, e.m, 1), to: o(a, e.m, Be(a, e.m)) });
  const i = vt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: o(i.y, i.m, 1), to: o(i.y, i.m, Be(i.y, i.m)) }), r.push({ label: "올해", from: o(a, 1, 1), to: o(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: o(a, 1, 1), to: l }), r.push({ label: "전년도", from: o(a - 1, 1, 1), to: o(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: o(a, m * 3 - 2, 1), to: o(a, m * 3, Be(a, m * 3)) });
  return r;
}
const fu = "_wrap_uxy72_1", _u = "_disabled_uxy72_18", pu = "_input_uxy72_22", yu = "_month_uxy72_36", bu = "_weekday_uxy72_39", Eu = "_sun_uxy72_40", hu = "_sat_uxy72_41", gu = "_icon_uxy72_43", vu = "_readOnly_uxy72_57", ku = "_required_uxy72_62", wu = "_invalid_uxy72_63", Nu = "_pop_uxy72_66", $u = "_calHead_uxy72_79", xu = "_calTitleStatic_uxy72_80", Du = "_calTitle_uxy72_80", Au = "_grid_uxy72_90", Cu = "_wd_uxy72_91", Su = "_day_uxy72_95", Mu = "_mon_uxy72_36", Tu = "_out_uxy72_104", qu = "_sel_uxy72_105", Bu = "_today_uxy72_108", Lu = "_months_uxy72_111", ju = "_foot_uxy72_114", Ru = "_clear_uxy72_127", Iu = "_range_uxy72_130", Ou = "_tilde_uxy72_131", Pu = "_rangeErr_uxy72_132", re = {
  wrap: fu,
  disabled: _u,
  input: pu,
  month: yu,
  weekday: bu,
  sun: Eu,
  sat: hu,
  icon: gu,
  readOnly: vu,
  required: ku,
  invalid: wu,
  pop: Nu,
  calHead: $u,
  calTitleStatic: xu,
  calTitle: Du,
  grid: Au,
  wd: Cu,
  day: Su,
  mon: Mu,
  out: Tu,
  sel: qu,
  today: Bu,
  months: Lu,
  foot: ju,
  clear: Ru,
  range: Iu,
  tilde: Ou,
  rangeErr: Pu
}, yt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Da({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: s,
  disabled: o,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: f,
  id: y,
  name: _,
  onBlur: p,
  "aria-label": d,
  "aria-describedby": b,
  className: w = "",
  style: N
}) {
  const k = a === "month", $ = Kt("axe-dp"), E = r || (k ? Na.slice(0, 7) : Na), h = s || (k ? $a.slice(0, 7) : $a), g = (D) => iu(D, E, h), x = !!o || !!l, [C, M] = A(e || ""), [T, I] = A(!1), [q, X] = A(!1), [G, K] = A(k ? "month" : "day"), [j, ne] = A(() => {
    var P;
    const D = (P = Qt(e, a)) != null ? P : yt();
    return { y: D.y, m: D.m };
  }), [ae, v] = A({ top: 0, left: 0 }), O = L(null), V = L(null), Q = L(null), se = L(null);
  Z(() => {
    M(e || ""), I(!1);
  }, [e]), Z(() => {
    const D = Qt(e, a);
    D && ne({ y: D.y, m: D.m });
  }, [e, a]), qe(() => {
    const D = V.current;
    se.current != null && D && document.activeElement === D && D.setSelectionRange(se.current, se.current), se.current = null;
  }, [C]), qe(() => {
    if (!q) return;
    const D = () => {
      const P = O.current, te = Q.current;
      if (!P || !te) return;
      const ie = P.getBoundingClientRect(), me = te.offsetHeight, he = te.offsetWidth;
      let xe = ie.bottom + 4;
      xe + me > window.innerHeight - 8 && ie.top - me - 4 > 8 && (xe = ie.top - me - 4);
      const Yt = Math.max(8, Math.min(ie.left, window.innerWidth - he - 8));
      v((jn) => jn.top === xe && jn.left === Yt ? jn : { top: xe, left: Yt });
    };
    return D(), window.addEventListener("resize", D), window.addEventListener("scroll", D, !0), () => {
      window.removeEventListener("resize", D), window.removeEventListener("scroll", D, !0);
    };
  }, [q, G, j.y, j.m]), Z(() => {
    if (!q) return;
    const D = (P) => {
      var ie, me;
      const te = P.target;
      (ie = O.current) != null && ie.contains(te) || (me = Q.current) != null && me.contains(te) || X(!1);
    };
    return document.addEventListener("mousedown", D), () => document.removeEventListener("mousedown", D);
  }, [q]);
  const B = (D) => {
    D !== (e || "") && t(D);
  }, J = (D) => {
    M(D), I(!1), B(D);
  }, R = () => {
    const D = jt(C, a);
    if (!D) return;
    const P = hn(D, a, yt()), te = P ? Te(P, a) : null;
    if (te && g(te)) {
      J(te);
      return;
    }
    u == null || u(C, te ? "range" : "format"), M(e || ""), I(!1);
  }, F = (D, P) => {
    const te = jt(D.slice(0, P), a).length, ie = jt(D, a), me = On(ie, a);
    if (se.current = xa(me, Math.min(te, ie.length)), M(me), !ie) {
      I(!1), B("");
      return;
    }
    if (ie.length === (k ? 6 : 8)) {
      const he = hn(ie, a, yt()), xe = he ? Te(he, a) : null;
      xe && g(xe) ? (I(!1), B(xe)) : I(!0);
    } else I(!1);
  }, Y = (D, P) => {
    var Yt;
    const te = yt(), ie = jt(C, a), me = (Yt = hn(ie, a, te)) != null ? Yt : Qt(e, a);
    let he;
    me ? k ? he = vt(me, D === "year" ? 12 * P : P) : D === "day" ? he = cn(me, P) : he = vt(me, D === "month" ? P : 12 * P) : he = te;
    const xe = Te(he, a);
    g(xe) && J(xe);
  }, z = (D) => {
    var P;
    J(D), X(!1), (P = V.current) == null || P.focus();
  }, H = () => {
    var P;
    if (x) return;
    const D = (P = Qt(e, a)) != null ? P : yt();
    ne({ y: D.y, m: D.m }), K(k ? "month" : "day"), X(!0);
  }, ce = (D) => {
    var te, ie;
    if (x) return;
    const P = D.currentTarget;
    switch (D.key) {
      case "Escape":
        q ? (X(!1), D.preventDefault(), D.stopPropagation(), D.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (M(e || ""), I(!1), D.preventDefault(), D.stopPropagation(), D.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => P.select()));
        break;
      case "ArrowDown":
        D.preventDefault(), D.altKey ? q ? X(!1) : H() : Y("day", 1);
        break;
      case "ArrowUp":
        D.preventDefault(), Y("day", -1);
        break;
      case "PageDown":
        D.preventDefault(), Y("month", 1);
        break;
      case "PageUp":
        D.preventDefault(), Y("month", -1);
        break;
      case "F2":
      case "F4":
        D.preventDefault(), q ? X(!1) : H();
        break;
      case "Enter":
        R(), q && X(!1);
        break;
      case "t":
      case "T":
        if (D.ctrlKey || D.metaKey || D.altKey) break;
        D.preventDefault(), J(Te(yt(), a));
        break;
      case "Backspace": {
        const me = (te = P.selectionStart) != null ? te : 0;
        if (me === ((ie = P.selectionEnd) != null ? ie : 0) && me > 0 && C[me - 1] === "-") {
          D.preventDefault();
          const he = jt(C.slice(0, me), a).length, xe = jt(C, a);
          F(On(xe.slice(0, he - 1) + xe.slice(he), a), 0), se.current = xa(On(xe.slice(0, he - 1) + xe.slice(he), a), he - 1);
        }
        break;
      }
    }
  }, Pe = (D) => {
    if (x) return;
    D.preventDefault();
    const P = uu(D.clipboardData.getData("text"), a, yt()), te = P ? Te(P, a) : null;
    te && g(te) ? J(te) : I(!0);
  }, je = (D) => {
    var te, ie;
    const P = D.relatedTarget;
    P && ((te = O.current) != null && te.contains(P) || (ie = Q.current) != null && ie.contains(P)) || (R(), X(!1), p && p());
  }, Re = Qt(e, a), ft = yt(), Ut = T || !!i, Ee = m && !k && Re ? Le(Re) : null, Ie = (D) => Te(D, a), Gt = (D, P) => {
    const te = Te({ y: D, m: P, d: 1 }, "date"), ie = Te({ y: D, m: P, d: Be(D, P) }, "date"), me = k ? E + "-01" : E, he = k ? h + "-31" : h;
    return ie >= me && te <= he;
  }, Fe = (D) => {
    const P = vt({ y: j.y, m: j.m, d: 1 }, D);
    ne({ y: P.y, m: P.m });
  }, _t = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Fe(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Fe(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.calTitle, "aria-label": "연·월 선택", onClick: () => K("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Fe(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Fe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.grid }, In.map((D, P) => /* @__PURE__ */ n.createElement("span", { key: D, className: [re.wd, P === 0 ? re.sun : "", P === 6 ? re.sat : ""].join(" ") }, D)), mu(j.y, j.m).map((D) => {
    const P = Te(D, "date"), te = Le(D), ie = [
      re.day,
      D.m !== j.m ? re.out : "",
      te === 0 ? re.sun : "",
      te === 6 ? re.sat : "",
      P === Te(ft, "date") ? re.today : "",
      Re && P === Te(Re, "date") ? re.sel : ""
    ].join(" "), me = !g(P);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: P,
        type: "button",
        tabIndex: -1,
        className: ie,
        disabled: me,
        "aria-label": `${D.y}년 ${D.m}월 ${D.d}일 ${In[te]}요일`,
        "aria-pressed": !!Re && P === Te(Re, "date"),
        onClick: () => z(P)
      },
      D.d
    );
  }))), Ln = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Fe(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: re.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Fe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.months }, Array.from({ length: 12 }, (D, P) => P + 1).map((D) => {
    const P = !!Re && Re.y === j.y && Re.m === D, te = [re.mon, P ? re.sel : "", ft.y === j.y && ft.m === D ? re.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: D,
        type: "button",
        tabIndex: -1,
        className: te,
        disabled: !Gt(j.y, D),
        "aria-pressed": P,
        onClick: () => {
          k ? z(Ie({ y: j.y, m: D, d: 1 })) : (ne({ y: j.y, m: D }), K("day"));
        }
      },
      D,
      "월"
    );
  }))), Ue = Te(ft, a), fn = k ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !g(Ue), onClick: () => z(Ue) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !g(Ue), onClick: () => z(Ue) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !g(Ie({ y: j.y, m: j.m, d: 1 })),
      onClick: () => z(Ie({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !g(Ie({ y: j.y, m: j.m, d: Be(j.y, j.m) })),
      onClick: () => z(Ie({ y: j.y, m: j.m, d: Be(j.y, j.m) }))
    },
    "월말"
  )), W = [
    re.wrap,
    o ? re.disabled : "",
    l ? re.readOnly : "",
    c && !e && !C ? re.required : "",
    Ut ? re.invalid : "",
    k ? re.month : "",
    w
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: W, style: N, onBlur: je }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: y,
      name: _,
      className: re.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: f != null ? f : k ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: o,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": q,
      "aria-controls": $,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": Ut || void 0,
      "aria-required": c || void 0,
      onChange: (D) => {
        var P;
        return F(D.target.value, (P = D.target.selectionStart) != null ? P : D.target.value.length);
      },
      onKeyDown: ce,
      onPaste: Pe
    }
  ), Ee != null && /* @__PURE__ */ n.createElement("span", { className: [re.weekday, Ee === 0 ? re.sun : "", Ee === 6 ? re.sat : ""].join(" "), "aria-hidden": "true" }, "(", In[Ee], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: re.icon,
      disabled: x,
      "aria-label": k ? "월 선택 열기" : "달력 열기",
      onMouseDown: (D) => D.preventDefault(),
      onClick: () => {
        var D;
        (D = V.current) == null || D.focus(), q ? X(!1) : H();
      }
    },
    /* @__PURE__ */ n.createElement(ln, { name: "calendar", size: 15 })
  ), q && /* @__PURE__ */ n.createElement(Ht, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: $,
      className: re.pop,
      style: { top: ae.top, left: ae.left },
      role: "dialog",
      "aria-label": k ? "월 선택" : "날짜 선택",
      onMouseDown: (D) => D.preventDefault()
    },
    G === "day" && !k ? _t() : Ln(),
    /* @__PURE__ */ n.createElement("div", { className: re.foot }, fn, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.clear, onClick: () => z("") }, "비우기"))
  )));
}
const Ct = (e) => String(e).padStart(2, "0");
function Nr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Ct(e.getMonth() + 1)}-${Ct(e.getDate())}`;
}
function xv(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Ct(t.getMonth() + 1)}-${Ct(t.getDate())} ${Ct(t.getHours())}:${Ct(t.getMinutes())}:${Ct(t.getSeconds())}`;
}
function Dv(e, t) {
  return !!e && !!t && e <= t;
}
function Av({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: s,
  max: o,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const f = !!e && !!t && e > t, y = /* @__PURE__ */ new Date(), _ = i === !1 ? [] : Array.isArray(i) ? i : du({ y: y.getFullYear(), m: y.getMonth() + 1, d: y.getDate() }, r), p = (d) => (!s || d.from >= s) && (!o || d.to <= o);
  return /* @__PURE__ */ n.createElement("span", { className: re.range }, /* @__PURE__ */ n.createElement(
    Da,
    {
      value: e,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: u && ((d, b) => u(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: re.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    Da,
    {
      value: t,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: u && ((d, b) => u(d, b, "to"))
    }
  ), _.length > 0 && /* @__PURE__ */ n.createElement(
    Zs,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: _.map((d) => Js(
        d.label,
        d.label,
        () => a(d.from, d.to),
        p(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: re.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const $r = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function xr(e, t = $r) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const s of t) s.start <= e.slice(0, 10) && (!r || s.start > r.start) && (r = s);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Xu(e, t = {}) {
  const a = xr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function Cv(e, t) {
  const a = xr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Ce = 1440, kn = (e) => String(e).padStart(2, "0");
function pe(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function Mt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function nn(e) {
  const t = new Date(e * 6e4);
  return `${Mt(e)}T${kn(t.getUTCHours())}:${kn(t.getUTCMinutes())}`;
}
function Ze(e) {
  const t = (e % Ce + Ce) % Ce;
  return `${kn(Math.floor(t / 60))}:${kn(t % 60)}`;
}
function ke(e, t) {
  return de(e) ? Cn(e, t) : e;
}
function Ft(e, t) {
  return Math.round((pe(t) - pe(e)) / Ce);
}
function un(e) {
  if (!de(e)) return !1;
  const t = ua(e);
  return t === 0 || t === 6;
}
function zu(e) {
  var s;
  const t = pe(e.start);
  if (Number.isNaN(t)) return null;
  const a = (s = e.allDay) != null ? s : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const o = Mt(t), l = e.end ? Mt(pe(e.end)) : o, c = l < o ? o : l;
    return { ev: e, s: pe(o), e: pe(c) + Ce, allDay: a, sDay: o, eDay: c };
  }
  let r = e.end ? pe(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: Mt(t), eDay: Mt(r - 1) };
}
function Sn(e, t, a, r) {
  const s = [];
  for (const o of e) {
    const l = r && o.id === r.id ? { ...o, start: r.start, end: r.end } : o, c = zu(l);
    c && c.eDay >= t && c.sDay <= a && s.push(c);
  }
  return s.sort(Fu);
}
function Fu(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Ft(t.sDay, t.eDay) - Ft(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function Wu(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Dr(e) {
  return e.allDay || e.e - e.s >= Ce;
}
function wn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Le(a) - t + 7) % 7;
  return ke(e, -r);
}
function Mn(e, t) {
  const a = Ft(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, s) => ke(e, s));
}
function Ar(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), s = tt(a.y, a.m, Be(a.y, a.m)), o = wn(r, t), l = ke(wn(s, t), 6), c = Mn(o, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function ma(e, t, a) {
  if (e === "month") {
    const r = Ar(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Be(r.y, r.m)) };
  }
  if (e === "week") {
    const r = wn(t, a);
    return { from: r, to: ke(r, 6) };
  }
  return { from: t, to: t };
}
function Hu(e, t, a, r = !1) {
  const s = de(t);
  if (!s) return t;
  if (e === "month" || e === "agenda") {
    const l = vt(s, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ke(t, 7 * a);
  let o = ke(t, a);
  for (; r && un(o); ) o = ke(o, a);
  return o;
}
function Ku(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: s, to: o } = ma("week", t, a);
  return r.year(s) !== r.year(o) ? `${r.ymd(s)} – ${r.ymd(o)}` : s.slice(5, 7) !== o.slice(5, 7) ? `${r.ymd(s)} – ${r.md(o)}` : `${r.ymd(s)} – ${r.d(o)}`;
}
function Cr(e, t) {
  const a = [], r = [];
  for (const s of e) {
    let o = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= s.sDay && t[i] <= s.eDay && (o < 0 && (o = i), l = i);
    if (o < 0) continue;
    let c = r.findIndex((i) => i < o);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: s, col: o, span: l - o + 1, lane: c, contL: s.sDay < t[o], contR: s.eDay > t[l] });
  }
  return a;
}
function Uu(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const s = Math.max(1, a), o = e.filter((c) => {
    if (c.lane < s - 1) return !0;
    if (c.lane > s - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > s) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of o) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: o, more: r.map((c, i) => c - l[i]) };
}
const Gu = 20;
function Yu(e, t) {
  const a = pe(t), r = a + Ce, s = e.filter((m) => !Dr(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let o = [], l = [], c = -1;
  const i = () => {
    for (const m of o) m.cols = l.length;
    o = [], l = [];
  };
  for (const m of s) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + Gu);
    let f = l.findIndex((y) => y <= m.top);
    f < 0 ? (f = l.length, l.push(u)) : l[f] = u, m.col = f, o.push(m), c = Math.max(c, u);
  }
  return i(), s;
}
function Aa(e, t) {
  return Math.round(e / t) * t;
}
function Zn(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Ce);
    return { start: ke(e.sDay, a), end: ke(e.eDay, a) };
  }
  return { start: nn(e.s + t), end: nn(e.e + t) };
}
function da(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = pe(e.sDay), r = Ze(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Ce ? "24:00" : Ze(e.e - a)}`;
  const s = de(e.sDay), o = de(Mt(e.e));
  return `${s.m}/${s.d} ${r} – ${o.m}/${o.d} ${Ze(e.e - pe(Mt(e.e)))}`;
}
const De = (e) => {
  const t = de(e);
  return { ...t, w: Le(t) };
};
function Ca(e, t, a, r, s) {
  const o = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return o;
  const l = Xu(e, { eras: r, gannen: s });
  return l ? t === "era" ? l : `${o}(${l})` : o;
}
function Vu(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : $r, s = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], f = (_) => Ca(_, a, "年", r, s), y = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (_) => `前の${y[_]} (P)`,
      next: (_) => `次の${y[_]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (_) => `他${_}件`,
      eventCount: (_) => `予定${_}件`,
      dayOfSpan: (_, p) => `${_}/${p}日目`,
      openDay: (_) => {
        const p = De(_);
        return `${p.m}月${p.d}日を日表示`;
      },
      year: f,
      ym: (_) => `${f(_)}${De(_).m}月`,
      ymd: (_) => {
        const p = De(_);
        return `${f(_)}${p.m}月${p.d}日`;
      },
      md: (_) => {
        const p = De(_);
        return `${p.m}月${p.d}日`;
      },
      d: (_) => `${De(_).d}日`,
      m: (_) => `${De(_).m}月`,
      dayTitle: (_) => {
        const p = De(_);
        return `${f(_)}${p.m}月${p.d}日(${u[p.w]})`;
      },
      dayAria: (_) => {
        const p = De(_);
        return `${p.m}月${p.d}日 ${u[p.w]}曜日`;
      }
    };
  }
  const o = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => Ca(u, a, "년", r, s), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: o,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, f) => `${u}/${f}일째`,
    openDay: (u) => {
      const f = De(u);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${De(u).m}월`,
    ymd: (u) => {
      const f = De(u);
      return `${l(u)} ${f.m}월 ${f.d}일`;
    },
    md: (u) => {
      const f = De(u);
      return `${f.m}월 ${f.d}일`;
    },
    d: (u) => `${De(u).d}일`,
    m: (u) => `${De(u).m}월`,
    dayTitle: (u) => {
      const f = De(u);
      return `${l(u)} ${f.m}월 ${f.d}일 (${o[f.w]})`;
    },
    dayAria: (u) => {
      const f = De(u);
      return `${f.m}월 ${f.d}일 ${o[f.w]}요일`;
    }
  };
}
const Sr = Vu("ko"), Qu = "_cal_38qtm_2", Ju = "_toolbar_38qtm_20", Zu = "_navBtns_38qtm_28", em = "_title_38qtm_29", tm = "_toolRight_38qtm_36", nm = "_toggle_38qtm_37", am = "_body_38qtm_58", rm = "_busy_38qtm_59", sm = "_sun_38qtm_71", om = "_sat_38qtm_72", lm = "_tAccent_38qtm_75", cm = "_tOk_38qtm_76", im = "_tWarn_38qtm_77", um = "_tDanger_38qtm_78", mm = "_tViolet_38qtm_79", dm = "_tGray_38qtm_80", fm = "_month_38qtm_83", _m = "_mHead_38qtm_84", pm = "_wdName_38qtm_85", ym = "_mBody_38qtm_91", bm = "_mWeek_38qtm_92", Em = "_mCells_38qtm_94", hm = "_cell_38qtm_96", gm = "_out_38qtm_104", vm = "_dayNum_38qtm_105", km = "_creatable_38qtm_106", wm = "_selDay_38qtm_109", Nm = "_cellHead_38qtm_111", $m = "_isToday_38qtm_124", xm = "_holiday_38qtm_125", Dm = "_addHint_38qtm_130", Am = "_barLayer_38qtm_138", Cm = "_chip_38qtm_139", Sm = "_more_38qtm_139", Mm = "_tEv_38qtm_155", Tm = "_aRow_38qtm_155", qm = "_popItem_38qtm_155", Bm = "_bar_38qtm_138", Lm = "_contL_38qtm_165", jm = "_contR_38qtm_166", Rm = "_dotChip_38qtm_167", Im = "_dot_38qtm_167", Om = "_chipTime_38qtm_170", Pm = "_chipTitle_38qtm_171", Xm = "_movable_38qtm_173", zm = "_ghost_38qtm_176", Fm = "_time_38qtm_189", Wm = "_tHead_38qtm_190", Hm = "_tAllDay_38qtm_190", Km = "_gutter_38qtm_193", Um = "_tHeadDays_38qtm_197", Gm = "_tAllDayCells_38qtm_197", Ym = "_tDay_38qtm_198", Vm = "_tDayBtn_38qtm_202", Qm = "_tWd_38qtm_206", Jm = "_tDayNum_38qtm_208", Zm = "_tAllDayRow_38qtm_216", ed = "_allDayCell_38qtm_218", td = "_tBody_38qtm_222", nd = "_tGrid_38qtm_223", ad = "_tGutter_38qtm_224", rd = "_tCols_38qtm_230", sd = "_tCol_38qtm_230", od = "_tSel_38qtm_238", ld = "_tEvTitle_38qtm_258", cd = "_tEvTime_38qtm_259", id = "_tEvShort_38qtm_261", ud = "_contTop_38qtm_263", md = "_contBottom_38qtm_264", dd = "_resize_38qtm_265", fd = "_now_38qtm_268", _d = "_agenda_38qtm_272", pd = "_aDay_38qtm_273", yd = "_aDate_38qtm_275", bd = "_aDateBtn_38qtm_276", Ed = "_aDayNum_38qtm_280", hd = "_aDayWd_38qtm_286", gd = "_aList_38qtm_288", vd = "_aTime_38qtm_295", kd = "_aTitle_38qtm_296", wd = "_aSpan_38qtm_297", Nd = "_aLoc_38qtm_298", $d = "_empty_38qtm_303", xd = "_pop_38qtm_155", Dd = "_popHead_38qtm_321", Ad = "_popDay_38qtm_322", Cd = "_popClose_38qtm_329", Sd = "_popList_38qtm_334", Md = "_tAllDayOnly_38qtm_348", S = {
  cal: Qu,
  toolbar: Ju,
  navBtns: Zu,
  title: em,
  toolRight: tm,
  toggle: nm,
  body: am,
  busy: rm,
  sun: sm,
  sat: om,
  tAccent: lm,
  tOk: cm,
  tWarn: im,
  tDanger: um,
  tViolet: mm,
  tGray: dm,
  month: fm,
  mHead: _m,
  wdName: pm,
  mBody: ym,
  mWeek: bm,
  mCells: Em,
  cell: hm,
  out: gm,
  dayNum: vm,
  creatable: km,
  selDay: wm,
  cellHead: Nm,
  isToday: $m,
  holiday: xm,
  addHint: Dm,
  barLayer: Am,
  chip: Cm,
  more: Sm,
  tEv: Mm,
  aRow: Tm,
  popItem: qm,
  bar: Bm,
  contL: Lm,
  contR: jm,
  dotChip: Rm,
  dot: Im,
  chipTime: Om,
  chipTitle: Pm,
  movable: Xm,
  ghost: zm,
  time: Fm,
  tHead: Wm,
  tAllDay: Hm,
  gutter: Km,
  tHeadDays: Um,
  tAllDayCells: Gm,
  tDay: Ym,
  tDayBtn: Vm,
  tWd: Qm,
  tDayNum: Jm,
  tAllDayRow: Zm,
  allDayCell: ed,
  tBody: td,
  tGrid: nd,
  tGutter: ad,
  tCols: rd,
  tCol: sd,
  tSel: od,
  tEvTitle: ld,
  tEvTime: cd,
  tEvShort: id,
  contTop: ud,
  contBottom: md,
  resize: dd,
  now: fd,
  agenda: _d,
  aDay: pd,
  aDate: yd,
  aDateBtn: bd,
  aDayNum: Ed,
  aDayWd: hd,
  aList: gd,
  aTime: vd,
  aTitle: kd,
  aSpan: wd,
  aLoc: Nd,
  empty: $d,
  pop: xd,
  popHead: Dd,
  popDay: Ad,
  popClose: Cd,
  popList: Sd,
  tAllDayOnly: Md
}, mn = 22, Td = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function Tn(e) {
  var t;
  return e.color ? "" : Td[(t = e.tone) != null ? t : "accent"];
}
function qn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function Mr(e, t) {
  return [e.ev.title, da(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const an = (e, t) => !!e.onEventChange && !t.locked;
function gn(e, t, a) {
  var r;
  for (const s of document.elementsFromPoint(e, t)) {
    const o = (r = s.closest) == null ? void 0 : r.call(s, `[${a}]`);
    if (o) return o;
  }
  return null;
}
function Nn(e, t) {
  const a = e.clientX, r = e.clientY;
  let s = !1;
  const o = (u) => {
    !s && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (s = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, s);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", o), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function Tr(e) {
  const [t, a] = A(null), [r, s] = A(null), o = L(!1);
  return { preview: t, items: (f, y) => Sn(e.events, f, y, t), onItemDown: (f, y) => {
    var d;
    if (f.button !== 0 || !an(e, y.ev)) return;
    const _ = (d = gn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!_) return;
    o.current = !1;
    let p = 0;
    Nn(f, {
      move: (b) => {
        var N;
        o.current = !0;
        const w = (N = gn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : N.dataset.calDay;
        w && (p = Ft(_, w), a({ id: y.ev.id, ...Zn(y, p * Ce) }));
      },
      end: (b, w) => {
        var N;
        a(null), w && p && ((N = e.onEventChange) == null || N.call(e, y.ev, Zn(y, p * Ce)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, y) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let _ = y;
    s({ a: y, b: y }), Nn(f, {
      move: (p) => {
        var b;
        const d = (b = gn(p.clientX, p.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (_ = d, s({ a: y, b: d }));
      },
      end: () => {
        var b;
        s(null);
        const [p, d] = y <= _ ? [y, _] : [_, y];
        (b = e.onCreate) == null || b.call(e, { start: p, end: d, allDay: !0 });
      },
      cancel: () => s(null)
    });
  }, clickItem: (f, y) => {
    var _;
    if (o.current) {
      o.current = !1;
      return;
    }
    (_ = e.onEventClick) == null || _.call(e, y, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function qr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: s
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((o) => {
    var f;
    const l = o.item, c = l.ev, i = Wu(l), m = Ze(l.s - pe(l.sDay)), u = [
      S.chip,
      i ? S.bar : S.dotChip,
      Tn(c),
      o.contL ? S.contL : "",
      o.contR ? S.contR : "",
      ((f = s.preview) == null ? void 0 : f.id) === c.id ? S.ghost : "",
      an(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${o.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${o.col / t * 100}% + 2px)`,
          width: `calc(${o.span / t * 100}% - 4px)`,
          top: a + o.lane * mn,
          ...qn(c)
        },
        "aria-label": Mr(l, r.L),
        onPointerDown: (y) => s.onItemDown(y, l),
        onClick: (y) => s.clickItem(y.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !o.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Pn = 26;
function qd({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: s, showWeekends: o, holidays: l } = e, c = a.slice(0, 7), i = we(
    () => Ar(a, s).map(($) => o ? $ : $.filter((E) => !un(E))),
    [a, s, o]
  ), m = i[0].length, u = Tr(e), f = u.items(i[0][0], i[i.length - 1][m - 1]), y = L(null), [_, p] = A(0);
  qe(() => {
    const $ = y.current;
    if (!$) return;
    const E = () => p($.clientHeight / i.length);
    if (E(), typeof ResizeObserver == "undefined") return;
    const h = new ResizeObserver(E);
    return h.observe($), () => h.disconnect();
  }, [i.length]);
  const d = _ ? Math.max(1, Math.floor((_ - Pn - 4) / mn)) : 3, b = L(!1), w = L(null);
  Z(() => {
    var $, E;
    b.current && (b.current = !1, (E = ($ = w.current) == null ? void 0 : $.querySelector(`[data-cal-day="${a}"]`)) == null || E.focus());
  }, [a, c]);
  const N = ($, E) => {
    let h = ke($, E);
    for (; !o && un(h); ) h = ke(h, E > 0 ? 1 : -1);
    return h;
  }, k = ($, E, h) => {
    let g = null;
    if ($.key === "ArrowLeft") g = N(E, -1);
    else if ($.key === "ArrowRight") g = N(E, 1);
    else if ($.key === "ArrowUp") g = N(E, -7);
    else if ($.key === "ArrowDown") g = N(E, 7);
    else if ($.key === "Home") g = h[0];
    else if ($.key === "End") g = h[h.length - 1];
    else if ($.key === "Enter" || $.key === " ") {
      $.preventDefault(), e.goto("day", E);
      return;
    }
    g && ($.preventDefault(), b.current = !0, e.setCursor(g));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: w }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map(($) => {
    const E = Le(de($));
    return /* @__PURE__ */ n.createElement("div", { key: $, role: "columnheader", className: [S.wdName, E === 0 ? S.sun : "", E === 6 ? S.sat : ""].join(" ") }, t.weekdays[E]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: y }, i.map(($) => {
    const { shown: E, more: h } = Uu(Cr(f, $), m, d);
    return /* @__PURE__ */ n.createElement("div", { key: $[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, $.map((g) => {
      const x = de(g), C = Le(x), M = l[g], T = f.filter((q) => q.sDay <= g && q.eDay >= g).length, I = [
        S.cell,
        g.slice(0, 7) !== c ? S.out : "",
        C === 0 || M ? S.sun : C === 6 ? S.sat : "",
        g === r ? S.isToday : "",
        u.inSel(g) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: g,
          role: "gridcell",
          "data-cal-day": g,
          tabIndex: g === a ? 0 : -1,
          "aria-selected": g === a,
          "aria-current": g === r ? "date" : void 0,
          "aria-label": `${t.dayAria(g)}${M ? ` ${M}` : ""}, ${t.eventCount(T)}`,
          className: I,
          onPointerDown: (q) => u.onCellDown(q, g),
          onKeyDown: (q) => k(q, g, $)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(g),
            onPointerDown: (q) => q.stopPropagation(),
            onClick: () => e.goto("day", g)
          },
          x.d === 1 ? t.md(g) : x.d
        ), M && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: M }, M), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(qr, { segs: E, cols: m, top: Pn, ctx: e, drag: u }), h.map((g, x) => g > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: $[x],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${x / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: Pn + (d - 1) * mn
        },
        onClick: (C) => e.openMore($[x], C.currentTarget)
      },
      t.more(g)
    ) : null));
  })));
}
const Qe = 44, Bd = Array.from({ length: 23 }, (e, t) => t + 1);
function Sa() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Xn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Ce, (e - a.top) / Qe * 60));
}
function Ma({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, s = Tr(e), [o, l] = A(null), [c, i] = A(null), m = L(!1), u = Sn(e.events, t[0], t[a - 1], o != null ? o : s.preview), f = Cr(e.timeGrid ? u.filter(Dr) : u, t), y = f.reduce((E, h) => Math.max(E, h.lane + 1), 0), _ = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [p, d] = A(Sa);
  Z(() => {
    const E = window.setInterval(() => d(Sa()), 6e4);
    return () => window.clearInterval(E);
  }, []);
  const b = L(null), w = t.includes(e.today);
  qe(() => {
    const E = b.current;
    if (!E) return;
    const h = w ? Math.max(0, Math.floor((p - pe(e.today)) / 60) - 1) : e.scrollToHour;
    E.scrollTop = h * Qe;
  }, [t[0], a]);
  const N = (E, h) => {
    if (E.button !== 0 || !e.onCreate) return;
    E.preventDefault();
    const g = E.currentTarget, x = Math.min(Ce - r, Math.floor(Xn(E.clientY, g) / r) * r);
    let C = x;
    i({ day: h, a: x, b: x + r }), Nn(E, {
      move: (M) => {
        C = Math.min(Ce - r, Math.floor(Xn(M.clientY, g) / r) * r), i({ day: h, a: Math.min(x, C), b: Math.max(x, C) + r });
      },
      end: (M, T) => {
        var G;
        i(null);
        const I = pe(h), q = T ? Math.min(x, C) : x, X = T ? Math.max(x, C) + r : Math.min(x + 60, Ce);
        (G = e.onCreate) == null || G.call(e, { start: nn(I + q), end: nn(I + X), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, k = (E, h, g) => {
    if (E.stopPropagation(), E.button !== 0 || !an(e, h.ev)) return;
    const x = (T, I) => {
      const q = gn(T, I, "data-cal-col");
      return q ? pe(q.dataset.calCol) + Xn(I, q) : null;
    }, C = x(E.clientX, E.clientY);
    if (C == null) return;
    m.current = !1;
    let M = null;
    Nn(E, {
      move: (T) => {
        m.current = !0;
        const I = x(T.clientX, T.clientY);
        if (I != null) {
          if (g === "move") {
            const q = Aa(I - C, r);
            M = q ? Zn(h, q) : null;
          } else {
            const q = Math.max(h.s + r, Aa(I, r));
            M = q !== h.e ? { start: h.ev.start, end: nn(q) } : null;
          }
          l(M ? { id: h.ev.id, ...M } : null);
        }
      },
      end: (T, I) => {
        var q;
        l(null), I && M && ((q = e.onEventChange) == null || q.call(e, h.ev, M));
      },
      cancel: () => l(null)
    });
  }, $ = (E, h) => {
    var g;
    if (m.current) {
      m.current = !1;
      return;
    }
    (g = e.onEventClick) == null || g.call(e, h, E);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: _ }, t.map((E) => {
    const h = de(E), g = Le(h), x = e.holidays[E];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        className: [S.tDay, E === e.today ? S.isToday : "", g === 0 || x ? S.sun : g === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", E), "aria-label": e.L.openDay(E) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[g]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, h.d)),
      x && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: x }, x)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, y) * mn + 6 } : { minHeight: Math.max(1, y) * mn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: _ }, t.map((E) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        "data-cal-day": E,
        className: [S.allDayCell, s.inSel(E) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (h) => s.onCellDown(h, E)
      }
    ))),
    /* @__PURE__ */ n.createElement(qr, { segs: f, cols: a, top: 3, ctx: e, drag: s })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Qe } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, Bd.map((E) => /* @__PURE__ */ n.createElement("span", { key: E, style: { top: E * Qe } }, Ze(E * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ..._, backgroundSize: `100% ${Qe}px` } }, t.map((E) => {
    const h = Yu(u, E);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        "data-cal-col": E,
        className: [S.tCol, E === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (g) => N(g, E)
      },
      (c == null ? void 0 : c.day) === E && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Qe, height: (c.b - c.a) / 60 * Qe } }, Ze(c.a), " – ", c.b === Ce ? "24:00" : Ze(c.b)),
      h.map((g) => {
        const x = g.item.ev, C = (g.bottom - g.top) / 60 * Qe, M = [
          S.tEv,
          Tn(x),
          C < 34 ? S.tEvShort : "",
          g.contTop ? S.contTop : "",
          g.contBottom ? S.contBottom : "",
          (o == null ? void 0 : o.id) === x.id ? S.ghost : "",
          an(e, x) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: x.id,
            type: "button",
            className: M,
            style: {
              top: g.top / 60 * Qe,
              height: Math.max(18, C - 1),
              left: `calc(${g.col / g.cols * 100}% + 1px)`,
              width: `calc(${100 / g.cols}% - 4px)`,
              ...qn(x)
            },
            "aria-label": Mr(g.item, e.L),
            onPointerDown: (T) => k(T, g.item, "move"),
            onClick: (T) => $(T.currentTarget, x)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, x.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, da(g.item, e.L.allDay)),
          an(e, x) && !g.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (T) => k(T, g.item, "resize") })
        );
      }),
      E === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (p - pe(E)) / 60 * Qe }, "aria-hidden": !0 })
    );
  })))));
}
function Ta(e, t, a) {
  return e.sDay === e.eDay ? da(e, a) : e.allDay ? a : t === e.sDay ? `${Ze(e.s - pe(t))} ~` : t === e.eDay ? `~ ${Ze(e.e - pe(t))}` : a;
}
function Ld({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = ma("agenda", e.cursor, e.weekStartsOn), s = Sn(e.events, a, r), o = Mn(a, r).filter((l) => e.showWeekends || !un(l)).map((l) => {
    const c = pe(l), i = (u) => Ta(u, l, "") === "" ? -1 : Math.max(u.s, c), m = s.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, f) => i(u) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return o.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, o.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = Le(i), f = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, u === 0 || m ? S.sun : u === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", f)), m && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((y) => {
      const _ = y.ev, p = Ft(y.sDay, y.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: _.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, Tn(_)].join(" "),
          style: qn(_),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, _, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Ta(y, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, _.title, p > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Ft(y.sDay, l) + 1, p))),
        _.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, _.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const zn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function qa(e, t, a) {
  const [r, s] = A(t), o = e !== void 0 ? e : r;
  return [o, (c) => {
    e === void 0 && s(c), c !== o && (a == null || a(c));
  }];
}
const Ba = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function Sv({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: s,
  defaultDate: o,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: f,
  slotMinutes: y = 30,
  scrollToHour: _ = 8,
  timeGrid: p = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: w,
  onEventChange: N,
  locale: k = Sr,
  loading: $,
  headerExtra: E,
  className: h = "",
  style: g,
  "aria-label": x
}) {
  var Y;
  const C = Nr(), [M, T] = qa(t, (Y = a != null ? a : c[0]) != null ? Y : "month", r), [I, q] = qa(s, o != null ? o : C, l), X = de(I) ? I : C, [G, K] = A(m), [j, ne] = A(null), ae = L(null), v = L(!1);
  Z(() => {
    var H;
    if (!v.current) return;
    v.current = !1;
    const z = ae.current;
    !z || z.contains(document.activeElement) || ((H = z.querySelector('[data-cal-day][tabindex="0"]')) != null ? H : z).focus();
  });
  const { from: O, to: V } = ma(M, X, i), Q = L(d);
  Q.current = d, Z(() => {
    var z;
    (z = Q.current) == null || z.call(Q, { from: O, to: V, view: M });
  }, [O, V, M]);
  const se = (z, H) => {
    q(H), c.includes(z) && T(z);
  }, B = {
    events: e,
    L: k,
    cursor: X,
    today: C,
    weekStartsOn: i,
    showWeekends: G,
    holidays: f != null ? f : {},
    slotMinutes: y,
    scrollToHour: _,
    timeGrid: p,
    setCursor: q,
    goto: se,
    openMore: (z, H) => ne({ day: z, anchor: H }),
    onEventClick: b,
    onCreate: w,
    onEventChange: N
  }, J = (z) => q(Hu(M, X, z, M === "day" && !G)), R = (z) => {
    if (z.defaultPrevented || z.ctrlKey || z.metaKey || z.altKey || z.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const H = z.nativeEvent.code;
    if (H === "KeyT") q(C);
    else if (H === "KeyN" || H === "KeyJ" || z.key === "PageDown") J(1);
    else if (H === "KeyP" || H === "KeyK" || z.key === "PageUp") J(-1);
    else if (zn[H] && c.includes(zn[H])) T(zn[H]);
    else if (H === "KeyC" && w)
      w(M === "month" || M === "agenda" ? { start: X, end: X, allDay: !0 } : { start: `${X}T09:00`, end: `${X}T10:00`, allDay: !1 });
    else return;
    z.preventDefault(), v.current = !0;
  }, F = we(
    () => Mn(O, V).filter((z) => G || !un(z)),
    [O, V, G]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, h].filter(Boolean).join(" "),
      style: g,
      role: "region",
      "aria-label": x != null ? x : k.region,
      "aria-busy": $ || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: ae,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(ut, { onClick: () => q(C), title: `${k.today} (T)` }, k.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(Vn, { label: k.prev(M), onClick: () => J(-1) }, /* @__PURE__ */ n.createElement(Ba, { dir: "l" })), /* @__PURE__ */ n.createElement(Vn, { label: k.next(M), onClick: () => J(1) }, /* @__PURE__ */ n.createElement(Ba, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, Ku(M, X, i, k)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, E, u && M !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !G,
        onClick: () => K((z) => !z)
      },
      k.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      fr,
      {
        variant: "segmented",
        "aria-label": k.viewTabs,
        items: c.map((z) => ({ key: z, label: k.views[z] })),
        value: M,
        onChange: (z) => T(z)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, $ && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": k.loading }), M === "month" && /* @__PURE__ */ n.createElement(qd, { ctx: B }), M === "week" && /* @__PURE__ */ n.createElement(Ma, { ctx: B, days: F }), M === "day" && /* @__PURE__ */ n.createElement(Ma, { ctx: B, days: [X] }), M === "agenda" && /* @__PURE__ */ n.createElement(Ld, { ctx: B })),
    j && /* @__PURE__ */ n.createElement(jd, { ctx: B, day: j.day, anchor: j.anchor, onClose: () => ne(null) })
  );
}
function jd({ ctx: e, day: t, anchor: a, onClose: r }) {
  const s = L(null), [o, l] = A({ top: -9999, left: -9999 }), c = de(t), i = Sn(e.events, t, t);
  return qe(() => {
    var _;
    const m = s.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), f = m.offsetWidth, y = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - y - 8))
    }), (_ = m.querySelector("[data-cal-pop-item]")) == null || _.focus();
  }, [a]), Z(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (y) => {
      var _;
      (_ = s.current) != null && _.contains(y.target) || r();
    }, f = (y) => {
      y.key !== "Escape" || y.isComposing || (y.preventDefault(), y.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Ht, null, /* @__PURE__ */ n.createElement("div", { ref: s, className: S.pop, style: o, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Le(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((m) => {
    const u = m.ev, f = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, f ? S.bar : S.dotChip, Tn(u)].join(" "),
        style: qn(u),
        onClick: () => {
          var y;
          r(), (y = e.onEventClick) == null || y.call(e, u, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, Ze(Math.max(m.s, pe(t)) - pe(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, u.title)
    ));
  }))));
}
const Rd = "_mini_q7p5n_3", Id = "_nav_q7p5n_5", Od = "_navBtn_q7p5n_6", Pd = "_todayBtn_q7p5n_6", Xd = "_title_q7p5n_6", zd = "_day_q7p5n_25", Fd = "_mon_q7p5n_25", Wd = "_grid_q7p5n_29", Hd = "_wdRow_q7p5n_30", Kd = "_row_q7p5n_30", Ud = "_sun_q7p5n_35", Gd = "_sat_q7p5n_36", Yd = "_num_q7p5n_45", Vd = "_sel_q7p5n_46", Qd = "_out_q7p5n_50", Jd = "_isToday_q7p5n_52", Zd = "_dots_q7p5n_55", ef = "_months_q7p5n_59", le = {
  mini: Rd,
  nav: Id,
  navBtn: Od,
  todayBtn: Pd,
  title: Xd,
  day: zd,
  mon: Fd,
  grid: Wd,
  wdRow: Hd,
  row: Kd,
  sun: Ud,
  sat: Gd,
  num: Yd,
  sel: Vd,
  out: Qd,
  isToday: Jd,
  dots: Zd,
  months: ef
}, La = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function Mv({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: s = {},
  markLabel: o,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Sr,
  today: m,
  children: u,
  className: f = "",
  "aria-label": y
}) {
  const _ = m != null ? m : Nr(), p = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${_.slice(0, 7)}-01`, d = de(p), b = wn(p, c), w = Mn(b, ke(b, 41)), N = o != null ? o : i.eventCount, [k, $] = A("day"), [E, h] = A(d.y), g = (K) => !!K && K.slice(0, 7) === p.slice(0, 7), [x, C] = A(() => g(a) ? a : g(_) ? _ : p);
  Z(() => {
    g(x) || C(g(a) ? a : g(_) ? _ : p);
  }, [p]);
  const M = L(!1), T = L(null);
  Z(() => {
    var K, j;
    M.current && (M.current = !1, (j = (K = T.current) == null ? void 0 : K.querySelector(`[data-day="${x}"]`)) == null || j.focus());
  }, [x, p]);
  const I = (K) => {
    M.current = !0, C(K), g(K) || t(K.slice(0, 7));
  }, q = (K) => {
    const j = vt(d, K);
    t(La(j.y, j.m));
  }, X = (K, j) => {
    const ne = de(j), ae = (Le(ne) - c + 7) % 7;
    let v = null;
    if (K.key === "ArrowLeft") v = ke(j, -1);
    else if (K.key === "ArrowRight") v = ke(j, 1);
    else if (K.key === "ArrowUp") v = ke(j, -7);
    else if (K.key === "ArrowDown") v = ke(j, 7);
    else if (K.key === "Home") v = ke(j, -ae);
    else if (K.key === "End") v = ke(j, 6 - ae);
    else if (K.key === "PageUp" || K.key === "PageDown") {
      const O = vt(ne, K.key === "PageUp" ? -1 : 1);
      v = tt(O.y, O.m, O.d);
    }
    v && (K.preventDefault(), I(v));
  }, G = () => {
    h(d.y), $("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, f].filter(Boolean).join(" "), role: y ? "group" : void 0, "aria-label": y }, k === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => q(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(p)}, ${i.pickMonth}`, "aria-live": "polite", onClick: G }, i.ym(p)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => q(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: g(_),
      onClick: () => {
        t(_.slice(0, 7)), I(_);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => h((K) => K - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${E}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => h((K) => K + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => $("day"), "aria-label": i.close }, "✕")), k === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (K) => {
    K.key === "Escape" && (K.preventDefault(), $("day"));
  } }, Array.from({ length: 12 }, (K, j) => {
    const ne = La(E, j + 1), ae = ne === p.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, ae ? le.sel : "", ne === _.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": ae,
        autoFocus: ae,
        onClick: () => {
          t(ne), $("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(p), ref: T }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, w.slice(0, 7).map((K) => {
    const j = Le(de(K));
    return /* @__PURE__ */ n.createElement("span", { key: K, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((K) => /* @__PURE__ */ n.createElement("div", { key: K, className: le.row, role: "row" }, w.slice(K * 7, K * 7 + 7).map((j) => {
    var V;
    const ne = Le(de(j)), ae = l[j], v = (V = s[j]) != null ? V : 0, O = [
      le.day,
      g(j) ? "" : le.out,
      ne === 0 || ae ? le.sun : ne === 6 ? le.sat : "",
      j === _ ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: O,
        tabIndex: j === x ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === _ ? "date" : void 0,
        "aria-label": [i.dayAria(j), ae, v ? N(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => X(Q, j),
        onFocus: () => C(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), u);
}
function tf(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function Tv({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: s,
  className: o,
  ...l
}) {
  const c = L(null), i = L(null), [m, u] = A(!1), f = e == null || e === "";
  qe(() => {
    const _ = c.current, p = i.current;
    if (i.current = null, !_ || p === null) return;
    let d = 0, b = 0;
    for (; d < _.value.length && b < p; )
      /\d/.test(_.value[d]) && (b += 1), d += 1;
    d === 0 && _.value[0] === "-" && (d = 1), _.setSelectionRange(d, d);
  });
  const y = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: m && f ? "-" : ts(e),
      onChange: (_) => {
        var b;
        const p = _.target;
        i.current = tf(p.value.slice(0, (b = p.selectionStart) != null ? b : p.value.length));
        const d = Zr(p.value, a);
        if (r) {
          const w = ir(p.value);
          !a && /^\s*-/.test(w) ? r("sign") : (/\.\d/.test(w.replace(/^\s*-/, "")) || /\.$/.test(w)) && r("decimal");
        }
        u(d === "-"), t({ text: d, num: es(d) });
      }
    }
  );
  return s ? /* @__PURE__ */ n.createElement(n.Fragment, null, y, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, s)) : y;
}
function ea(e) {
  const t = ir(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function ja(e, t) {
  const a = ea(e), r = ea(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function qv(e, t) {
  var o, l;
  const a = ja(e.qty, e.unitAm), r = ja((o = t.qty) != null ? o : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const s = ea(e.lineAm);
  return s == null || s === a ? { ...t, lineAm: String(r) } : t;
}
const nf = "_box_qzg36_3", af = "_banner_qzg36_9", rf = "_verify_qzg36_10", sf = "_t_info_qzg36_15", of = "_t_warn_qzg36_16", lf = "_t_danger_qzg36_17", cf = "_error_qzg36_22", uf = "_note_qzg36_30", mf = "_noteI_qzg36_42", df = "_noteBody_qzg36_43", ff = "_badge_qzg36_49", _f = "_b_muted_qzg36_53", pf = "_b_ok_qzg36_54", yf = "_b_warn_qzg36_55", bf = "_b_info_qzg36_56", Ef = "_b_off_qzg36_57", ze = {
  box: nf,
  banner: af,
  verify: rf,
  t_info: sf,
  t_warn: of,
  t_danger: lf,
  error: cf,
  note: uf,
  noteI: mf,
  noteBody: df,
  badge: ff,
  b_muted: _f,
  b_ok: pf,
  b_warn: yf,
  b_info: bf,
  b_off: Ef
};
function hf({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [ze.box, ze.banner, ze[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function Bv({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [ze.box, ze.verify, ze[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Br({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [ze.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(gf, { text: t }) : t);
}
function Lv({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [ze.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: ze.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: ze.noteBody }, a));
}
function Ra({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", ze.badge, ze[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function gf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(Qr, { key: a }, t))) : null;
}
const vf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function kf(e, t = vf) {
  const a = L(e);
  return a.current = e, Z(() => {
    if (!e) return;
    const r = (s) => {
      s.preventDefault(), s.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), oe(() => !a.current || window.confirm(t), [t]);
}
const wf = "_overlay_1qt6w_2", Nf = "_modal_1qt6w_8", $f = "_wide_1qt6w_15", xf = "_head_1qt6w_16", Df = "_title_1qt6w_20", Af = "_close_1qt6w_21", Cf = "_body_1qt6w_25", Sf = "_flush_1qt6w_26", Mf = "_error_1qt6w_27", Tf = "_foot_1qt6w_29", Ye = {
  overlay: wf,
  modal: Nf,
  wide: $f,
  head: xf,
  title: Df,
  close: Af,
  body: Cf,
  flush: Sf,
  error: Mf,
  foot: Tf
}, St = [];
function Ia(e) {
  const t = St[St.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const qf = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Oa(e) {
  return Array.from(e.querySelectorAll(qf)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Pa = 0, Xa = "";
function Bn({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: s,
  headerExtra: o,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: m,
  confirmDiscard: u = !0
}) {
  const [f, y] = A(!1), _ = u ? () => {
    f || y(!0);
  } : void 0, p = kf(u && f, "입력한 내용을 저장하지 않고 닫을까요?"), d = () => {
    p() && t();
  }, b = L(d);
  b.current = d;
  const w = L({ close: () => b.current(), esc: i });
  w.current.esc = i, Z(() => {
    const h = w.current;
    return St.push(h), St.length === 1 && window.addEventListener("keydown", Ia), () => {
      const g = St.lastIndexOf(h);
      g >= 0 && St.splice(g, 1), St.length === 0 && window.removeEventListener("keydown", Ia);
    };
  }, []);
  const N = L(null), k = L(null), $ = L(void 0);
  $.current === void 0 && ($.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var x;
    const h = N.current, g = (x = $.current) != null ? x : null;
    return h && !h.contains(document.activeElement) && (k.current && Oa(k.current)[0] || null || h).focus(), Pa++ === 0 && (Xa = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Pa === 0 && (document.body.style.overflow = Xa), g && g.isConnected && typeof g.focus == "function" && g.focus();
    };
  }, []);
  const E = (h) => {
    const g = N.current;
    if (h.key !== "Tab" || !g || !g.contains(h.target)) return;
    const x = Oa(g);
    if (x.length === 0) {
      h.preventDefault(), g.focus();
      return;
    }
    const C = x[0], M = x[x.length - 1], T = document.activeElement;
    h.shiftKey && (T === C || T === g) ? (h.preventDefault(), M.focus()) : !h.shiftKey && T === M && (h.preventDefault(), C.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Ye.overlay, onClick: c ? d : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: N,
      tabIndex: -1,
      className: [Ye.modal, r ? Ye.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (h) => h.stopPropagation(),
      onKeyDown: E
    },
    /* @__PURE__ */ n.createElement("header", { className: Ye.head }, /* @__PURE__ */ n.createElement("strong", { className: Ye.title }, e), o, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ye.close, onClick: d, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: k,
        className: [Ye.body, l ? Ye.flush : ""].filter(Boolean).join(" "),
        onInputCapture: _,
        onChangeCapture: _
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Ye.error }, /* @__PURE__ */ n.createElement(Br, null, m)),
    s && /* @__PURE__ */ n.createElement("footer", { className: Ye.foot }, s)
  ));
}
function jv(e = 4e3) {
  const [t, a] = A(""), [r, s] = A(!1), o = L(void 0), l = oe((m) => {
    window.clearTimeout(o.current), s(!1), a(m), o.current = window.setTimeout(() => a(""), e);
  }, [e]), c = oe((m) => {
    window.clearTimeout(o.current), s(!0), a(m);
  }, []), i = oe(() => {
    window.clearTimeout(o.current), s(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const Bf = "_message_psco6_1", Lf = "_details_psco6_2", jf = "_warn_psco6_7", Rf = "_field_psco6_8", yn = {
  message: Bf,
  details: Lf,
  warn: jf,
  field: Rf
};
function Rv() {
  var _, p;
  const [e, t] = A(null), [a, r] = A(""), s = L(null), o = L(null), l = L(null), c = oe((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = oe((d) => new Promise((b) => {
    var w, N, k, $;
    r(($ = (k = d.defaultValue) != null ? k : (N = (w = d.choices) == null ? void 0 : w[0]) == null ? void 0 : N.value) != null ? $ : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  Z(() => {
    var d, b, w;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = o.current) == null || b.focus() : (w = s.current) == null || w.focus());
  }, [e]);
  const m = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), y = e && u ? /* @__PURE__ */ n.createElement(
    Bn,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(ut, { ref: o, onClick: () => m(!1) }, (_ = u.cancelLabel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(
        ut,
        {
          ref: s,
          variant: u.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => m(!0)
        },
        (p = u.confirmLabel) != null ? p : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: yn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: yn.details }, u.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: yn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: yn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: y };
}
function Iv(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + If(e);
}
function If(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function Ov() {
  const [e, t] = A(!1), a = L(!1), r = oe(async (s) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await s();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function Pv(e, t, a, r) {
  const [s, o] = A(null), [l, c] = A(a), [i, m] = A(null), [u, f] = A(!1), [y, _] = A(0), p = L(0), d = L(r);
  d.current = r;
  const b = oe(() => _((w) => w + 1), []);
  return Z(() => {
    if (!a) return;
    const w = ++p.current;
    return c(!0), e().then((N) => {
      w === p.current && (o(N), m(null), f(!1));
    }).catch((N) => {
      var k, $, E;
      w === p.current && (m(d.current.errorText(N)), f((E = ($ = (k = d.current).isUnavailable) == null ? void 0 : $.call(k, N)) != null ? E : !1));
    }).finally(() => {
      w === p.current && c(!1);
    }), () => {
      p.current++;
    };
  }, [a, y, ...t]), { data: s, loading: l, error: i, unavailable: u, reload: b };
}
function Xv(e) {
  const [t, a] = A(null), [r, s] = A(null), [o, l] = A(!1), [c, i] = A(1), m = L(0), u = L(e);
  u.current = e;
  const f = oe(async (_, p) => {
    const d = ++m.current;
    l(!0), s(null);
    try {
      const b = await p(_);
      if (d !== m.current) return;
      a(b), i(_);
    } catch (b) {
      if (d !== m.current) return;
      a(null), s(u.current.errorText(b));
    } finally {
      d === m.current && l(!1);
    }
  }, []), y = oe(() => {
    m.current++, a(null), s(null), l(!1);
  }, []);
  return { data: t, err: r, loading: o, page: c, load: f, clear: y };
}
const Of = "_section_dyrr7_3", Pf = "_row_dyrr7_10", Xf = "_label_dyrr7_15", zf = "_value_dyrr7_21", Ff = "_invalid_dyrr7_43", Wf = "_help_dyrr7_45", Hf = "_err_dyrr7_45", Kf = "_req_dyrr7_49", Uf = "_opt_dyrr7_50", Gf = "_sr_dyrr7_51", Yf = "_ro_dyrr7_10", Vf = "_readonly_dyrr7_58", Qf = "_hint_dyrr7_65", Jf = "_toggle_dyrr7_73", Zf = "_table_dyrr7_80", e_ = "_isReq_dyrr7_95", Ae = {
  section: Of,
  row: Pf,
  label: Xf,
  value: zf,
  invalid: Ff,
  help: Wf,
  err: Hf,
  req: Kf,
  opt: Uf,
  sr: Gf,
  ro: Yf,
  readonly: Vf,
  hint: Qf,
  toggle: Jf,
  table: Zf,
  isReq: e_
};
let t_ = 0;
const n_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function zv({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: s,
  required: o,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var E, h, g, x;
  const u = L(`axe-fr${++t_}`).current, f = `${u}-lbl`, y = L(null), _ = c ? `${u}-help` : void 0, p = i ? `${u}-err` : void 0, d = [_, p].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let w = t;
  const N = Yn.count(t) === 1 ? Yn.toArray(t)[0] : null, k = on(N) && typeof N.type != "string" && !!N.type.axeFormControl;
  if (on(N) && (typeof N.type == "string" && n_.has(N.type) || k)) {
    const C = N, M = C.props;
    w = oa(C, {
      id: (E = M.id) != null ? E : s,
      "aria-describedby": (h = M["aria-describedby"]) != null ? h : d,
      "aria-invalid": (g = M["aria-invalid"]) != null ? g : i ? !0 : void 0,
      "aria-required": (x = M["aria-required"]) != null ? x : o ? !0 : void 0
    });
  }
  qe(() => {
    var I;
    const C = (I = y.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const M = (q, X) => {
      const G = `data-fr-${q}`;
      if (X == null) {
        C.hasAttribute(G) && (C.removeAttribute(q), C.removeAttribute(G));
        return;
      }
      C.hasAttribute(q) && !C.hasAttribute(G) || (C.getAttribute(q) !== X && C.setAttribute(q, X), C.setAttribute(G, ""));
    }, T = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    M("aria-labelledby", T ? null : f), M("aria-invalid", i ? "true" : null), M("aria-required", o ? "true" : null), M("aria-describedby", d != null ? d : null);
  });
  const $ = /* @__PURE__ */ n.createElement(n.Fragment, null, e, o && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ae.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ae.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ae.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ae.row, r ? Ae.ro : "", i ? Ae.invalid : "", o ? Ae.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ae.label}` }, s ? /* @__PURE__ */ n.createElement("label", { htmlFor: s, id: f }, $) : /* @__PURE__ */ n.createElement("span", { id: f }, $), a && /* @__PURE__ */ n.createElement(Bt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ae.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: y, className: `axe-form-value ${Ae.value}` }, w, c && /* @__PURE__ */ n.createElement("span", { id: _, className: Ae.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: p, className: Ae.err }, i)));
}
function Fv({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ae.table}` : "", Ae.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function Wv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ae.readonly }, e);
}
function Hv({ checked: e, onChange: t, disabled: a, label: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ae.toggle, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (o) => t(o.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const a_ = "_mono_6omzf_2", r_ = "_invalid_6omzf_3", s_ = "_qty_6omzf_6", o_ = "_qtyInput_6omzf_7", l_ = "_unit_6omzf_8", c_ = "_note_6omzf_9", i_ = "_qtyErr_6omzf_10", ht = {
  mono: a_,
  invalid: r_,
  qty: s_,
  qtyInput: o_,
  unit: l_,
  note: c_,
  qtyErr: i_
};
function u_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: s,
  mono: o,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": f,
  "aria-invalid": y,
  "aria-required": _,
  className: p = ""
}) {
  const d = [o ? ht.mono : "", l ? ht.invalid : "", p].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: s,
    disabled: a,
    "aria-label": m,
    "aria-describedby": f,
    "aria-invalid": y != null ? y : l || void 0,
    "aria-required": _,
    onChange: (w) => t(w.target.value === "" ? null : w.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
u_.axeFormControl = !0;
function m_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: s,
    label: o,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u
  } = e, f = (_) => {
    e.codeType === "string" ? e.onChange(_ === "" ? null : _) : e.onChange(_ === "" ? null : Number(_));
  }, y = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      value: t == null ? "" : String(t),
      disabled: s,
      "aria-label": o,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (_) => f(_.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    y.map(([_, p]) => /* @__PURE__ */ n.createElement("option", { key: _, value: String(_) }, p))
  );
}
m_.axeFormControl = !0;
function d_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const f_ = /^-?(\d+\.?\d*|\.\d+)$/;
function Jt(e) {
  const t = d_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!f_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function $n(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const s = t.slice(0, a), o = s.indexOf(".");
    return (o >= 0 ? s.length - o - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Lr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if ($n(e) <= a) return e;
  const r = e < 0 ? -1 : 1, s = Math.abs(e).toFixed(Math.min(20, $n(e))), o = Math.round(+`${s}e${a}`), l = r * +`${o}e-${a}`;
  return l === 0 ? 0 : l;
}
function Rt(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function __(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function p_(e, t, a, r, s, o) {
  let l = e == null ? s != null ? s : 0 : Lr(e + a * t, Math.max(r, $n(t)));
  return s != null && l < s && (l = s), o != null && l > o && (l = o), l;
}
const y_ = 2500;
function b_({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: s,
  step: o,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": f,
  "aria-required": y,
  width: _,
  onEnter: p,
  onInvalidChange: d,
  placeholder: b,
  className: w = ""
}) {
  const [N, k] = A(() => Rt(e)), [$, E] = A(!1), [h, g] = A(null), [x, C] = A(!1), M = L(null), T = L(N);
  T.current = N, Z(() => {
    const v = Jt(T.current), O = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    O !== void 0 && O === (e != null ? e : null) || k(Rt(e));
  }, [e]), Z(() => () => {
    M.current && clearTimeout(M.current);
  }, []);
  const I = Jt(N), q = I.kind === "bad" || I.kind === "partial";
  Z(() => {
    q || C(!1);
  }, [q]);
  const X = L(d);
  X.current = d, Z(() => {
    var v;
    (v = X.current) == null || v.call(X, q);
  }, [q]), Z(() => () => {
    var v;
    (v = X.current) == null || v.call(X, !1);
  }, []);
  const G = (v) => {
    M.current && clearTimeout(M.current), g(v), M.current = setTimeout(() => g(null), y_);
  }, K = (v) => {
    k(v);
    const O = Jt(v);
    O.kind === "empty" ? t(null) : O.kind === "num" && t(O.value);
  }, j = () => {
    const v = Jt(N);
    if (v.kind !== "num") return;
    if ($n(v.value) > a) {
      const V = Lr(v.value, a);
      k(Rt(V)), t(V), G(`반올림했습니다 → ${Rt(V)}`);
      return;
    }
    const O = Rt(v.value);
    O !== N && k(O);
  }, ne = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (q) {
          C(!0);
          return;
        }
        j(), p == null || p();
        return;
      }
      if (o && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const O = Jt(N), V = O.kind === "num" ? O.value : O.kind === "empty" ? null : e, Q = p_(V, o, v.key === "ArrowUp" ? 1 : -1, a, r, s);
        k(Rt(Q)), t(Q);
      }
    }
  }, ae = I.kind === "bad" || I.kind === "partial" && (!$ || x) || I.kind === "num" && __(I.value, r, s);
  return /* @__PURE__ */ n.createElement("span", { className: [ht.qty, w].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [ht.qtyInput, ae ? ht.invalid : ""].filter(Boolean).join(" "),
      style: _ != null ? { width: _, maxWidth: "none" } : void 0,
      value: N,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": f != null ? f : ae || void 0,
      "aria-required": y,
      onChange: (v) => K(v.target.value),
      onFocus: () => E(!0),
      onBlur: () => {
        E(!1), j();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: ht.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!$ || x)) && /* @__PURE__ */ n.createElement("span", { className: ht.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: ht.note, role: "status", "aria-live": "polite" }, h));
}
b_.axeFormControl = !0;
function E_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function h_(e, t) {
  var s;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((s = e != null ? e : t) != null ? s : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((o) => {
    E_(e[o], t[o]) || r.push(o);
  }), r;
}
function g_(e, t) {
  return e === null || t === null ? e === t : h_(e, t).length === 0;
}
function Kv() {
  const [e, t] = A(null), [a, r] = A(!1), [s, o] = A(null), l = we(() => a || !g_(s, e), [a, s, e]), c = oe((_) => {
    t((p) => p === null ? p : { ...p, ..._ });
  }, []), i = oe((_, p) => {
    t((d) => d === null ? d : { ...d, [_]: p });
  }, []), m = L(null), u = oe((_) => {
    m.current = _, t(_), o(_), r(!1);
  }, []), f = oe((_) => {
    m.current = _, t(_), o(_), r(!0);
  }, []), y = oe(() => t(m.current), []);
  return we(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: f, reset: y, snapshot: s }),
    [e, a, l, i, c, u, f, y, s]
  );
}
function Uv() {
  const e = L(!1), [t, a] = A(!1), r = oe(async (s) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await s();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const v_ = "_panel_1w7xx_2", k_ = "_band_1w7xx_7", w_ = "_chev_1w7xx_11", N_ = "_title_1w7xx_17", $_ = "_note_1w7xx_19", x_ = "_chip_1w7xx_21", D_ = "_other_1w7xx_32", A_ = "_reset_1w7xx_33", C_ = "_form_1w7xx_42", at = {
  panel: v_,
  band: k_,
  chev: w_,
  title: N_,
  note: $_,
  chip: x_,
  other: D_,
  reset: A_,
  form: C_
};
function Gv({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: s = "상세검색",
  title: o = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const f = L(null);
  if (i && !a && e.length === 0) return null;
  const y = (p, d = 0) => {
    var $, E, h;
    const b = ($ = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? $ : f.current, w = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), N = (h = w && ((E = w[p]) != null ? E : w[p - 1])) != null ? h : b == null ? void 0 : b.querySelector("button[aria-expanded]"), k = !document.activeElement || document.activeElement === document.body;
    N && N !== document.activeElement && (d === 0 || k) && N.focus(), d < 4 && setTimeout(() => y(p, d + 1), 250);
  }, _ = (p) => {
    e[p].onClear(), requestAnimationFrame(() => y(p));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [at.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: at.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: at.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", s), o !== null && /* @__PURE__ */ n.createElement("span", { className: at.title, "aria-live": "polite" }, o, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((p, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: p.key, className: [at.chip, p.tone === "other" ? at.other : ""].filter(Boolean).join(" ") }, p.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = p.label) != null ? b : typeof p.text == "string" ? p.text : "조건"} 해제`,
        onClick: () => _(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: at.reset, onClick: () => {
    t(), requestAnimationFrame(() => y(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: at.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: at.form }, c));
}
const S_ = "_zone_1y6sp_2", M_ = "_drag_1y6sp_8", T_ = "_busy_1y6sp_9", q_ = "_attached_1y6sp_10", B_ = "_left_1y6sp_12", L_ = "_icon_1y6sp_13", j_ = "_title_1y6sp_18", R_ = "_desc_1y6sp_19", I_ = "_right_1y6sp_20", O_ = "_count_1y6sp_21", P_ = "_pick_1y6sp_22", We = {
  zone: S_,
  drag: M_,
  busy: T_,
  attached: q_,
  left: B_,
  icon: L_,
  title: j_,
  desc: R_,
  right: I_,
  count: O_,
  pick: P_
};
function X_({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: s,
  multiple: o = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = L(null), [f, y] = A(!1), _ = (p) => {
    !p || p.length === 0 || l || e(Array.from(p));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [We.zone, f ? We.drag : "", l ? We.busy : "", c ? We.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var p;
        l || (p = u.current) == null || p.click();
      },
      onDragOver: (p) => {
        p.preventDefault(), l || y(!0);
      },
      onDragLeave: () => y(!1),
      onDrop: (p) => {
        p.preventDefault(), y(!1), _(p.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: We.left }, /* @__PURE__ */ n.createElement("div", { className: We.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: We.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: We.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: We.right }, r && /* @__PURE__ */ n.createElement("span", { className: We.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: We.pick,
        disabled: l,
        onClick: (p) => {
          var d;
          p.stopPropagation(), (d = u.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: s,
        multiple: o,
        hidden: !0,
        onChange: (p) => {
          _(p.target.files), p.target.value = "";
        }
      }
    ))
  );
}
function z_(e, t) {
  var o, l;
  const a = (o = e.headers.get("Content-Disposition")) != null ? o : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const s = /filename="?([^";]+)"?/i.exec(a);
  return (l = s == null ? void 0 : s[1]) != null ? l : t;
}
function jr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function Yv(e, t, a) {
  jr(await e.blob(), a != null ? a : z_(e, t));
}
const F_ = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, W_ = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Rr(e, t = {}) {
  var s, o;
  const a = e.trim();
  if (t.parenNegative) {
    const l = W_.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(s = l[2]) != null ? s : ""}`;
  }
  const r = F_.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((o = r[3]) != null ? o : "") : null;
}
function Xt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function H_(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => En(Xt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let s = null;
  const o = (l) => {
    var i;
    const c = K_(l, e);
    !c || c === s || (s = c, a.length > r && a.push(""), a.push(En(Xt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var _;
    if (l.tagName !== "TABLE") {
      if ((_ = l.parentElement) != null && _.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const p = U_(l, t);
      if (!p) return;
      o(l), a.push(p.map(En).join(","));
      return;
    }
    const c = l;
    o(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, f = u >= 0 && !!c.querySelector("[data-csv-path]"), y = [];
    Array.from(c.rows).forEach((p) => {
      if (p.hasAttribute("data-state") || p.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const w = () => {
        for (; y[b] && y[b].n > 0; )
          y[b].n -= 1, y[b].skip || d.push(""), b += 1;
      };
      Array.from(p.cells).forEach((N) => {
        var g, x;
        w();
        const k = Y_(N), $ = k ? "" : V_(N, t), E = Math.max(1, N.colSpan || 1), h = Math.max(1, N.rowSpan || 1);
        for (let C = 0; C < E; C += 1)
          k || d.push(C === 0 ? $ : ""), y[b] = { n: h - 1, skip: k }, b += 1;
        if (u >= 0 && N.cellIndex === u) {
          const C = N.querySelector("[data-tree-depth]");
          C ? (d.push(String(Number(C.getAttribute("data-tree-depth")) + 1)), f && d.push(Xt((g = C.getAttribute("data-csv-path")) != null ? g : ""))) : ((x = p.parentElement) == null ? void 0 : x.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), w(), d.some((N) => N !== "") && a.push(d.map(En).join(","));
    });
  }), a.join(`\r
`);
}
function K_(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function U_(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), s = e.querySelector("[data-csv-unit]"), o = s ? bn(s) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? bn(a) : "");
  if (!c) return null;
  o && (c = `${c} (${o})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((y) => y.remove()), i = bn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((y) => y.remove()), i = bn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Xt(c), (u = Rr(i, t)) != null ? u : Xt(i)];
}
function bn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function G_(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  jr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function Y_(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function V_(e, t) {
  var s, o, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((o = (s = a.innerText) != null ? s : a.textContent) != null ? o : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Rr(r, t)) != null ? l : Xt(r);
}
function En(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const Q_ = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function Vv({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: s, prepare: o, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    Vn,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        o && (c = await o(), await Q_());
        try {
          const i = e.current;
          if (!i) return;
          G_(H_(i, { parenNegative: s, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(ln, { name: "download", size: 14 }),
    "CSV"
  );
}
const J_ = "_root_kpw7f_1", Z_ = "_guide_kpw7f_2", ep = "_tpl_kpw7f_3", Fn = {
  root: J_,
  guide: Z_,
  tpl: ep
};
function Qv({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: s,
  maxBytes: o,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: m = "CSV 파일",
  pickLabel: u = "파일 선택",
  busyReason: f,
  className: y = ""
}) {
  const _ = (d) => {
    var w;
    const b = (w = d[0]) != null ? w : null;
    if (b && o !== void 0 && b.size > o) {
      l == null || l(b);
      return;
    }
    s(b);
  }, p = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Fn.root, y].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(hf, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Fn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Fn.tpl }, /* @__PURE__ */ n.createElement(ut, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    X_,
    {
      title: m,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: p,
      accept: i,
      multiple: !1,
      disabled: !!f,
      pickLabel: u,
      onFiles: _
    }
  ));
}
const tp = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function Jv({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Ra, { tone: tp[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Ra, null, String(t));
}
const za = "axerp-form-modal";
function Zv({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: s,
  submitLabel: o,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: m,
  children: u
}) {
  var y, _, p;
  const f = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    Bn,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: s,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(ut, { onClick: t, disabled: r }, (y = i == null ? void 0 : i.cancel) != null ? y : "취소"), /* @__PURE__ */ n.createElement(ut, { type: "submit", form: za, variant: "primary", blockedReason: r ? (_ = i == null ? void 0 : i.saving) != null ? _ : "저장 중입니다" : l }, (p = o != null ? o : i == null ? void 0 : i.save) != null ? p : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: za, className: m, onSubmit: f, noValidate: !0 }, u)
  );
}
const np = { left: "axe-l", center: "axe-c", right: "axe-r" };
function Fa(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const Wa = (e) => {
  var t;
  return np[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function e0({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: s = null,
  emptyText: o = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: m,
  grow: u = !1,
  growClassName: f,
  pagination: y
}) {
  const _ = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(ac, { grow: u, className: u ? f : void 0, cols: e.map((p) => p.width), busy: r, title: m, pagination: y }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((p) => /* @__PURE__ */ n.createElement("th", { key: p.key, className: Wa(p) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: Fa }, p.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    Ec,
    {
      colSpan: e.length,
      loading: r,
      error: s,
      count: t ? _.length : null,
      empty: o,
      idle: null
    }
  ), _.map((p, d) => {
    var N;
    const b = a(p), w = [c ? "axe-clickable" : "", l === b ? "axe-sel" : "", (N = i == null ? void 0 : i(p)) != null ? N : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: b,
        className: w || void 0,
        onClick: c ? () => c(p) : void 0,
        ...c ? hc(() => c(p), l === void 0 ? void 0 : l === b) : {}
      },
      e.map((k) => /* @__PURE__ */ n.createElement("td", { key: k.key, className: Wa(k), onMouseEnter: Fa }, k.render(p, d)))
    );
  })));
}
function t0({ title: e, info: t, badge: a, notice: r, actions: s, minWidth: o, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(ls, { style: { height: "100%" }, minWidth: o }, /* @__PURE__ */ n.createElement(Cs, { title: e, info: t, badge: a, notice: r }, s), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const ap = "_card_1adld_1", rp = "_sub_1adld_2", sp = "_state_1adld_3", op = "_list_1adld_7", lp = "_row_1adld_8", cp = "_warn_1adld_20", ip = "_danger_1adld_21", Nt = {
  card: ap,
  sub: rp,
  state: sp,
  list: op,
  row: lp,
  warn: cp,
  danger: ip
};
function n0({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: s,
  onRetry: o,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    vr,
    {
      flush: !0,
      className: [Nt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: Nt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: Nt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: Nt.state }, /* @__PURE__ */ n.createElement(Br, null, s != null ? s : "불러오지 못했습니다"), o && /* @__PURE__ */ n.createElement(la, { onClick: o }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: Nt.list }, c.map((m, u) => {
      var _, p;
      const f = [Nt.row, m.tone ? Nt[m.tone] : ""].filter(Boolean).join(" "), y = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (_ = m.key) != null ? _ : u, className: f, onClick: m.onClick }, y) : /* @__PURE__ */ n.createElement("div", { key: (p = m.key) != null ? p : u, className: f }, y);
    }))
  );
}
function up(e, t, a, r, s) {
  const o = Math.max(0, Math.floor(e));
  if (o === 0) return 1;
  const l = Math.max(1, Math.min(o, s != null && s > 0 ? Math.floor(s) : o)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(o / c);
  return Math.ceil(o / i);
}
const mp = "_group_16rha_1", dp = "_tile_16rha_2", fp = "_click_16rha_9", _p = "_ok_16rha_12", pp = "_warn_16rha_13", yp = "_danger_16rha_14", bp = "_info_16rha_15", Ep = "_accent_16rha_16", hp = "_muted_16rha_17", gp = "_label_16rha_18", vp = "_value_16rha_20", kp = "_desc_16rha_25", xt = {
  group: mp,
  tile: dp,
  click: fp,
  ok: _p,
  warn: pp,
  danger: yp,
  info: bp,
  accent: Ep,
  muted: hp,
  label: gp,
  value: vp,
  desc: kp
};
function a0({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: s = "info",
  onClick: o,
  className: l = ""
}) {
  const c = [xt.tile, xt[s], o ? xt.click : "", l].filter(Boolean).join(" "), i = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: xt.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: xt.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: xt.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return o ? /* @__PURE__ */ n.createElement("button", { type: "button", className: c, onClick: o, "data-csv-kv": "" }, i) : /* @__PURE__ */ n.createElement("div", { className: c, "data-csv-kv": "" }, i);
}
const wp = 150, Np = 12, $p = 8;
function r0({ children: e, columns: t, className: a = "" }) {
  const r = L(null), s = Yn.toArray(e).filter(on).length, o = t != null || s <= $p, [l, c] = A(null);
  qe(() => {
    const u = r.current;
    if (!o || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(u.clientWidth));
    return f.observe(u), () => f.disconnect();
  }, [o]);
  const i = o ? up(s, l != null ? l : Number.MAX_SAFE_INTEGER, wp, Np, t) : 0, m = o ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [xt.group, a].filter(Boolean).join(" "), style: m }, e);
}
const xp = "_card_1lav2_1", Dp = "_n_1lav2_2", Ap = "_list_1lav2_7", Cp = "_row_1lav2_8", Sp = "_go_1lav2_15", Mp = "_name_1lav2_16", Tp = "_empty_1lav2_17", qp = "_star_1lav2_18", Bp = "_clear_1lav2_27", Ve = {
  card: xp,
  n: Dp,
  list: Ap,
  row: Cp,
  go: Sp,
  name: Mp,
  empty: Tp,
  star: qp,
  clear: Bp
};
function s0({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: s = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: o = ""
}) {
  const [l, c] = A("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    vr,
    {
      flush: !0,
      className: [Ve.card, o].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        fr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (m) => c(m),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ve.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ve.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(la, { className: Ve.clear, onClick: r }, "목록 비우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Ve.list }, i.map((m) => /* @__PURE__ */ n.createElement("li", { key: m.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.row, onClick: () => a(m) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ve.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Ve.name }, m.label))))) : /* @__PURE__ */ n.createElement("div", { className: Ve.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ve.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? s : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Ha(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Wn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function o0({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, s] = A(() => Ha(e)), [o, l] = A(() => Ha(t)), c = oe((f) => r.some((y) => y.path === f), [r]), i = oe((f) => s((y) => {
    const _ = y.some((p) => p.path === f.path) ? y.filter((p) => p.path !== f.path) : [...y, f];
    return Wn(e, _), _;
  }), [e]), m = oe((f) => l((y) => {
    const _ = [f, ...y.filter((p) => p.path !== f.path)].slice(0, a);
    return Wn(t, _), _;
  }), [t, a]), u = oe(() => {
    l([]), Wn(t, []);
  }, [t]);
  return { mine: r, recent: o, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const Lp = "_banner_7tqhk_2", jp = "_heading_7tqhk_7", Rp = "_sparkleBox_7tqhk_8", Ip = "_eyebrow_7tqhk_12", Op = "_headline_7tqhk_13", Pp = "_desc_7tqhk_15", Xp = "_err_7tqhk_16", zp = "_chips_7tqhk_18", Fp = "_footer_7tqhk_28", Wp = "_kicker_7tqhk_35", Hp = "_list_7tqhk_36", Kp = "_row_7tqhk_37", Up = "_icon_7tqhk_39", Gp = "_text_7tqhk_40", Yp = "_cap_7tqhk_41", Vp = "_body_7tqhk_43", Qp = "_reason_7tqhk_44", Jp = "_empty_7tqhk_45", ye = {
  banner: Lp,
  heading: jp,
  sparkleBox: Rp,
  eyebrow: Ip,
  headline: Op,
  desc: Pp,
  err: Xp,
  chips: zp,
  footer: Fp,
  kicker: Wp,
  list: Hp,
  row: Kp,
  icon: Up,
  text: Gp,
  cap: Yp,
  body: Vp,
  reason: Qp,
  empty: Jp
};
function Ka({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function l0({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: s,
  maxChips: o = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: f = ""
}) {
  const y = s.slice(0, o), _ = s.length - y.length;
  return /* @__PURE__ */ n.createElement("section", { className: [ye.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ye.heading }, /* @__PURE__ */ n.createElement("span", { className: ye.sparkleBox }, /* @__PURE__ */ n.createElement(Ka, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: ye.eyebrow }, /* @__PURE__ */ n.createElement(Ka, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: ye.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [ye.desc, r ? ye.err : ""].filter(Boolean).join(" ") }, a) : null)), s.length > 0 && /* @__PURE__ */ n.createElement("div", { className: ye.chips }, y.map((p) => /* @__PURE__ */ n.createElement("button", { type: "button", key: p.key, title: p.label, onClick: () => l(p.key) }, /* @__PURE__ */ n.createElement("i", { style: p.color ? { background: p.color } : void 0, "aria-hidden": "true" }), p.label, " ", /* @__PURE__ */ n.createElement("strong", { style: p.color ? { color: p.color } : void 0 }, p.count, "건"))), _ > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", _, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: ye.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? ye.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(la, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Zp({ items: e, onRun: t, onSkip: a, busy: r, emptyText: s = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: ye.empty }, s) : /* @__PURE__ */ n.createElement("ul", { className: ye.list }, e.map((o) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: o.id, className: ye.row }, /* @__PURE__ */ n.createElement("span", { className: ye.icon, "aria-hidden": "true" }, (l = o.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: ye.text }, /* @__PURE__ */ n.createElement("div", { className: ye.cap }, o.title, o.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", o.meta) : null), /* @__PURE__ */ n.createElement("div", { className: ye.body }, o.body), o.reason ? /* @__PURE__ */ n.createElement("div", { className: ye.reason }, o.reason) : null), /* @__PURE__ */ n.createElement(ut, { variant: "primary", disabled: r, onClick: () => t(o) }, (c = o.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(ut, { disabled: r, onClick: () => a(o) }, "무시"));
  }));
}
function c0({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: s, onSkip: o }) {
  const l = L(!1), [c, i] = A(!1), [m, u] = A(""), f = async (y) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await y();
      } catch {
        u("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    Bn,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: ye.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(ut, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(Zp, { items: a, busy: c, onRun: (y) => f(() => s(y)), onSkip: (y) => f(() => o(y)) })
  );
}
const ey = "_wrap_1wvdc_2", ty = "_header_1wvdc_7", ny = "_iconBox_1wvdc_8", ay = "_headText_1wvdc_12", ry = "_eyebrow_1wvdc_13", sy = "_headline_1wvdc_14", oy = "_headerExtra_1wvdc_16", ly = "_grid_1wvdc_19", cy = "_card_1wvdc_20", iy = "_badge_1wvdc_29", uy = "_toneRed_1wvdc_33", my = "_toneViolet_1wvdc_34", dy = "_toneGreen_1wvdc_35", fy = "_toneBlue_1wvdc_36", _y = "_title_1wvdc_38", py = "_summary_1wvdc_42", yy = "_action_1wvdc_46", by = "_notice_1wvdc_53", Ey = "_err_1wvdc_56", fe = {
  wrap: ey,
  header: ty,
  iconBox: ny,
  headText: ay,
  eyebrow: ry,
  headline: sy,
  headerExtra: oy,
  grid: ly,
  card: cy,
  badge: iy,
  toneRed: uy,
  toneViolet: my,
  toneGreen: dy,
  toneBlue: fy,
  title: _y,
  summary: py,
  action: yy,
  notice: by,
  err: Ey
};
function Ua({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const hy = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function i0({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: s,
  loading: o,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(Ua, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, s) : null, e.length === 0 ? s ? null : o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((m) => {
    var u, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: fe.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, hy[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(Ua, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (f = m.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const gy = "_wrapper_wrch3_1", vy = "_searchIcon_wrch3_18", ky = "_input_wrch3_26", wy = "_clearButton_wrch3_40", Ny = "_hint_wrch3_60", Zt = {
  wrapper: gy,
  searchIcon: vy,
  input: ky,
  clearButton: wy,
  hint: Ny
}, $y = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function xy({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: s,
  onClear: o
}) {
  const l = (c) => {
    c.key === "Enter" && (s == null || s());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Zt.wrapper }, /* @__PURE__ */ n.createElement("span", { className: Zt.searchIcon }, $y), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: Zt.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), o && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Zt.clearButton,
      onClick: o,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: Zt.hint }, r));
}
const Dy = "_screen_1bsma_1", Ay = "_shell_1bsma_8", Cy = "_command_1bsma_10", Sy = "_body_1bsma_20", My = "_overview_1bsma_22", Ty = "_areaHead_1bsma_25", Ot = {
  screen: Dy,
  shell: Ay,
  command: Cy,
  body: Sy,
  overview: My,
  areaHead: Ty
};
function u0({ search: e, panel: t, children: a, className: r = "" }) {
  var s;
  return /* @__PURE__ */ n.createElement("main", { className: [Ot.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Ot.shell }, e && /* @__PURE__ */ n.createElement("div", { className: Ot.command }, /* @__PURE__ */ n.createElement(
    xy,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (s = e.hint) != null ? s : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: Ot.body }, a)));
}
function m0({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Ot.overview, t].filter(Boolean).join(" ") }, e);
}
function d0({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: Ot.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const qy = "_group_oodts_1", By = "_grid_oodts_7", Ly = "_row_oodts_8", jy = "_item_oodts_9", Ry = "_launch_oodts_14", Iy = "_name_oodts_17", Oy = "_desc_oodts_18", Py = "_badge_oodts_19", Xy = "_disabled_oodts_23", zy = "_tab_oodts_25", Fy = "_star_oodts_25", Wy = "_on_oodts_30", Hy = "_empty_oodts_32", Oe = {
  group: qy,
  grid: By,
  row: Ly,
  item: jy,
  launch: Ry,
  name: Iy,
  desc: Oy,
  badge: Py,
  disabled: Xy,
  tab: zy,
  star: Fy,
  on: Wy,
  empty: Hy
};
function Ky() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Uy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function f0({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Oe.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Oe.grid }, t.map((s) => /* @__PURE__ */ n.createElement("div", { className: Oe.row, key: s.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Oe.item, s.disabled ? Oe.disabled : ""].filter(Boolean).join(" "),
      disabled: s.disabled,
      onClick: s.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Oe.launch }, /* @__PURE__ */ n.createElement(Ky, null)),
    /* @__PURE__ */ n.createElement("span", { className: Oe.name }, s.label),
    s.desc && /* @__PURE__ */ n.createElement("span", { className: Oe.desc }, s.desc),
    s.badge != null && /* @__PURE__ */ n.createElement("em", { className: Oe.badge }, s.badge)
  ), s.onOpenNewTab && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Oe.tab,
      "aria-label": `${s.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: s.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Uy, null)
  ), s.onToggleStar && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Oe.star, s.starred ? Oe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!s.starred,
      "aria-label": `${s.label} ${s.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: s.onToggleStar
    },
    s.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Oe.empty }, a)));
}
const Gy = "_strip_8zhai_2", Yy = "_day_8zhai_9", Vy = "_total_8zhai_10", Qy = "_sel_8zhai_31", Jy = "_today_8zhai_35", Zy = "_md_8zhai_35", eb = "_off_8zhai_36", tb = "_head_8zhai_45", nb = "_wd_8zhai_46", ab = "_sun_8zhai_47", rb = "_sat_8zhai_48", sb = "_lock_8zhai_50", ob = "_value_8zhai_60", lb = "_mark_8zhai_66", cb = "_warn_8zhai_67", ib = "_danger_8zhai_68", ub = "_info_8zhai_69", Ne = {
  strip: Gy,
  day: Yy,
  total: Vy,
  sel: Qy,
  today: Jy,
  md: Zy,
  off: eb,
  head: tb,
  wd: nb,
  sun: ab,
  sat: rb,
  lock: sb,
  value: ob,
  mark: lb,
  warn: cb,
  danger: ib,
  info: ub
}, Ga = ["일", "월", "화", "수", "목", "금", "토"];
function mb(e) {
  const [t, a, r] = e.split("-").map(Number), s = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: s };
}
function _0({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: s,
  totalLabel: o = "합계",
  "aria-label": l,
  className: c
}) {
  const i = L([]), m = (y) => {
    var p;
    const _ = e.length;
    for (let d = 0; d < _; d++) {
      const b = (y + d + _) % _;
      if (!e[b].disabled) {
        (p = i.current[b]) == null || p.focus();
        return;
      }
    }
  }, u = (y, _) => {
    y.key === "ArrowRight" ? (y.preventDefault(), m(_ + 1)) : y.key === "ArrowLeft" ? (y.preventDefault(), m(_ - 1)) : y.key === "Home" ? (y.preventDefault(), m(0)) : y.key === "End" && (y.preventDefault(), m(e.length - 1));
  }, f = Math.max(0, e.findIndex((y) => y.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${Ne.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((y, _) => {
    var N, k, $, E;
    const { md: p, wd: d } = mb(y.date), b = [
      Ne.day,
      y.off ? Ne.off : "",
      y.date === t ? Ne.sel : "",
      y.date === a ? Ne.today : "",
      d === 0 ? Ne.sun : d === 6 ? Ne.sat : ""
    ].filter(Boolean).join(" "), w = [`${p}(${Ga[d]})`, y.offLabel, y.locked ? "잠김" : null, (N = y.mark) == null ? void 0 : N.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: y.date,
        ref: (h) => {
          i.current[_] = h;
        },
        type: "button",
        className: b,
        disabled: y.disabled,
        tabIndex: _ === f ? 0 : -1,
        "aria-pressed": y.date === t,
        "aria-label": w,
        title: w,
        onClick: () => r == null ? void 0 : r(y.date),
        onKeyDown: (h) => u(h, _)
      },
      /* @__PURE__ */ n.createElement("span", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, Ga[d]), /* @__PURE__ */ n.createElement("span", { className: Ne.md }, p), y.locked && /* @__PURE__ */ n.createElement("span", { className: Ne.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: Ne.value }, y.value),
      /* @__PURE__ */ n.createElement("span", { className: `${Ne.mark}${y.mark ? ` ${Ne[y.mark.tone]}` : ""}` }, (E = (k = y.mark) == null ? void 0 : k.text) != null ? E : y.off && ($ = y.offLabel) != null ? $ : "")
    );
  }), s !== void 0 && /* @__PURE__ */ n.createElement("div", { className: Ne.total }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, o), /* @__PURE__ */ n.createElement("span", { className: Ne.value }, s)));
}
const db = "_stepper_1wbt2_1", fb = "_nav_1wbt2_2", _b = "_today_1wbt2_3", pb = "_range_1wbt2_14", en = {
  stepper: db,
  nav: fb,
  today: _b,
  range: pb
};
function yb(e) {
  const t = ua(e);
  return t === 0 ? 7 : t;
}
function bb(e, t = 1) {
  const a = (yb(e) - t + 7) % 7;
  return Cn(e, -a);
}
function Hn(e, t) {
  return Cn(e, t);
}
function p0({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: s, label: o = "주" }) {
  const l = Hn(e, 6), c = bb(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: en.stepper, role: "group", "aria-label": o }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.nav,
      onClick: () => t(Hn(e, -7)),
      disabled: s,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: en.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.nav,
      onClick: () => t(Hn(e, 7)),
      disabled: s,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.today,
      onClick: () => t(c),
      disabled: s || e === c
    },
    "이번 주"
  ));
}
const Eb = "_wrap_1dtpy_1", hb = "_svg_1dtpy_2", gb = "_grid_1dtpy_3", vb = "_axis_1dtpy_4", kb = "_accent_1dtpy_5", wb = "_muted_1dtpy_6", Nb = "_ok_1dtpy_7", $b = "_warn_1dtpy_8", xb = "_danger_1dtpy_9", Db = "_legend_1dtpy_10", Ab = "_dot_accent_1dtpy_13", Cb = "_dot_muted_1dtpy_14", Sb = "_dot_ok_1dtpy_15", Mb = "_dot_warn_1dtpy_16", Tb = "_dot_danger_1dtpy_17", bt = {
  wrap: Eb,
  svg: hb,
  grid: gb,
  axis: vb,
  accent: kb,
  muted: wb,
  ok: Nb,
  warn: $b,
  danger: xb,
  legend: Db,
  dot_accent: Ab,
  dot_muted: Cb,
  dot_ok: Sb,
  dot_warn: Mb,
  dot_danger: Tb
}, qb = 600;
function Bb(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const Ya = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function y0({ categories: e, series: t, unit: a = "", height: r = 180, label: s, labelEvery: o }) {
  const l = L(null), [c, i] = A(qb);
  qe(() => {
    const g = l.current;
    if (!g) return;
    const x = () => {
      const M = g.clientWidth;
      M > 0 && i((T) => T === M ? T : M);
    };
    if (x(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(x);
    return C.observe(g), () => C.disconnect();
  }, []);
  const m = r, u = 40, f = 22, y = 8, _ = c - u - 4, p = m - f - y, d = t.flatMap((g) => g.values.filter((x) => x != null)), b = Bb(Math.max(0, ...d)), w = Math.max(e.length, 1), N = _ / w, k = Math.min(8, N * 0.2), $ = Math.max(1, (N - k) / Math.max(t.length, 1)), E = o != null ? o : Math.max(1, Math.ceil(w / 8)), h = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: bt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: bt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": s,
      style: { height: r }
    },
    h.map((g) => {
      const x = y + p - g / b * p;
      return /* @__PURE__ */ n.createElement("g", { key: g }, /* @__PURE__ */ n.createElement("line", { className: bt.grid, x1: u, x2: c - 4, y1: x, y2: x }), /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: u - 4, y: x + 3, textAnchor: "end" }, Ya(g)));
    }),
    e.map((g, x) => /* @__PURE__ */ n.createElement("g", { key: g }, t.map((C, M) => {
      var q;
      const T = C.values[x];
      if (T == null || T <= 0) return null;
      const I = T / b * p;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: bt[(q = C.tone) != null ? q : "accent"],
          x: u + x * N + k / 2 + M * $,
          y: y + p - I,
          width: $,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${g} · ${C.label} ${Ya(T)}${a}`)
      );
    }), x % E === 0 && /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: u + x * N + N / 2, y: m - 6, textAnchor: "middle" }, g)))
  ), /* @__PURE__ */ n.createElement("ul", { className: bt.legend }, t.map((g) => {
    var x;
    return /* @__PURE__ */ n.createElement("li", { key: g.key }, /* @__PURE__ */ n.createElement("i", { className: bt[`dot_${(x = g.tone) != null ? x : "accent"}`], "aria-hidden": "true" }), g.label, a ? ` (${a})` : "");
  })));
}
const Lb = "_wrap_85lir_1", jb = "_track_85lir_2", Rb = "_accent_85lir_3", Ib = "_muted_85lir_3", Ob = "_ok_85lir_3", Pb = "_warn_85lir_3", Xb = "_danger_85lir_3", zb = "_center_85lir_9", Fb = "_legend_85lir_10", Wb = "_name_85lir_13", Hb = "_val_85lir_14", Kb = "_pct_85lir_15", Ub = "_dot_accent_85lir_16", Gb = "_dot_muted_85lir_17", Yb = "_dot_ok_85lir_18", Vb = "_dot_warn_85lir_19", Qb = "_dot_danger_85lir_20", rt = {
  wrap: Lb,
  track: jb,
  accent: Rb,
  muted: Ib,
  ok: Ob,
  warn: Pb,
  danger: Xb,
  center: zb,
  legend: Fb,
  name: Wb,
  val: Hb,
  pct: Kb,
  dot_accent: Ub,
  dot_muted: Gb,
  dot_ok: Yb,
  dot_warn: Vb,
  dot_danger: Qb
}, ta = 40, Va = 2 * Math.PI * ta;
function b0({ items: e, center: t, size: a = 120, label: r, emptyText: s = "자료 없음", unit: o = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: rt.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: rt.track, cx: "50", cy: "50", r: ta }), l > 0 && e.map((i) => {
    var f;
    const m = Math.max(0, i.value) / l * Va, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: rt[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: ta,
        strokeDasharray: `${m} ${Va - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${o}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: rt.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : s)), /* @__PURE__ */ n.createElement("ul", { className: rt.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: rt[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: rt.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: rt.val }, i.value.toLocaleString("ko-KR"), o), /* @__PURE__ */ n.createElement("span", { className: rt.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const Jb = "_wrap_1b8ll_1", Zb = "_track_1b8ll_2", e1 = "_compact_1b8ll_3", t1 = "_fill_1b8ll_4", n1 = "_accent_1b8ll_5", a1 = "_muted_1b8ll_6", r1 = "_ok_1b8ll_7", s1 = "_warn_1b8ll_8", o1 = "_danger_1b8ll_9", l1 = "_num_1b8ll_10", c1 = "_none_1b8ll_12", $t = {
  wrap: Jb,
  track: Zb,
  compact: e1,
  fill: t1,
  accent: n1,
  muted: a1,
  ok: r1,
  warn: s1,
  danger: o1,
  num: l1,
  none: c1
};
function E0({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: $t.none, "aria-label": `${t} 해당 없음` }, "-");
  const s = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [$t.wrap, r ? $t.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": s
    },
    /* @__PURE__ */ n.createElement("span", { className: $t.track }, /* @__PURE__ */ n.createElement("span", { className: `${$t.fill} ${$t[a]}`, style: { width: `${s}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: $t.num }, s, "%")
  );
}
const i1 = { day: 28, week: 10, month: 3 };
function Tt(e, t) {
  return Cn(e, t);
}
function na(e, t) {
  return gt(t) - gt(e) + 1;
}
function Ir(e) {
  return ua(e);
}
const Qa = (e) => {
  const t = Ir(e);
  return t === 0 || t === 6;
};
function It(e, t, a, r) {
  const s = [], o = na(e, t);
  for (let l = 0; l < o; l++) {
    const c = Tt(e, l), i = a(c), m = s[s.length - 1];
    m && m.key === i ? m.days++ : s.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return s;
}
function u1(e, t, a) {
  const r = (o) => o.slice(0, 7), s = (o) => `${o.slice(0, 4)}.${o.slice(5, 7)}`;
  if (a === "month")
    return {
      top: It(e, t, (o) => o.slice(0, 4), (o) => `${o.slice(0, 4)}년`),
      bottom: It(e, t, r, (o) => `${Number(o.slice(5, 7))}월`)
    };
  if (a === "week") {
    const o = (l) => Tt(l, -((Ir(l) + 6) % 7));
    return {
      top: It(e, t, r, s),
      bottom: It(e, t, o, (l) => {
        const c = o(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: It(e, t, r, s),
    bottom: It(e, t, (o) => o, (o) => String(Number(o.slice(8, 10))))
  };
}
function Kn(e, t, a, r) {
  if (a === "move") return { start: Tt(e, r), end: Tt(t, r) };
  if (a === "start") {
    const o = Tt(e, r);
    return { start: o > t ? t : o, end: t };
  }
  const s = Tt(t, r);
  return { start: e, end: s < e ? e : s };
}
const m1 = "_gantt_1smka_3", d1 = "_scroll_1smka_15", f1 = "_canvas_1smka_21", _1 = "_head_1smka_24", p1 = "_headLabel_1smka_32", y1 = "_headTrack_1smka_43", b1 = "_band_1smka_44", E1 = "_seg_1smka_46", h1 = "_tick_1smka_59", g1 = "_tickOff_1smka_60", v1 = "_body_1smka_62", k1 = "_overlay_1smka_65", w1 = "_weekend_1smka_66", N1 = "_holiday_1smka_66", $1 = "_today_1smka_68", x1 = "_row_1smka_70", D1 = "_label_1smka_76", A1 = "_sel_1smka_77", C1 = "_track_1smka_77", S1 = "_dim_1smka_78", M1 = "_labelText_1smka_95", T1 = "_dot_1smka_96", q1 = "_warn_1smka_97", B1 = "_err_1smka_98", L1 = "_bar_1smka_113", j1 = "_can_1smka_21", R1 = "_dragging_1smka_126", I1 = "_fill_1smka_127", O1 = "_late_1smka_128", P1 = "_summary_1smka_130", X1 = "_handle_1smka_133", z1 = "_hL_1smka_134", F1 = "_hR_1smka_135", W1 = "_mark_1smka_137", H1 = "_barText_1smka_138", K1 = "_empty_1smka_147", U1 = "_srOnly_1smka_150", ee = {
  gantt: m1,
  scroll: d1,
  canvas: f1,
  head: _1,
  headLabel: p1,
  headTrack: y1,
  band: b1,
  seg: E1,
  tick: h1,
  tickOff: g1,
  body: v1,
  overlay: k1,
  weekend: w1,
  holiday: N1,
  today: $1,
  row: x1,
  label: D1,
  sel: A1,
  track: C1,
  dim: S1,
  labelText: M1,
  dot: T1,
  warn: q1,
  err: B1,
  bar: L1,
  can: j1,
  dragging: R1,
  fill: I1,
  late: O1,
  summary: P1,
  handle: X1,
  hL: z1,
  hR: F1,
  mark: W1,
  barText: H1,
  empty: K1,
  srOnly: U1
}, Ja = 28, Za = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let G1 = 0;
function h0({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: s = {},
  today: o,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: f,
  lockedReason: y,
  scrollMemory: _,
  className: p = "",
  style: d,
  "aria-label": b
}) {
  const w = L("");
  w.current || (w.current = `axe-gantt-keys-${++G1}`);
  const N = i1[r], k = Math.max(na(t, a), 1), $ = gt(t), E = k * N, h = we(() => u1(t, a, r), [t, a, r]), g = we(() => {
    const v = [];
    for (let O = 0; O < k; O++) {
      const V = Tt(t, O), Q = V in s;
      if (!Q && !Qa(V)) continue;
      const se = v[v.length - 1];
      se && se.offset + se.days === O && se.holiday === Q ? se.days++ : v.push({ offset: O, days: 1, holiday: Q });
    }
    return v;
  }, [t, k, s]), [x, C] = A(null), M = L(null), T = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, O, V) => {
    if (!T(O) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: O.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    M.current = Q, C(Q);
  }, q = (v) => {
    const O = M.current;
    if (!O) return;
    const V = Math.round((v.clientX - O.x) / N), Q = O.moved || Math.abs(v.clientX - O.x) > 3;
    if (V !== O.delta || Q !== O.moved) {
      const se = { ...O, delta: V, moved: Q };
      M.current = se, C(se);
    }
  }, X = (v) => {
    const O = M.current;
    if (M.current = null, C(null), !!O) {
      if (!O.moved) {
        i == null || i(v);
        return;
      }
      O.delta !== 0 && v.start && v.end && (c == null || c(v, Kn(v.start, v.end, O.mode, O.delta), O.mode));
    }
  }, G = () => {
    M.current = null, C(null);
  }, K = (v, O) => {
    if (v.key === "Escape" && M.current) {
      G();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(O);
      return;
    }
    if (!T(O) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(O, Kn(O.start, O.end, Q, V), Q);
  }, j = o ? gt(o) - $ : -1, ne = L(null), ae = L(null);
  return qe(() => {
    const v = ne.current;
    if (v && (_ != null && _.current) && ae.current === null) {
      ae.current = r, v.scrollLeft = _.current.left, v.scrollTop = _.current.top;
      return;
    }
    if (!l || !v || j < 0 || j >= k || ae.current === r) return;
    ae.current = r;
    const O = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, j * N + N / 2 - O / 3);
  }, [l, r, j, k, N, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, p].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && M.current && G();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: w.current, className: ee.srOnly }, Za),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ee.scroll,
        onScroll: _ ? (v) => {
          _.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: u + E } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${u}px ${E}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, h.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * N, width: v.days * N }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, h.bottom.map((v) => {
        var V;
        const O = r === "day" && (v.key in s || Qa(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, O ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * N, width: v.days * N },
            title: (V = s[v.key]) != null ? V : v.key
          },
          v.days * N >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: Ja } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: u, width: E }, "aria-hidden": "true" }, g.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * N, width: v.days * N } })), j >= 0 && j < k && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * N + N / 2 }, title: "오늘" })), e.map((v) => {
        var z, H, ce, Pe;
        const O = !!v.start && !!v.end && v.start <= v.end, V = x && x.id === v.id ? x : null, Q = O && V && V.delta !== 0 ? Kn(v.start, v.end, V.mode, V.delta) : O ? { start: v.start, end: v.end } : null, se = Q ? (gt(Q.start) - $) * N : 0, B = Q ? na(Q.start, Q.end) * N : 0, J = Math.max(0, Math.min(100, (z = v.progress) != null ? z : 0)), R = m != null && m === v.id, F = T(v), Y = !F && c && Q ? y == null ? void 0 : y(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, R ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: Ja }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: E }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", F ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(B, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(H = v.name) != null ? H : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${J}%` : ""}${v.late ? " 지연" : ""}${Y ? ` 잠김: ${Y}` : ""}`,
              "aria-describedby": F ? w.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${J}%` : ""}${v.late ? " · 지연" : ""}${F ? `
끌어 옮기기·양 끝 조절
${Za}` : ""}${Y ? `
잠김: ${Y}` : ""}`,
              onPointerDown: (je) => I(je, v, "move"),
              onPointerMove: q,
              onPointerUp: () => X(v),
              onPointerCancel: G,
              onClick: (je) => je.stopPropagation(),
              onKeyDown: (je) => K(je, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${J}%` } }),
            F && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (je) => I(je, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (je) => I(je, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (gt(v.markDate) - $ + 1) * N - 1 }, title: (ce = v.markLabel) != null ? ce : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(B, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Pe = v.emptyText) != null ? Pe : "기간 없음"))
        );
      })))
    )
  );
}
const Y1 = "_board_192fl_3", V1 = "_col_192fl_15", Q1 = "_over_192fl_23", J1 = "_head_192fl_25", Z1 = "_title_192fl_33", eE = "_count_192fl_34", tE = "_hint_192fl_43", nE = "_list_192fl_45", aE = "_empty_192fl_54", rE = "_card_192fl_56", sE = "_sel_192fl_68", oE = "_dragging_192fl_69", lE = "_hasErr_192fl_70", cE = "_dot_192fl_71", iE = "_err_192fl_72", Se = {
  board: Y1,
  col: V1,
  over: Q1,
  head: J1,
  title: Z1,
  count: eE,
  hint: tE,
  list: nE,
  empty: aE,
  card: rE,
  sel: sE,
  dragging: oE,
  hasErr: lE,
  dot: cE,
  err: iE
}, Un = "application/x-axerp-kanban";
function g0({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: s,
  cardLabel: o,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: f,
  emptyText: y = "카드가 없습니다",
  moveHint: _,
  className: p = "",
  style: d,
  "aria-label": b
}) {
  const w = Kt("axe-kb"), [N, k] = A(null), [$, E] = A(null), h = new Map(t.map((T) => [String(a(T)), T])), g = L(null), x = L(null);
  Z(() => {
    var q, X;
    const T = x.current;
    if (!T) return;
    if (Date.now() > T.until) {
      x.current = null;
      return;
    }
    const I = Array.from((X = (q = g.current) == null ? void 0 : q.querySelectorAll("[data-kanban-key]")) != null ? X : []).find((G) => G.dataset.kanbanKey === T.key);
    I && document.activeElement !== I && I.focus(), x.current = null;
  });
  const C = (T, I) => {
    T.preventDefault(), k(null), E(null);
    const q = T.dataTransfer.getData(Un), X = h.get(q);
    X && r(X) !== I && (l == null || l(X, I));
  }, M = (T, I) => {
    if (T.key === "Enter" || T.key === " ") {
      T.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !T.altKey || T.key !== "ArrowLeft" && T.key !== "ArrowRight" || f != null && f(I)) return;
    T.preventDefault();
    const q = e.findIndex((G) => G.key === r(I)), X = q + (T.key === "ArrowLeft" ? -1 : 1);
    q >= 0 && X >= 0 && X < e.length && (x.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[X].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: g, className: [Se.board, p].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((T) => {
    const I = t.filter((q) => r(q) === T.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: T.key,
        className: [Se.col, N === T.key ? Se.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof T.title == "string" ? T.title : void 0,
        onDragOver: l ? (q) => {
          q.dataTransfer.types.includes(Un) && (q.preventDefault(), k(T.key));
        } : void 0,
        onDragLeave: l ? (q) => {
          q.currentTarget.contains(q.relatedTarget) || k((X) => X === T.key ? null : X);
        } : void 0,
        onDrop: l ? (q) => C(q, T.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Se.head }, /* @__PURE__ */ n.createElement("span", { className: Se.title }, T.title), /* @__PURE__ */ n.createElement("span", { className: Se.count }, I.length), T.hint && /* @__PURE__ */ n.createElement("span", { className: Se.hint }, T.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Se.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Se.empty }, y), I.map((q) => {
        const X = a(q), G = f == null ? void 0 : f(q), K = u == null ? void 0 : u(q), j = !!l && !G, ne = G != null ? G : j ? _ != null ? _ : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: X,
            className: [Se.card, i === X ? Se.sel : "", $ === X ? Se.dragging : "", K ? Se.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(X),
            role: "button",
            "aria-label": o == null ? void 0 : o(q),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${w}-h-${String(X)}` : void 0,
            draggable: j,
            onDragStart: j ? (ae) => {
              ae.dataTransfer.setData(Un, String(X)), ae.dataTransfer.effectAllowed = "move", E(X);
            } : void 0,
            onDragEnd: () => {
              E(null), k(null);
            },
            onClick: () => c == null ? void 0 : c(q),
            onKeyDown: (ae) => M(ae, q)
          },
          ne && /* @__PURE__ */ n.createElement(kr, { id: `${w}-h-${String(X)}` }, ne),
          (m == null ? void 0 : m(q)) && /* @__PURE__ */ n.createElement("span", { className: Se.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          s(q),
          K && /* @__PURE__ */ n.createElement("p", { className: Se.err, role: "alert" }, K)
        );
      }))
    );
  }));
}
const uE = "_list_1aqum_2", mE = "_empty_1aqum_3", dE = "_item_1aqum_5", fE = "_row_block_1aqum_6", _E = "_row_warn_1aqum_7", pE = "_head_1aqum_9", yE = "_mark_1aqum_16", bE = "_msg_1aqum_17", EE = "_count_1aqum_18", hE = "_aside_1aqum_19", gE = "_caret_1aqum_20", vE = "_block_1aqum_22", kE = "_warn_1aqum_23", wE = "_info_1aqum_24", NE = "_body_1aqum_29", $E = "_actions_1aqum_30", Me = {
  list: uE,
  empty: mE,
  item: dE,
  row_block: fE,
  row_warn: _E,
  head: pE,
  mark: yE,
  msg: bE,
  count: EE,
  aside: hE,
  caret: gE,
  block: vE,
  warn: kE,
  info: wE,
  body: NE,
  actions: $E
}, xE = { block: "■", warn: "▲", info: "●" }, DE = { block: "차단", warn: "경고", info: "정보" };
function v0({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [s, o] = A({}), [l, c] = A(e);
  return l !== e && (c(e), o({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Me.list} ${r}` }, e.map((i) => {
    var y;
    const m = !!i.detail || !!i.actions, u = m && ((y = s[i.key]) != null ? y : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Me.mark} ${Me[i.tone]}`, "aria-label": DE[i.tone], role: "img" }, xE[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Me.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Me.count} ${Me[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Me.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Me.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Me.item} ${Me[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Me.head,
        "aria-expanded": u,
        onClick: () => o((_) => ({ ..._, [i.key]: !u }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: Me.head }, f), u && /* @__PURE__ */ n.createElement("div", { className: Me.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Me.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Me.empty} ${r}` }, t);
}
function AE(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), s = (o, l) => Array.from({ length: l - o + 1 }, (c, i) => o + i);
  return a <= 10 ? s(1, a) : r <= 5 ? [...s(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...s(a - 6, a)] : [1, "…", ...s(r - 2, r + 2), "…", a];
}
function CE(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function k0(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function w0(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const SE = "_nav_1r2z8_1", ME = "_list_1r2z8_3", TE = "_btn_1r2z8_4", qE = "_cur_1r2z8_13", BE = "_gap_1r2z8_15", LE = "_total_1r2z8_16", jE = "_jump_1r2z8_17", RE = "_go_1r2z8_20", IE = "_size_1r2z8_22", OE = "_more_1r2z8_24", PE = "_moreBtn_1r2z8_25", XE = "_moreN_1r2z8_29", ge = {
  nav: SE,
  list: ME,
  btn: TE,
  cur: qE,
  gap: BE,
  total: LE,
  jump: jE,
  in: "_in_1r2z8_18",
  go: RE,
  size: IE,
  more: OE,
  moreBtn: PE,
  moreN: XE
};
function N0({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: s, pageSize: o, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [f, y] = A(String(u));
  Z(() => y(String(u)), [u]);
  const _ = (d) => {
    d !== u && d >= 1 && d <= m && a(d);
  }, p = () => {
    const d = CE(f, m);
    if (d === null) {
      y(String(u));
      return;
    }
    y(String(d)), _(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [ge.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: ge.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: ge.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), AE(u, m).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: ge.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [ge.btn, d === u ? ge.cur : ""].filter(Boolean).join(" "),
      onClick: () => _(d),
      "aria-current": d === u ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: ge.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: ge.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: ge.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => y(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), p());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.go, onClick: p }, "이동")), s && o !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: ge.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: o, onChange: (d) => l(Number(d.target.value)) }, s.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function $0({ shown: e, total: t, onMore: a, busy: r = !1, className: s = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [ge.more, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: ge.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const zE = "_ol_fbatg_1", FE = "_li_fbatg_2", WE = "_done_fbatg_5", HE = "_now_fbatg_5", KE = "_item_fbatg_6", UE = "_dot_fbatg_12", GE = "_label_fbatg_19", YE = "_opt_fbatg_21", VE = "_sr_fbatg_22", st = {
  ol: zE,
  li: FE,
  done: WE,
  now: HE,
  item: KE,
  dot: UE,
  label: GE,
  opt: YE,
  sr: VE
};
function x0({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [st.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((s, o) => {
    const l = o < t ? "done" : o === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: st.dot, "aria-hidden": "true" }, l === "done" ? "✓" : o + 1), /* @__PURE__ */ n.createElement("span", { className: st.label }, s.label, s.optional && /* @__PURE__ */ n.createElement("span", { className: st.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: st.sr }, " 완료"))), i = !!a && o <= t;
    return /* @__PURE__ */ n.createElement("li", { key: s.key, className: [st.li, st[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: st.item, onClick: () => a(o, s) }, c) : /* @__PURE__ */ n.createElement("span", { className: st.item }, c));
  }));
}
const QE = "_root_7y5bc_5", JE = "_block_7y5bc_6", ZE = "_svg_7y5bc_7", eh = "_sm_7y5bc_8", th = "_md_7y5bc_9", nh = "_lg_7y5bc_10", ah = "_track_7y5bc_11", rh = "_bar_7y5bc_12", sh = "_spin_7y5bc_13", oh = "_txt_7y5bc_15", Et = {
  root: QE,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: JE,
  svg: ZE,
  sm: eh,
  md: th,
  lg: nh,
  track: ah,
  bar: rh,
  spin: sh,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: oh,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function D0({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: s = !1, className: o = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Et.root, s ? Et.block : "", o].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [Et.svg, Et[e], l ? "" : Et.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: Et.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: Et.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: Et.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const lh = "_group_xpsei_1", ch = "_legend_xpsei_2", ih = "_req_xpsei_3", uh = "_opts_xpsei_4", mh = "_inline_xpsei_5", dh = "_all_xpsei_6", fh = "_opt_xpsei_4", _h = "_dis_xpsei_11", ph = "_radio_xpsei_12", yh = "_check_xpsei_12", bh = "_text_xpsei_14", Eh = "_hint_xpsei_15", hh = "_err_xpsei_16", _e = {
  group: lh,
  legend: ch,
  req: ih,
  opts: uh,
  inline: mh,
  all: dh,
  opt: fh,
  dis: _h,
  radio: ph,
  check: yh,
  text: bh,
  hint: Eh,
  err: hh
};
function Or({ legend: e, required: t }) {
  return /* @__PURE__ */ n.createElement("legend", { className: _e.legend }, e, t && /* @__PURE__ */ n.createElement("span", { className: _e.req }, " (필수)"));
}
function A0({ name: e, legend: t, options: a, value: r, onChange: s, required: o, disabled: l, error: c, inline: i = !1, className: m = "" }) {
  const u = Kt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [_e.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? u : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Or, { legend: t, required: o }),
    /* @__PURE__ */ n.createElement("div", { className: [_e.opts, i ? _e.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((f) => /* @__PURE__ */ n.createElement("label", { key: f.value, className: [_e.opt, f.disabled ? _e.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: _e.radio,
        name: e,
        value: f.value,
        checked: r === f.value,
        disabled: f.disabled,
        required: o,
        onChange: () => s(f.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: _e.text }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: _e.hint }, f.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: u, className: _e.err }, c)
  );
}
function er({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: s, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [_e.opt, r ? _e.dis : "", o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: _e.check,
      checked: e,
      disabled: r,
      ref: (l) => {
        l && (l.indeterminate = t && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), s !== void 0 && /* @__PURE__ */ n.createElement("span", { className: _e.text }, s));
}
function C0({ legend: e, options: t, value: a, onChange: r, required: s, disabled: o, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Kt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), y = f.length > 0 && f.every((d) => a.includes(d)), _ = f.some((d) => a.includes(d)), p = (d, b) => r(b ? [...a, d] : a.filter((w) => w !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [_e.group, m].filter(Boolean).join(" "),
      disabled: o,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Or, { legend: e, required: s }),
    i && /* @__PURE__ */ n.createElement("div", { className: _e.all }, /* @__PURE__ */ n.createElement(
      er,
      {
        checked: y,
        indeterminate: _ && !y,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [_e.opts, c ? _e.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(er, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => p(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: _e.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: _e.err }, l)
  );
}
const gh = "_list_13vw7_1", vh = "_tag_13vw7_2", kh = "_main_13vw7_3", wh = "_x_13vw7_6", Nh = "_t_muted_13vw7_10", $h = "_t_accent_13vw7_11", xh = "_t_ok_13vw7_12", Dh = "_t_warn_13vw7_13", Ah = "_t_danger_13vw7_14", Ch = "_sel_13vw7_16", Dt = {
  list: gh,
  tag: vh,
  main: kh,
  x: wh,
  t_muted: Nh,
  t_accent: $h,
  t_ok: xh,
  t_warn: Dh,
  t_danger: Ah,
  sel: Ch
};
function S0({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: s, removeLabel: o, disabled: l, className: c = "" }) {
  const i = [Dt.tag, Dt[`t_${t}`], a ? Dt.sel : "", c].filter(Boolean).join(" "), m = o != null ? o : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: Dt.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: Dt.main }, e), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Dt.x, onClick: s, disabled: l, "aria-label": m }, "✕"));
}
function M0({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [Dt.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, s) => /* @__PURE__ */ n.createElement("li", { key: s }, r)));
}
const Sh = "_acc_1lmty_1", Mh = "_item_1lmty_2", Th = "_h_1lmty_3", qh = "_btn_1lmty_4", Bh = "_title_1lmty_8", Lh = "_meta_1lmty_9", jh = "_chev_1lmty_10", Rh = "_open_1lmty_11", Ih = "_body_1lmty_12", ot = {
  acc: Sh,
  item: Mh,
  h: Th,
  btn: qh,
  title: Bh,
  meta: Lh,
  chev: jh,
  open: Rh,
  body: Ih
};
function T0({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: s, headingLevel: o = 3, className: l = "" }) {
  const [c, i] = A(a), m = r != null ? r : c, u = Kt("axe-acc"), f = `h${o}`, y = (_) => {
    const p = m.includes(_) ? m.filter((d) => d !== _) : t ? [_] : [...m, _];
    r === void 0 && i(p), s == null || s(p);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ot.acc, l].filter(Boolean).join(" ") }, e.map((_) => {
    const p = m.includes(_.key), d = `${u}-b-${_.key}`, b = `${u}-p-${_.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: _.key, className: [ot.item, p ? ot.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: ot.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: ot.btn,
        "aria-expanded": p,
        "aria-controls": b,
        disabled: _.disabled,
        onClick: () => y(_.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: ot.title }, _.title),
      _.meta && /* @__PURE__ */ n.createElement("span", { className: ot.meta }, _.meta),
      /* @__PURE__ */ n.createElement("span", { className: ot.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !p, className: ot.body }, _.content));
  }));
}
const Oh = "_stack_1u83j_2", Ph = "_toast_1u83j_3", Xh = "_t_danger_1u83j_9", zh = "_ico_1u83j_10", Fh = "_t_ok_1u83j_11", Wh = "_msg_1u83j_12", Hh = "_act_1u83j_13", Kh = "_x_1u83j_15", At = {
  stack: Oh,
  toast: Ph,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: Xh,
  ico: zh,
  t_ok: Fh,
  msg: Wh,
  act: Hh,
  x: Kh
}, Pr = An(null);
let Uh = 0;
function q0() {
  const e = Dn(Pr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function Gh({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = A(!1), s = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  Z(() => {
    if (a || s === 0) return;
    const i = window.setTimeout(t, s);
    return () => window.clearTimeout(i);
  }, [a, s, t, e.message]);
  const o = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [At.toast, At[`t_${o}`]].join(" "),
      role: o === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: At.ico, "aria-hidden": "true" }, o === "ok" ? "✓" : o === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: At.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: At.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: At.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function B0({ children: e }) {
  const [t, a] = A([]), r = L(t);
  r.current = t;
  const s = oe((c) => a((i) => i.filter((m) => m.id !== c)), []), o = oe((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((f) => f.message === i.message);
    if (m)
      return a((f) => f.map((y) => y.id === m.id ? { ...y, ...i } : y)), m.id;
    const u = ++Uh;
    return a((f) => [...f, { ...i, id: u }].slice(-3)), u;
  }, []), l = we(() => ({ toast: o, dismiss: s }), [o, s]);
  return /* @__PURE__ */ n.createElement(Pr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: At.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(Gh, { key: c.id, item: c, onClose: () => s(c.id) }))));
}
const Yh = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function Vh(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const Qh = "_grid_yplhe_1", Jh = "_group_yplhe_2", Zh = "_h_yplhe_3", eg = "_list_yplhe_4", tg = "_row_yplhe_5", ng = "_keys_yplhe_6", ag = "_text_yplhe_7", rg = "_or_yplhe_8", sg = "_kbd_yplhe_9", lt = {
  grid: Qh,
  group: Jh,
  h: Zh,
  list: eg,
  row: tg,
  keys: ng,
  text: ag,
  or: rg,
  kbd: sg
};
function og({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...Yh];
  return /* @__PURE__ */ n.createElement(Bn, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: lt.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: lt.group }, /* @__PURE__ */ n.createElement("h3", { className: lt.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: lt.list }, r.items.map((s, o) => /* @__PURE__ */ n.createElement("div", { key: o, className: lt.row }, /* @__PURE__ */ n.createElement("dt", { className: lt.keys }, s.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: lt.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: lt.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: lt.text }, s.text))))))));
}
function lg(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function L0(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, s] = A(!1);
  return Z(() => {
    if (!t) return;
    const o = (l) => {
      Vh(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, lg(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), s(!0)));
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [t]), { open: () => s(!0), dialog: r ? /* @__PURE__ */ n.createElement(og, { extra: a, onClose: () => s(!1) }) : null };
}
const tr = 30, cg = BigInt(10);
function Wt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * cg;
  return t;
}
function mt(e, t = 0) {
  return { u: e, s: t };
}
const Xr = mt(BigInt(0));
function zr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Wt(a - e.s), t.u * Wt(a - t.s), a];
}
function dn(e, t) {
  const [a, r, s] = zr(e, t);
  return mt(a + r, s);
}
function fa(e, t) {
  const [a, r, s] = zr(e, t);
  return mt(a - r, s);
}
function et(e, t) {
  return mt(e.u * t.u, e.s + t.s);
}
function qt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Wt(t.s + tr), r = t.u * Wt(e.s);
  return mt(a / r, tr);
}
function Fr(e) {
  return mt(-e.u, e.s);
}
function dt(e, t, a) {
  if (t >= e.s)
    return mt(e.u * Wt(t - e.s), t);
  const r = Wt(e.s - t), s = e.u < BigInt(0), o = s ? -e.u : e.u, l = o / r, c = o % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, mt(s ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s) + r.slice(s + 1), l = s < 0 ? 0 : r.length - s - 1, c = BigInt(o === "" ? "0" : o);
  return mt(a ? -c : c, l);
}
function _a(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : Xr);
}
function Ke(e, t = e.s, a = !1) {
  const r = dt(e, Math.max(t, 0), "half"), s = r.u < BigInt(0), o = (s ? -r.u : r.u).toString().padStart(t + 1, "0"), l = o.length - t;
  let c = o.slice(0, l);
  const i = o.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (s ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function aa(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), s = Number(t[3]);
  return r < 1 || r > 12 || s < 1 || s > Be(a, r) ? null : { y: a, m: r, d: s };
}
function Pt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), s = e + 4800 - r, o = t + 12 * r - 3;
  return a + Math.floor((153 * o + 2) / 5) + 365 * s + Math.floor(s / 4) - Math.floor(s / 100) + Math.floor(s / 400) - 32045;
}
function Wr(e, t) {
  const a = Pt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), s = a - Math.floor(146097 * r / 4), o = Math.floor((4 * s + 3) / 1461), l = s - Math.floor(1461 * o / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + o - 4800 + Math.floor(c / 10)
  };
}
function Hr(e, t, a = "exclude-first") {
  const r = Pt(e) > Pt(t), s = r ? t : e, o = r ? e : t, l = a === "include-first", c = Pt(o) - Pt(s) + (l ? 1 : 0), i = l ? Wr(o, 1) : o;
  let m = i.y - s.y, u = i.m - s.m, f = i.d - s.d;
  if (f < 0) {
    u -= 1;
    const y = i.m === 1 ? 12 : i.m - 1, _ = i.m === 1 ? i.y - 1 : i.y;
    f += Be(_, y);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d: f, swapped: r };
}
function xn(e, t) {
  return Wr(e, t);
}
function nr(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = a % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Be(r, s)) };
}
const ig = ["월", "화", "수", "목", "금", "토", "일"];
function ra(e) {
  return ig[Pt(e) % 7];
}
function Xe(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const tn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Gn = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function ar(e) {
  var t;
  return (t = Gn[e]) != null ? t : e in Gn ? Gn[e] : null;
}
function sa(e, t) {
  return e.find((a) => a.code === t);
}
function Kr(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Ur(e, t, a, r) {
  const s = sa(e, a), o = sa(e, r);
  if (!s || !o) return null;
  const l = be(s.krw), c = be(o.krw), i = be(String(s.per)), m = be(String(o.per));
  if (!l || !c || !i || !m) return null;
  const u = qt(et(t, l), i);
  if (!u) return null;
  const f = qt(et(u, m), c);
  return f ? {
    value: dt(f, 2, "half"),
    notice: `${Kr(s)} · 참고용 환율`
  } : null;
}
function ug(e, t) {
  let a = null;
  for (const s of e)
    if (s.value) {
      if (a === null) {
        a = s.sign === "-" ? Fr(s.value) : s.value;
        continue;
      }
      switch (s.sign) {
        case "+":
          a = dn(a, s.value);
          break;
        case "-":
          a = fa(a, s.value);
          break;
        case "*":
          a = et(a, s.value);
          break;
        default: {
          const o = qt(a, s.value);
          if (!o) return { ok: !1, error: "divide-by-zero" };
          a = o;
          break;
        }
      }
    }
  const r = a != null ? a : Xr;
  return { ok: !0, value: t ? dt(r, t.digits, t.mode) : r };
}
const rr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function rn() {
  return { sign: "+", text: "" };
}
function mg(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s), l = s < 0 ? "" : "." + r.slice(s + 1).replace(/\./g, "");
  return (a ? "-" : "") + o.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function dg(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function fg(e) {
  const { lines: t, onLines: a, active: r, onActive: s, digits: o, onDigits: l, mode: c, onMode: i } = e, m = L([]), u = Math.min(r, t.length - 1);
  Z(() => {
    var k;
    (k = m.current[u]) == null || k.focus();
  }, [u, t.length]);
  const f = ug(dg(t), { digits: o, mode: c }), y = f.ok ? Ke(f.value, o, !0) : "0으로 나눌 수 없음", _ = (k, $) => {
    a(t.map((E, h) => h === k ? { ...E, ...$ } : E));
  }, p = (k = t.length, $ = "") => {
    const E = [...t];
    E.splice(k, 0, { ...rn(), text: $ }), a(E), s(k);
  }, d = (k) => {
    if (t.length === 1) {
      a([rn()]);
      return;
    }
    a(t.filter(($, E) => E !== k)), s(Math.max(0, k - 1));
  }, b = () => {
    f.ok && p(t.length, Ke(f.value, o, !0));
  }, w = (k, $) => {
    const E = k.key, h = _g(E);
    if (h && !(E === "-" && t[$].text === "")) {
      k.preventDefault(), _($, { sign: h });
      return;
    }
    if (E === "v" || E === "V") {
      k.preventDefault(), b();
      return;
    }
    E === "Enter" ? (k.preventDefault(), $ === t.length - 1 ? p() : s($ + 1)) : E === "ArrowDown" ? (k.preventDefault(), s(Math.min($ + 1, t.length - 1))) : E === "ArrowUp" ? (k.preventDefault(), s(Math.max($ - 1, 0))) : E === "Insert" ? (k.preventDefault(), p($ + 1)) : E === "Delete" && t[$].text === "" ? (k.preventDefault(), d($)) : E === "F4" && (k.preventDefault(), N());
  }, N = () => {
    a([rn()]), s(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => p(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(u) }, "라인삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: N }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, rr.map((k) => {
    var $;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": (($ = t[u]) == null ? void 0 : $.sign) === k.key,
        onClick: () => _(u, { sign: k.key })
      },
      k.label,
      " (",
      k.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: o, onChange: (k) => l(Number(k.target.value)) }, [0, 1, 2, 3, 4].map((k) => /* @__PURE__ */ n.createElement("option", { key: k, value: k }, k))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (k) => i(k.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((k, $) => {
    var E;
    return /* @__PURE__ */ n.createElement("div", { key: $, className: `bical-line${$ === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, $ === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (E = rr.find((h) => h.key === k.sign)) == null ? void 0 : E.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (h) => {
          m.current[$] = h;
        },
        value: k.text,
        inputMode: "decimal",
        "aria-label": `${$ + 1}번째 금액`,
        onFocus: () => s($),
        onChange: (h) => _($, { text: mg(h.target.value) }),
        onKeyDown: (h) => w(h, $)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y))));
}
function _g(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function pg(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let s = a;
      for (; s < e.length && (e[s] >= "0" && e[s] <= "9" || e[s] === "." || e[s] === ","); ) s += 1;
      const o = be(e.slice(a, s));
      if (!o) return null;
      t.push({ t: "num", v: o }), a = s;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class yg {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? dn(t.value, r.value) : fa(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: et(t.value, r.value) };
      else {
        const s = qt(t.value, r.value);
        if (!s) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: s };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Fr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function bg(e) {
  const t = pg(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new yg(t).parse();
}
const sn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], Eg = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function hg(e, t) {
  return e.replace(/오늘/g, Xe(t)).replace(/내일/g, Xe(xn(t, 1))).replace(/어제/g, Xe(xn(t, -1)));
}
function gg(e) {
  const t = [];
  for (const a of e.matchAll(Eg)) {
    const r = aa(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const vg = /부터|까지|에서|일수|며칠|기간|차이|~/;
function kg(e, t) {
  if (t.length < 2 || !vg.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Hr(t[0], t[1], a ? "include-first" : "exclude-first"), s = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${Xe(t[0])} ~ ${Xe(t[1])} 기간(${s})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const wg = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Ng(e, t) {
  if (t.length !== 1) return null;
  const a = wg.exec(e);
  if (!a) return null;
  const r = Number(a[1]), s = a[3] === "전" || a[3] === "이전", o = s ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = xn(l, o) : a[2] === "주" ? c = xn(l, o * 7) : a[2] === "년" ? c = nr(l, o * 12) : c = nr(l, o), {
    ok: !0,
    explain: `${Xe(l)} 에서 ${r}${a[2]} ${s ? "전" : "후"}`,
    value: `${Xe(c)} (${ra(c)})`
  };
}
function $g(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? Gr(a[2]) : null, s = be(a[1]);
  if (!s) return null;
  const o = r ? et(s, r) : s, l = ar(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : ar(xg(e));
  if (!i || i === l) return null;
  const m = Ur(t, o, l, i);
  return m ? {
    ok: !0,
    explain: `${Ke(o, o.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ke(m.value, 2, !0)} ${i}`
  } : null;
}
function xg(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const Dg = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Gr(e) {
  var t;
  return (t = be(Dg[e])) != null ? t : _a(1);
}
const Ag = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Cg = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Sg(e) {
  return e.replace(Ag, (t) => {
    let a = be("0"), r = !1;
    for (const s of t.matchAll(Cg)) {
      const o = be(s[1]);
      o && (r = !0, a = dn(a, s[2] ? et(o, Gr(s[2])) : o));
    }
    return r ? Ke(a, a.s) : t;
  });
}
const Mg = /원화|원|엔|씩|개월|개|명|건/g;
function Tg(e) {
  return Sg(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Mg, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const qg = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Bg(e, t, a) {
  const r = be("1"), s = Ke(et(t, _a(100)), 0);
  if (a === "add")
    return {
      value: dt(et(e, dn(r, t)), 0, "half"),
      explain: `消費税 ${s}% 가산(税抜 기준)`
    };
  const o = qt(et(e, t), dn(r, t));
  return {
    value: o ? dt(o, 0, "down") : e,
    explain: `消費税 ${s}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Lg(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: sn };
  const r = hg(a, t.today), s = gg(r), o = kg(r, s);
  if (o) return o;
  const l = Ng(r, s);
  if (l) return l;
  const c = $g(r, (i = t.rates) != null ? i : []);
  return c || jg(r, t);
}
function jg(e, t) {
  var m, u;
  const a = qg.exec(e), r = a ? e.slice(0, a.index) : e, s = Tg(r);
  if (!s) return { ok: !1, supported: sn };
  const o = bg(s);
  if (!o.ok)
    return { ok: !1, supported: sn };
  if (!a)
    return { ok: !0, explain: s, value: sr(o.value), expr: s };
  const l = (u = (m = Rg(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...sn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Bg(o.value, l, c);
  return {
    ok: !0,
    explain: `${s} · ${i.explain}`,
    value: sr(i.value),
    expr: s
  };
}
function Rg(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = qt(t, _a(100))) != null ? a : null;
}
function sr(e) {
  const t = dt(e, 2, "half"), a = dt(t, 0, "down");
  return fa(t, a).u === BigInt(0) ? Ke(t, 0, !0) : Ke(t, 2, !0);
}
const He = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function or(e, t) {
  const a = He[e].units.find((s) => s.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function Ig(e, t, a, r, s = 4, o = "half") {
  const l = or(e, t), c = or(e, a);
  if (!l || !c) return null;
  const i = qt(et(r, l), c);
  return i ? dt(i, s, o) : null;
}
const Og = [0, 1, 2, 3, 4, 6], Pg = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Xg(e) {
  const { tab: t, onTab: a, seed: r, onClose: s, history: o, onHistory: l } = e, [c, i] = A(() => r == null ? [rn()] : [{ sign: "+", text: Ke(Gg(r), 0, !0) }]), [m, u] = A(0), [f, y] = A(0), [_, p] = A("half"), d = L(null);
  Z(() => {
    const w = (N) => {
      N.key === "Escape" && (N.preventDefault(), s());
    };
    return document.addEventListener("keydown", w), () => document.removeEventListener("keydown", w);
  }, [s]), Z(() => {
    var w, N;
    (N = (w = d.current) == null ? void 0 : w.querySelector("[data-autofocus]")) == null || N.focus();
  }, [t]);
  const b = (w) => {
    const N = [...c.filter((k) => k.text !== ""), { sign: "+", text: w }, rn()];
    i(N), u(N.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: s }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, Pg.map((w) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: w.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": w.key === t,
      onClick: () => a(w.key)
    },
    w.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Wg, { history: o, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    fg,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: f,
      onDigits: y,
      mode: _,
      onMode: p
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Hg, null), t === "unit" && /* @__PURE__ */ n.createElement(Kg, null), t === "fx" && /* @__PURE__ */ n.createElement(Ug, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: s }, "닫기"))));
}
const zg = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Fg = 20;
function Wg({ history: e, onHistory: t, onPush: a }) {
  var p;
  const [r, s] = A(""), [o, l] = A(null), [c, i] = A(!1), [m, u] = A(!1), f = L(!1), y = we(pa, []), _ = (d) => {
    s(d), u(!1);
    const b = Lg(d, { today: y, rates: tn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((w) => w !== d)].slice(0, Fg));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => s(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), _(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, zg.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => _(d) }, d))), o && (o.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, o.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, o.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(o.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(o.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((p = o.supported) != null ? p : sn).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => _(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Hg() {
  const e = we(pa, []), [t, a] = A(Xe(e)), [r, s] = A(Xe(e)), [o, l] = A("exclude-first"), c = aa(t), i = aa(r), m = c && i ? Hr(c, i, o) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: o, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => s(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, Xe(c), "(", ra(c), ") ~ ", Xe(i), "(", ra(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Kg() {
  const [e, t] = A("area"), [a, r] = A(He.area.units[0].key), [s, o] = A(He.area.units[4].key), [l, c] = A(""), [i, m] = A(4), [u, f] = A("half"), y = (d) => {
    t(d), r(He[d].units[0].key), o(He[d].units[1].key), c("");
  }, _ = be(l), p = _ ? Ig(e, a, s, _, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => y(d.target.value) }, Object.keys(He).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, He[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", He[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: s, onChange: (d) => o(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => m(Number(d.target.value)) }, Og.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, lr(e, a), " → ", lr(e, s), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, p ? Ke(p, i, !0) : "—")));
}
function lr(e, t) {
  var a, r;
  return (r = (a = He[e].units.find((s) => s.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Ug() {
  const e = we(pa, []), [t, a] = A(Xe(e)), [r, s] = A("JPY"), [o, l] = A("KRW"), [c, i] = A(""), m = be(c), u = m ? Ur(tn, m, r, o) : null, f = sa(tn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (y) => a(y.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (y) => i(y.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (y) => s(y.target.value) }, tn.map((y) => /* @__PURE__ */ n.createElement("option", { key: y.code, value: y.code }, y.code, " (", y.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: o, onChange: (y) => l(y.target.value) }, tn.map((y) => /* @__PURE__ */ n.createElement("option", { key: y.code, value: y.code }, y.code, " (", y.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? Kr(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ke(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function pa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Gg(e) {
  var t;
  return dt((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const Yr = An(null);
function j0({ children: e }) {
  const [t, a] = A(!1), [r, s] = A("text"), [o, l] = A(null), [c, i] = A([]), [m, u] = A(0), f = we(() => ({
    open: (y) => {
      var _, p;
      s((_ = y == null ? void 0 : y.tab) != null ? _ : "text"), l((p = y == null ? void 0 : y.seed) != null ? p : null), u((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(Yr.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    Xg,
    {
      key: m,
      tab: r,
      onTab: s,
      seed: o,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function R0() {
  var e;
  return (e = Dn(Yr)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class I0 extends cr {
  constructor() {
    super(...arguments), this.rootRef = Jr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new _r(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  t0 as $,
  T0 as A,
  Fv as B,
  Xg as C,
  h0 as D,
  mv as E,
  Ts as F,
  ac as G,
  Ec as H,
  uv as I,
  ln as J,
  Vn as K,
  g0 as L,
  a0 as M,
  r0 as N,
  la as O,
  $0 as P,
  u0 as Q,
  d0 as R,
  f0 as S,
  Mv as T,
  Bn as U,
  Tv as V,
  gf as W,
  Lv as X,
  m0 as Y,
  ls as Z,
  Jg as _,
  Zs as a,
  Vh as a$,
  N0 as a0,
  iv as a1,
  E0 as a2,
  l0 as a3,
  i0 as a4,
  Zp as a5,
  c0 as a6,
  b_ as a7,
  s0 as a8,
  A0 as a9,
  Bt as aA,
  bv as aB,
  Bv as aC,
  dv as aD,
  kr as aE,
  p0 as aF,
  _0 as aG,
  Sr as aH,
  vf as aI,
  Yh as aJ,
  $r as aK,
  Ht as aL,
  I0 as aM,
  _r as aN,
  Hn as aO,
  yr as aP,
  qv as aQ,
  Vu as aR,
  h_ as aS,
  Jn as aT,
  ri as aU,
  si as aV,
  Er as aW,
  Yv as aX,
  z_ as aY,
  il as aZ,
  Iv as a_,
  Wv as aa,
  cv as ab,
  tv as ac,
  lv as ad,
  m_ as ae,
  og as af,
  nv as ag,
  rv as ah,
  av as ai,
  kv as aj,
  gv as ak,
  hv as al,
  D0 as am,
  sv as an,
  n0 as ao,
  Ra as ap,
  x0 as aq,
  vv as ar,
  ov as as,
  fr as at,
  S0 as au,
  M0 as av,
  u_ as aw,
  Cs as ax,
  B0 as ay,
  Hv as az,
  hf as b,
  fl as b0,
  up as b1,
  Js as b2,
  Zg as b3,
  dl as b4,
  pr as b5,
  w0 as b6,
  AE as b7,
  CE as b8,
  $n as b9,
  fv as bA,
  dc as bB,
  pv as bC,
  bc as bD,
  Nr as bE,
  Uv as bF,
  R0 as bG,
  Rv as bH,
  kf as bI,
  Kv as bJ,
  jv as bK,
  Xv as bL,
  Pv as bM,
  o0 as bN,
  Ev as bO,
  Ov as bP,
  L0 as bQ,
  ev as bR,
  q0 as bS,
  yv as bT,
  Kt as bU,
  xy as bV,
  Rt as ba,
  __ as bb,
  Jt as bc,
  Lr as bd,
  p_ as be,
  ja as bf,
  Dv as bg,
  $c as bh,
  hc as bi,
  g_ as bj,
  jr as bk,
  G_ as bl,
  ml as bm,
  br as bn,
  ul as bo,
  eo as bp,
  H_ as bq,
  k0 as br,
  bb as bs,
  Xt as bt,
  Rr as bu,
  xr as bv,
  Cv as bw,
  Xu as bx,
  xv as by,
  _v as bz,
  y0 as c,
  ut as d,
  j0 as e,
  Sv as f,
  vr as g,
  C0 as h,
  v0 as i,
  er as j,
  Jv as k,
  $v as l,
  Nv as m,
  wv as n,
  Vv as o,
  Qv as p,
  e0 as q,
  Da as r,
  Av as s,
  b0 as t,
  Br as u,
  cl as v,
  X_ as w,
  Gv as x,
  Zv as y,
  zv as z
};
